export const QUESTIONS = [
    {
       "id":34967,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Under FINRA rules, if when opening a margin account for a new customer, a registered rep discovers that the customer is employed at another broker dealer, the rep must do which of the following:",
       "choice_a":"Notify FINRA immediately",
       "choice_b":"Notify the customer\u0027s employer in writing",
       "choice_c":"Receive permission from the regulators to open the account",
       "choice_d":"Receive permission from the customer\u0027s employer to open the account",
       "correct_answer":"B",
       "explanation":"Under FINRA rules if a registered rep wants to open a margin account with another broker dealer then the opening firm must contact the rep\u0027s employer in writing advising them of the customer\u0027s intent."
    },
    {
       "id":34968,
       "practice_test_id":5,
       "topic_id":1,
       "question":"Under FINRA rules, if when opening a cash account for a new customer, a registered rep discovers that the customer is employed at another broker dealer, the rep must do which of the following:",
       "choice_a":"Notify FINRA at once",
       "choice_b":"Notify the customer\u0027s employer in writing",
       "choice_c":"Receive permission from the regulators to open the account",
       "choice_d":"Receive permission from the customer\u0027s employer to open the account",
       "correct_answer":"B",
       "explanation":"Under FINRA rules if a registered rep wants to open a cash account with another broker dealer then the opening firm must contact the rep\u0027s employer in writing advising them of the customer\u0027s intent."
    },
    {
       "id":34969,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following is true of the ACAT process when a customer requests to have his securities transferred to another broker dealer?",
       "choice_a":"The carrying firm has 1 business day to validate the positions and an additional 3 business days to complete the transfer",
       "choice_b":"The carrying firm has 3 business days to validate the positions and an additional 3 business days to complete the transfer",
       "choice_c":"The carrying firm has 3 business days to validate the positions and an additional 4 business days to complete the transfer",
       "choice_d":"The carrying firm has 1 business day to validate the positions and an additional 4 business days to complete the transfer",
       "correct_answer":"A",
       "explanation":"The ACAT process allows the carrying firm one business day to either validate or take exception to the customer\u0027s positions. The firm then has an additional 3 business days to complete the transfer of those securities to the new broker dealer."
    },
    {
       "id":34970,
       "practice_test_id":"",
       "topic_id":1,
       "question":"When opening a new margin account at a broker dealer which of the following is not required?",
       "choice_a":"A signed margin agreement",
       "choice_b":"A signed credit agreement",
       "choice_c":"A signed loan consent",
       "choice_d":"A signed hypothecation agreement",
       "correct_answer":"C",
       "explanation":"The margin agreement details the terms of the margin at the broker dealer, the credit agreement states how interest is charged on the margin loan and the hypothecation agreement states that the customer agrees to allow the broker dealer to pledge his securities to the bank as collateral for the loan. All of these must be signed by the customer. The loan consent allows the broker dealer to loan out the customer\u0027s securities for short sales and is not required to open a margin account."
    },
    {
       "id":34971,
       "practice_test_id":1,
       "topic_id":1,
       "question":"Which of the following are true when a customer takes a withdrawal from a 529 college savings plan and uses the money to pay for educational expenses?",
       "choice_a":"The principal will be taxed, but the growth will be federally tax free",
       "choice_b":"The growth will be taxed, but the principal is federally tax free",
       "choice_c":"Both the principal and the growth are federally taxable",
       "choice_d":"Both the interest and the growth are federally tax free",
       "correct_answer":"D",
       "explanation":"When a customer makes a contribution to a 529 plan he does so with after tax dollars, so the tax has already been paid. When he withdraws money to use for educational expenses, the growth is federally tax free and may be state tax free depending on where the customer resides."
    },
    {
       "id":34972,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following regarding 529 plans is a true statement?",
       "choice_a":"Only college savings plans have income limits for the donors",
       "choice_b":"Contribution limits vary from state to state",
       "choice_c":"Contributions are made pre-tax",
       "choice_d":"The account becomes the property of the beneficial owner upon the date of the first withdrawal",
       "correct_answer":"B",
       "explanation":"There are no income limitations on donors to 529 plans though the contribution limits may vary by state. The donor makes contributions to the account with after tax money and will always remain the owner of the account. Ownership of a 529 plan does not revert to the beneficial owner at any point."
    },
    {
       "id":34973,
       "practice_test_id":1,
       "topic_id":1,
       "question":"Variable annuities are considered retirement vehicles and as such are required to follow many of the same rules as traditional IRAs. All of the following apply to both variable annuities and traditional IRAs except:",
       "choice_a":"Withdrawals before the age of 59\u00BD are subject to a 10% penalty",
       "choice_b":"Excess contributions are subject to a 6% penalty",
       "choice_c":"Withdrawals due to death are not subject to a 10% penalty",
       "choice_d":"Withdrawals due to disability are not subject to a 10% penalty",
       "correct_answer":"B",
       "explanation":"Both variable annuities and IRAs are subject to a premature withdrawal penalty that will be negated in the event of death or disability. Only the IRA has contribution limits, the variable annuity does not."
    },
    {
       "id":34974,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following statements are true when a customer opens a new option account at a broker dealer? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The customer must sign the option agreement</li><li>The broker dealer will furnish the customer with a copy of the risk disclosure document </li><li>The account must be approved by the ROSFP prior to the first trade</li><li>The account must be approved by a branch manager prior to the first trade</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"I, II and IV",
       "choice_d":"I, III and IV",
       "correct_answer":"C",
       "explanation":"When opening a new option account a customer will sign the option agreement and be given a copy of the risk disclosure document. A branch manager may initially approve the account as long as it is subsequently approved by the ROSFP within a reasonable period of time."
    },
    {
       "id":34975,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Mr. Jones has just completed a review of your firm\u0027s services and decides to open an account with your firm after meeting with his new representative. Your firm must provide Mr. Jones with a copy of the new account information:",
       "choice_a":"within 30 days",
       "choice_b":"within 45 days",
       "choice_c":"with the first statement",
       "choice_d":"by the completion of the first transaction",
       "correct_answer":"A",
       "explanation":"A firm opening a customer account must provide a copy of the information contained on the new account within 30 days. This is done to ensure that the information on file relating to the customer is accurate."
    },
    {
       "id":36087,
       "practice_test_id":2,
       "topic_id":1,
       "question":"An investor has an open margin account with $48,000 in long market value and a debit balance of $10,000. His minimum equity at this level is:",
       "choice_a":"$24,000",
       "choice_b":"$12,000",
       "choice_c":"$13,333",
       "choice_d":"$10,000",
       "correct_answer":"B",
       "explanation":"To find the minimum equity given a long market value simply multiply the market value by .25."
    },
    {
       "id":36088,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Minimum maintenance is set in a new margin account by:",
       "choice_a":"FRB",
       "choice_b":"Regulation T",
       "choice_c":"NYSE / FINRA",
       "choice_d":"The Brokerage firm",
       "correct_answer":"C",
       "explanation":"The NYSE / FINRA set the minimum maintenance for a new margin account. The minimum equity in a new margin account is $2,000 or 50 percent of the purchase price whichever is greater."
    },
    {
       "id":36089,
       "practice_test_id":2,
       "topic_id":1,
       "question":"Your customer buys $100,000 principal amount of New York Bridge and Tunnel revenue bonds at 54 in their margin account. They must deposit:",
       "choice_a":"$7,000",
       "choice_b":"$27,000",
       "choice_c":"$54,000",
       "choice_d":"$8,100",
       "correct_answer":"D",
       "explanation":"When buying a municipal bond in a margin account investors must deposit the greater of 7% of par value or 15% of the market value. In this case 15% x $54,000 = $8,100."
    },
    {
       "id":36090,
       "practice_test_id":5,
       "topic_id":1,
       "question":"You have the following positions in your margin account: <ol style='margin-left: 25px; list-style-type: disc;'><li>Long 500 ABC at 27 </li><li>Long 1500 XYZ at 42 </li><li>Long 250 MCX at 80 </li></ol>You have a debit balance of $28,200. What is your minimum maintenance?",
       "choice_a":"$24,125",
       "choice_b":"$48,250",
       "choice_c":"$22,500",
       "choice_d":"$37,600",
       "correct_answer":"A",
       "explanation":"To find the minimum maintenance multiply the long market value by .25 <br></br>= 96,500 x .25 = $24,125"
    },
    {
       "id":36091,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The initial minimum for a new margin account is:",
       "choice_a":"50% of the purchase price",
       "choice_b":"The greater of $2,000 or 50% of the purchase price",
       "choice_c":"Set by the FRB",
       "choice_d":"Set by the MSRB",
       "correct_answer":"B",
       "explanation":"The initial minimum for a new margin account is the greater of $2,000 or 50% of the purchase price."
    },
    {
       "id":36092,
       "practice_test_id":3,
       "topic_id":1,
       "question":"You have an open margin account with a long market value of $125,000 and a debit balance of $54,000. How low can the value of the securities drop before you get a margin call?",
       "choice_a":"$100,000",
       "choice_b":"$72,000",
       "choice_c":"$93,750",
       "choice_d":"$67,500",
       "correct_answer":"B",
       "explanation":"The market value could fall to $72,000. This is found by dividing the debit balance by .75 or 54,000/.75 =72,000"
    },
    {
       "id":36093,
       "practice_test_id":"",
       "topic_id":1,
       "question":"An investor in a new margin account purchases 200 XYZ at 20 and deposits $2,000. XYZ falls to $18 and the investor\u0027s equity falls to $1,600. Which of the following is true?",
       "choice_a":"The investor must deposit $400 to maintain the $2,000 minimum equity requirement.",
       "choice_b":"The position could be liquidated if the investor doesn\u0027t meet their current margin call.",
       "choice_c":"The investor will receive a margin call for $200",
       "choice_d":"No action by the investor is required at this time.",
       "correct_answer":"D",
       "explanation":"The $2,000 minimum equity requirement is only for the initial deposit."
    },
    {
       "id":36095,
       "practice_test_id":3,
       "topic_id":1,
       "question":"A margin customer must sign which of the following to pledge their securities as collateral for the loan?",
       "choice_a":"Loan consent",
       "choice_b":"Re hypothecation agreement",
       "choice_c":"Hypothecation agreement",
       "choice_d":"Collateral agreement",
       "correct_answer":"C",
       "explanation":"The customer must sign the hypothecation agreement."
    },
    {
       "id":36097,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Your client buys $15,000 in securities in a new margin account and deposits $7,500. The account is later charged $200 in interest and credited $275 in dividends. What is the new debit balance?",
       "choice_a":"$7,425.00",
       "choice_b":"$7,700.00",
       "choice_c":"$7,975.00",
       "choice_d":"$8,125",
       "correct_answer":"A",
       "explanation":"The customer was charged $200 in interest and received $275 in dividends; therefore, the customer\u0027s debit balance would have decreased by $75 to $7425."
    },
    {
       "id":36098,
       "practice_test_id":"",
       "topic_id":1,
       "question":"An investor sells 100 shares of T short at 35 with no other positions in the account. The initial minimum requirement, assuming Regulation T is 50%, is:",
       "choice_a":"$1,750",
       "choice_b":"$2,000",
       "choice_c":"$3,500",
       "choice_d":"$500",
       "correct_answer":"B",
       "explanation":"The customer has a minimum initial equity of $2,000"
    },
    {
       "id":36099,
       "practice_test_id":5,
       "topic_id":1,
       "question":"A customer has a margin account with an $80,000 market value, a $55,000 debit balance and a $5,000 SMA. Reg. T is 50%. How much money can be withdrawn?",
       "choice_a":"Nothing",
       "choice_b":"$5,000",
       "choice_c":"$2,500",
       "choice_d":"$1,500",
       "correct_answer":"B",
       "explanation":"The customer may always withdraw their SMA so long as doing so would not cause the account to fall below the minimum equity requirement. The minimum equity for the account is $20,000"
    },
    {
       "id":36101,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A client has the following margin account. Regulation T is 50% and the house maintenance requirement is 30%. <img src='/question_assets/sie/1.png'></img> The client could withdraw:",
       "choice_a":"$500",
       "choice_b":"$0",
       "choice_c":"$3,750",
       "choice_d":"$2,750",
       "correct_answer":"B",
       "explanation":"The client could not withdraw anything because they are below the house minimum by $500."
    },
    {
       "id":36103,
       "practice_test_id":4,
       "topic_id":1,
       "question":"A customer in an initial transaction sells short $1,500 of stock. Regulation T is at 50%. His maintenance requirement would be:",
       "choice_a":"$750",
       "choice_b":"$1,500",
       "choice_c":"$2,000",
       "choice_d":"$2,250",
       "correct_answer":"C",
       "explanation":"The minimum initial equity in a margin account is $2,000"
    },
    {
       "id":36104,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A customer has a margin account with a market value of $80,000, a debit of $45,000 and an SMA of $10,000. The equity in the account is:",
       "choice_a":"$25,000",
       "choice_b":"$35,000",
       "choice_c":"$45,000",
       "choice_d":"$15,000",
       "correct_answer":"B",
       "explanation":"The customer\u0027s equity is $35,000. Found by using the following formula: Long market value - Debit"
    },
    {
       "id":36105,
       "practice_test_id":5,
       "topic_id":1,
       "question":"The customer makes a new purchase of 100 shares of Abra Corporation at $90 per share on an IPO. Abra stock trades up to $110 on the first day. If the FRB margin requirement is 50%, the customer must deposit:",
       "choice_a":"$4,500",
       "choice_b":"$9,000",
       "choice_c":"$5,500",
       "choice_d":"$4,000",
       "correct_answer":"B",
       "explanation":"The customer must deposit the full purchase price. IPOs may not be purchased on margin."
    },
    {
       "id":36106,
       "practice_test_id":4,
       "topic_id":1,
       "question":"When securities are sold in a restricted margin account: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The debit balance is decreased. </li><li>The SMA account is increased.</li><li>The equity is increased.</li><li>The market value of the account is decreased.</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II",
       "choice_c":"II and III",
       "choice_d":"I, II and IV",
       "correct_answer":"D",
       "explanation":"When stock is sold in a restricted margin account all of the answers listed occur except the equity does not change. When an investor sells stock in a margin account 50 percent of the proceeds must be credited to SMA."
    },
    {
       "id":36108,
       "practice_test_id":"",
       "topic_id":1,
       "question":"An investor has a margin account as follows. Regulation T is 50%.  <img src='/question_assets/sie/2.png'></img>He sells 20 shares of PDQ for $2,000. The SMA can be credited with:",
       "choice_a":"$0",
       "choice_b":"$1,000",
       "choice_c":"$500",
       "choice_d":"$2,000",
       "correct_answer":"B",
       "explanation":"The investor\u0027s account is restricted however 50% of all sale proceeds must be credited to SMA."
    },
    {
       "id":36110,
       "practice_test_id":2,
       "topic_id":1,
       "question":"A customer has a margin account with a market value of $22,000 and a debit balance of $3,000. The FRB margin requirement is 50%.To what level can the market value decline to be on the NYSE minimum maintenance requirement?",
       "choice_a":"$4,000",
       "choice_b":"$5,000",
       "choice_c":"$6,000",
       "choice_d":"$10,000",
       "correct_answer":"A",
       "explanation":"To determine how low an account can fall divide the debit balance by .75 or in this case 3000/.75 = 4,000"
    },
    {
       "id":36111,
       "practice_test_id":3,
       "topic_id":1,
       "question":"A customer has a margin account with a market value of $20,000 and a debit balance of $12,000. The FRB margin requirement is 50%. On Monday, March 2nd, the customer buys $10,000 worth of new stock and sells $8,000 worth of stock. How much money will the customer have to deposit as a result of the two trades?",
       "choice_a":"$2,000",
       "choice_b":"$1,000",
       "choice_c":"$4,000",
       "choice_d":"$2,500",
       "correct_answer":"B",
       "explanation":"The customer bought $10,000 worth of stock and must deposit $5,000. The customer also sold $8,000 worth of stock $4,000 of which must be credited to SMA so the customer must deposit $1,000"
    },
    {
       "id":36112,
       "practice_test_id":4,
       "topic_id":1,
       "question":"Which of the following must be bought for cash only?",
       "choice_a":"US Treasury Bonds",
       "choice_b":"Closed end investment company shares",
       "choice_c":"New issues",
       "choice_d":"Municipal bonds",
       "correct_answer":"C",
       "explanation":"New issues may not be purchased on margin and must be paid for fully."
    },
    {
       "id":36113,
       "practice_test_id":5,
       "topic_id":1,
       "question":"A customer has a margin account with a market value of $22,000 and a debit balance of $3,000. The FRB margin requirement is 50%. The equity in the account is:",
       "choice_a":"$19,000.00",
       "choice_b":"$10,000.00",
       "choice_c":"$15,000.00",
       "choice_d":"$20,000.00",
       "correct_answer":"A",
       "explanation":"To find the customer\u0027s equity subtract the debit balance from the market value"
    },
    {
       "id":36115,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Under Regulation T, credit may be extended on all of the following long positions, except:",
       "choice_a":"Listed stocks.",
       "choice_b":"Listed bonds.",
       "choice_c":"Listed options.",
       "choice_d":"Convertible Bonds selling below par",
       "correct_answer":"C",
       "explanation":"Listed options have no loan value and must be paid for fully."
    },
    {
       "id":36116,
       "practice_test_id":2,
       "topic_id":1,
       "question":"A sale of securities in a long margin account would have all of the following results, except:",
       "choice_a":"The market value of the account will be reduced.",
       "choice_b":"The equity of the account will be increased.",
       "choice_c":"50% of the proceeds of the sale can be added to the SMA account if the account is restricted.",
       "choice_d":"The proceeds of the sale will be credited to the account and the debit balance will be reduced.",
       "correct_answer":"B",
       "explanation":"A sale of securities in a margin account will not cause the equity in the account to increase. All of the other choices listed are true."
    },
    {
       "id":36117,
       "practice_test_id":"",
       "topic_id":1,
       "question":"If a customer wanted to purchase warrants listed on the AMEX trading at $7.40 the  customer would have to deposit what percentage of the warrants value?",
       "choice_a":"25%",
       "choice_b":"30%",
       "choice_c":"50%",
       "choice_d":"100%",
       "correct_answer":"C",
       "explanation":"Listed warrants can be purchased on margin."
    },
    {
       "id":36118,
       "practice_test_id":2,
       "topic_id":1,
       "question":"In a new margin account an investor purchases 100 shares of RFG at $45 per share. The investor\u0027s minimum required deposit when Reg T is 50%, is:",
       "choice_a":"$2,250",
       "choice_b":"$2,000",
       "choice_c":"$1,250",
       "choice_d":"$1,750",
       "correct_answer":"A",
       "explanation":"The investor must deposit $2,250 which is 50 percent of the purchase price since it is greater than the NYSE / FINRA minimum initial requirement of $2,000."
    },
    {
       "id":36119,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A customer meets with his investment representative and decides to open a margin account in addition to the cash investment account he maintains at the firm. In his new margin account he buys 1000 XVD at $44, 300 GTT at $100 and 1000 shares of Grow Fast open end mutual fund at $20. How much must the customer deposit in the account?",
       "choice_a":"$57,000",
       "choice_b":"$47,000",
       "choice_c":"$77,000",
       "choice_d":"$37,000",
       "correct_answer":"A",
       "explanation":"The customer must make the deposit as follows: $22,000 for the 1000 shares of XVD at $44, $15,000 for the 300 GTT at $100 and $20,000 for the 1000 shares of the Grow Fast mutual fund at $20. For a total of $57,000. The customer must pay for the open end mutual fund shares fully. An open end mutual fund is considered to be a new issue and cannot be purchased on margin. However after holding the shares fully paid for for 30 days the shares may be used as collateral to purchase other securities on margin."
    },
    {
       "id":36120,
       "practice_test_id":"",
       "topic_id":1,
       "question":"An investor who wishes to open a new margin account and sell 1,000 shares of stock short at $2.10, would have a margin requirement when Reg T is 50 percent equal to:",
       "choice_a":"$1,050",
       "choice_b":"$2,000",
       "choice_c":"$2,500",
       "choice_d":"$2,100",
       "correct_answer":"C",
       "explanation":"An investor selling stock short with a market value of less than $5 per share would be subject to the greater of 100 percent of the market value or $2,500. Since the investor sold $2,100 worth of stock short the margin requirement would be $2,500."
    },
    {
       "id":34914,
       "practice_test_id":3,
       "topic_id":2,
       "question":"Commercial paper with 270 days to maturity trading in the money market has its interest rate calculated based on:",
       "choice_a":"270 days",
       "choice_b":"360 days",
       "choice_c":"Nine 30 day months",
       "choice_d":"Three 90 day quarters",
       "correct_answer":"B",
       "explanation":"Commercial paper with 270 days to maturity trading in the money market has its interest rate calculated based on a 360 day year."
    },
    {
       "id":34915,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Bond interest starts to accrue on:",
       "choice_a":"The accrual date",
       "choice_b":"The issue date",
       "choice_c":"The dated date",
       "choice_d":"The payment date",
       "correct_answer":"C",
       "explanation":"Bond interest starts to accrue on a new issue of bonds on the dated date."
    },
    {
       "id":34916,
       "practice_test_id":3,
       "topic_id":2,
       "question":"An investor who is concerned that interest rates will be falling in the near future would be unlikely to buy which of the following?",
       "choice_a":"CMOs",
       "choice_b":"GNMAs",
       "choice_c":"zero coupon bonds",
       "choice_d":"all of the the choices listed",
       "correct_answer":"D",
       "explanation":"Mortgage backed securities like CMOs and GNMAs have refinancing risk, i.e. when interest rates fall homeowners refinance and the holders of these securities will be paid back sooner than anticipated. And zero coupon bonds pay no interest, but are sold at a deep discount making them extremely sensitive to changes in interest rates. If an investor is concerned about falling interest rates none of these would be appropriate investments."
    },
    {
       "id":34917,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following are true of both CMOs and GNMAs? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>They are both mortgage backed securities </li><li>They are both issued by a US government agency </li><li>They are both subject to interest rate risk </li><li>They are both pass through certificates</li></ol>",
       "choice_a":"I only",
       "choice_b":"I,II, IV",
       "choice_c":"II, III, IV",
       "choice_d":"I, III, IV",
       "correct_answer":"D",
       "explanation":"Both CMOs and GNMAs are mortgage backed securities that are classified as pass through certificates, as interest and principal pass through to the investor. As such they are both subject to interest rate risk i.e. if interest rates fall homeowners are more likely to refinance their mortgages resulting in the CMO or GNMA investor being paid off sooner than anticipated. Only GMNAs are issued by a US government agency. CMO\u0027s are issued by investment banks."
    },
    {
       "id":34918,
       "practice_test_id":"",
       "topic_id":2,
       "question":"All of the following are available to investors in a CMO except:",
       "choice_a":"Tendered Amortization Class",
       "choice_b":"Planned Amortization Class",
       "choice_c":"Principal only",
       "choice_d":"Targeted amortization Class",
       "correct_answer":"A",
       "explanation":"When purchasing a CMO an investor may choose between a planned or targeted amortization class and a principal only or interest only option. There are no tendered amortization classes."
    },
    {
       "id":34919,
       "practice_test_id":"",
       "topic_id":2,
       "question":"All of the following are risks to a CMO investor: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Interest rate risk </li><li>Refinancing risk </li><li>Liquidity risk </li><li>Purchasing power risk</li></ol>",
       "choice_a":"I, II",
       "choice_b":"I, IV",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"When purchasing a CMO it is important that the investor understands that fluctuations in interest rates may result in homeowners refinancing their mortgages and the investors having their principal returned early. There are also the risks that when the principal is paid, its value will have eroded due to inflation and that the investor won\u0027t be able to sell the position quickly."
    },
    {
       "id":34920,
       "practice_test_id":5,
       "topic_id":2,
       "question":"CMOs are issued by all of the following except:",
       "choice_a":"Investment banks",
       "choice_b":"FNMA",
       "choice_c":"US government agencies",
       "choice_d":"FHLMC",
       "correct_answer":"C",
       "explanation":"CMOs are issued by investment banks, FNMA and FHLMC. Unlike GNMAs they are not issued by government agencies."
    },
    {
       "id":34921,
       "practice_test_id":4,
       "topic_id":2,
       "question":"A bond issue that is said to trade \u0022flat\u0022 indicates to the investor:",
       "choice_a":"the bond is trading at par value",
       "choice_b":"the bond is in default",
       "choice_c":"the bond price is very stable",
       "choice_d":"the bond does not pay interest",
       "correct_answer":"D",
       "explanation":"A bond that is said to trade flat does not trade with accrued interest. Zero coupon bonds, and other issues that are issued at a discount like T\u0027 bills, commercial paper and banker\u0027s acceptances all trade flat and do not make regular interest payments. These securities are issued at a discount and appreciate up to par."
    },
    {
       "id":34922,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An investor is considering purchasing a 7 percent corporate bond. The bond is trading in the marketplace at 100 and is callable in 10 years at par. The bond has 16 years left until maturity. Which of the following is true?",
       "choice_a":"The YTC is lower than the YTM",
       "choice_b":"The YTC is greater than the YTM",
       "choice_c":"The YTC equals the YTM",
       "choice_d":"The investor would be better off purchasing a non callable issue",
       "correct_answer":"C",
       "explanation":"The bond is trading at 100 or par in the market and callable at par in 10 years. Since the price the investor would pay for the bond is equal to par and the bond is callable at par, the YTC will be equal to the YTM. When an investor buys a bond at par the nominal yield, the current yield and the yield to maturity will all be equal. If the bond is callable at par the YTC will also be the same as the nominal yield."
    },
    {
       "id":34923,
       "practice_test_id":"",
       "topic_id":2,
       "question":"As it relates to the issuance of Eurodollar bonds issued by a US corporation, which of the following is / are not true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The corporation is subject to currency risk </li><li>The bonds must be registered with the SEC prior to sale </li><li>The investors will receive payments in their domestic currency </li><li> The bonds may only be sold to qualified institutional buyers in the US</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"Eurodollar bonds are bonds issued by a US corporation denominated in US dollars and sold to investors who reside outside of the US. Because the bonds are issued in US Dollars the corporation does not have any currency risk. The bonds are issued outside of the US which is beyond the jurisdiction of the SEC. Therefore the bonds do not need to register with the SEC. Eurodollar bonds are not sold to any US investors and investors receive payments in US dollars."
    },
    {
       "id":34924,
       "practice_test_id":4,
       "topic_id":2,
       "question":"As it relates to a variable interest rate municipal security, which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The bond has a fixed coupon rate </li><li>The bond has a stable principal value  </li><li>The bond has a coupon rate that varies  </li><li>The bond has a principal amount that varies </li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"III and IV",
       "correct_answer":"C",
       "explanation":"A variable interest rate municipal security has a coupon rate that is regularly adjusted to the prevailing interest rates in the market. As such the principal value of the bond tends to be very stable and always close to par. If rates increase the interest rate  paid on the bond is increased., if rates fall the interest rate paid on the bond is reduced."
    },
    {
       "id":34925,
       "practice_test_id":"",
       "topic_id":2,
       "question":"As structured products equity linked notes or ELNs may not be suitable for all investors. Which of the following is a typical characteristic of ELNs that investors should be made aware of:",
       "choice_a":"ELNs convert to cash at maturity",
       "choice_b":"ELNs convert to the underlying equity security",
       "choice_c":"ELNs have a set rate of interest",
       "choice_d":"ELNs make payments to investors annually and at maturity",
       "correct_answer":"A",
       "explanation":"Of the choices listed only the fact that ELNs convert to cash at maturity is correct. ELNs do not make interest payments. At maturity the investor receives the cash value of the note which will include the principal amount plus a percentage of the actual return of the underlying security."
    },
    {
       "id":36265,
       "practice_test_id":"",
       "topic_id":2,
       "question":"When considering investing in a municipal bond, the opinion stating it\u0027s a binding obligation of the issuer is issued by the:",
       "choice_a":"Governor",
       "choice_b":"MSRB",
       "choice_c":"FINRA",
       "choice_d":"Bond counsel",
       "correct_answer":"D",
       "explanation":"The bond counsel issues a legal opinion about the municipal bond and states that it is a legally binding obligation of the issuer and that its interest should be free from federal income taxes."
    },
    {
       "id":36251,
       "practice_test_id":5,
       "topic_id":2,
       "question":"All of the following are true about municipal bonds except:",
       "choice_a":"If an investor buys a municipal bond issued within the state where they reside, the interest is free from federal, state, and local taxes",
       "choice_b":"If an investor buys a municipal bond and sells it at a profit, the capital gain is taxed as ordinary income",
       "choice_c":"If an investor buys a municipal bond and sells it at a profit, the capital gain is not taxed federally, but it is taxed by the state and local governments",
       "choice_d":"If an investor buys a municipal bond issued by a territory such as Guam or the Virgin Islands, the interest is tax-free on all levels.",
       "correct_answer":"C",
       "explanation":"If an investor realizes a profit on a sale of a municipal bond, the capital gain is taxed as ordinary income."
    },
    {
       "id":36246,
       "practice_test_id":"",
       "topic_id":2,
       "question":"The portion of a county\u0027s debt that a city is responsible for is known as:",
       "choice_a":"Double barreled debt",
       "choice_b":"Prorated debt",
       "choice_c":"Overlapping debt",
       "choice_d":"Shared debt",
       "correct_answer":"C",
       "explanation":"The portion of a county\u0027s debt that a city is responsible for is known as overlapping debt."
    },
    {
       "id":36244,
       "practice_test_id":1,
       "topic_id":2,
       "question":"A customer in the 30% tax bracket is considering investing in a municipal bond with a current yield of 6%. If they were to consider a corporate bond of equal quality the corporate bond must yield at least:",
       "choice_a":"8.60%",
       "choice_b":"7.80%",
       "choice_c":"9%",
       "choice_d":"4.20%",
       "correct_answer":"A",
       "explanation":"To find the tax equivalent yield use the following: municipal rate / (100% -tax bracket) = 6% / .7= 8.57%"
    },
    {
       "id":36239,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A customer has been holding $50,000 worth of municipal bonds in her portfolio. The bonds pay interest at 5.5% per year. She is in the 30% bracket and wants to know what her federal tax liability will be. You should tell her:",
       "choice_a":"$725",
       "choice_b":"$2,750",
       "choice_c":"$2,025",
       "choice_d":"$0",
       "correct_answer":"D",
       "explanation":"A municipal bond\u0027s interest is free from federal income taxes."
    },
    {
       "id":36234,
       "practice_test_id":1,
       "topic_id":2,
       "question":"You have purchased municipal bonds whose proceeds have been used to build a new school in your town. The bonds are trading ex legal. What is the most likely reason for this?",
       "choice_a":"The legal opinion was lost",
       "choice_b":"The bonds are illegal",
       "choice_c":"No legal opinion was obtained",
       "choice_d":"The legal opinion is in doubt",
       "correct_answer":"C",
       "explanation":"Many small municipal issues never get a legal opinion because the issue is too small to justify the cost."
    },
    {
       "id":36294,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A bond analyst checking a municipal bond will examine: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The past performance of the payment of interest. </li><li>The per-capita income of the citizens. </li><li>The population growth of the area. </li><li>The industrial development of the area.</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"II and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"An analyst looking at a municipal bond would look at all of the items listed."
    },
    {
       "id":36295,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An investor in the 28% tax bracket can buy a municipal bond yielding 12.64%. What yield would the investor require in a corporate bond to realize the same after-tax return?",
       "choice_a":"17.50%.",
       "choice_b":"17.56%.",
       "choice_c":"18.00%.",
       "choice_d":"18.56%.",
       "correct_answer":"B",
       "explanation":"The investor would need to invest in a corporate bond yielding at least 17.56. Found by dividing the municipal rate by the complement of the investor\u0027s tax rate. In this case 12.64 / .72 = 17.55"
    },
    {
       "id":36309,
       "practice_test_id":2,
       "topic_id":2,
       "question":"The dated date of a new municipal bond is:",
       "choice_a":"The date from which interest accrues.",
       "choice_b":"The date on which a bond is sold.",
       "choice_c":"The date on which the bond can be called.",
       "choice_d":"The date when the bond matures.",
       "correct_answer":"A",
       "explanation":"The dated date is the date when interest starts to accrue."
    },
    {
       "id":36306,
       "practice_test_id":"",
       "topic_id":2,
       "question":"All the following concerning an investor who buys a municipal bond at 94, maturing in 3 years, are correct, except:",
       "choice_a":"The investor must accrete the discount each year.",
       "choice_b":"The coupon interest is free from Federal income tax.",
       "choice_c":"The investor will have a capital gain at maturity.",
       "choice_d":"If the amount of the discount is an \u0027original issue\u0027 discount, it will have no tax liability at maturity.",
       "correct_answer":"C",
       "explanation":"An investor who purchases a municipal bond at discount must step up or accrete the discount each year. This will not result in a capital gain at maturity."
    },
    {
       "id":36303,
       "practice_test_id":2,
       "topic_id":2,
       "question":"All of the following are true about municipal bond taxation, except:",
       "choice_a":"Interest is exempt from Federal taxes.",
       "choice_b":"Interest is exempt from State taxes for residents of the state of issuance.",
       "choice_c":"Capital gains are subject to Federal taxes.",
       "choice_d":"Capital gains are subject to State taxes.",
       "correct_answer":"D",
       "explanation":"States do not tax gains on municipal securities."
    },
    {
       "id":36352,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following is a double-barreled bond?",
       "choice_a":"Section 8 bond",
       "choice_b":"NHA",
       "choice_c":"PHA",
       "choice_d":"Hospital bond backed by revenues and full faith and credit",
       "correct_answer":"D",
       "explanation":"If we point revenues and full faith and credit at the problem of paying debt service, it\u0027s like we\u0027re aiming a double-barreled shotgun at the problem. The issuer has to be the one pointing both barrels, though, which is why the other three choices are NOT double-barreled. They\u0027re issued by a city and guaranteed by a different government, the federal government."
    },
    {
       "id":36465,
       "practice_test_id":"",
       "topic_id":2,
       "question":"If your customer is concerned about tax preference items for AMT, you would least likely recommend",
       "choice_a":"school bonds",
       "choice_b":"GO bonds",
       "choice_c":"private purpose bonds",
       "choice_d":"public purpose bonds",
       "correct_answer":"C",
       "explanation":"Private purpose bonds don\u0027t get the favorable tax treatment from the IRS that public purpose/essential/GO bonds receive."
    },
    {
       "id":36491,
       "practice_test_id":3,
       "topic_id":2,
       "question":"A customer in the 30% tax bracket is considering investing in a municipal bond with a current yield of 4%. If they were to consider a corporate bond of equal quality the corporate bond must yield at least:",
       "choice_a":"5.70%",
       "choice_b":"7.80%",
       "choice_c":"9%",
       "choice_d":"4.20%",
       "correct_answer":"A",
       "explanation":"To find the tax equivalent yield use the following: municipal rate / (100% -tax bracket) = 4% / .7= 5.71%"
    },
    {
       "id":36502,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A municipality might issue an industrial development bond for which of the following?",
       "choice_a":"To benefit a private corporation that is building a corporate office",
       "choice_b":"To build a new prison",
       "choice_c":"To improve an airport which will pay back the investors from its revenues collected",
       "choice_d":"To lower the sales tax for that state or municipality",
       "correct_answer":"A",
       "explanation":"An industrial development bond is a municipal bond issued for the benefit of a corporation. The corporation will then lease the improved facility or equipment from the municipality to support the repayment of the bond."
    },
    {
       "id":36984,
       "practice_test_id":3,
       "topic_id":2,
       "question":"An investor who is risk averse is reviewing an opportunity to purchase a corporate bond issued by ABC Corporation. Which of the following would provide the investor with the greatest understanding of the bond\u0027s risk?",
       "choice_a":"Term",
       "choice_b":"Collateral",
       "choice_c":"Yield",
       "choice_d":"Price",
       "correct_answer":"C",
       "explanation":"The bond\u0027s yield is the best measure of risk. The higher the yield, the greater the risk associated with the bond. Bonds with a significant amount of risk of default or credit risk will have the highest yield to compensate investors for taking on that risk."
    },
    {
       "id":39453,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A corporate debt instrument secured by property that consists of stocks or bonds of other corporations is known as:",
       "choice_a":"a collateral trust certificate.",
       "choice_b":"a debenture.",
       "choice_c":"an equipment trust certificate.",
       "choice_d":"a unit investment trust.",
       "correct_answer":"A",
       "explanation":"Collateral trust certificates issued by corporations are backed by the securities (stocks or bonds) of other companies the corporation owns."
    },
    {
       "id":39454,
       "practice_test_id":5,
       "topic_id":2,
       "question":"An investor purchases a corporate bond at 96-5/8. Months later she sold the bond at 99-3/4. What is the profit or loss realized after the sale?",
       "choice_a":"$31.25 profit",
       "choice_b":"$31.25 loss",
       "choice_c":"$3.125 profit",
       "choice_d":"$3.125 loss",
       "correct_answer":"A",
       "explanation":"The sale price was 3-1/8 points more than the purchase price (99-3/4 &ndash; 96-5/8 = 3-1/8) making the transaction profitable. Always remember that one bond point equals $10. Therefore 3 points is $30 and 1/8 of a point is $1.25. $30 + $1.25 equals a profit of $31.25."
    },
    {
       "id":39456,
       "practice_test_id":5,
       "topic_id":2,
       "question":"A bond has been issued with a coupon of 3.15%. Now, two years later its yield to maturity is 3.65%. This information tells you that the bond is currently trading:",
       "choice_a":"at a discount.",
       "choice_b":"at par.",
       "choice_c":"at a premium.",
       "choice_d":"flat.",
       "correct_answer":"A",
       "explanation":"Remember the inverse relationship between price and yield. If the YTM is now greater than the nominal yield, or coupon yield (yield up), then the price of the bond will have gone down; trading at a discount."
    },
    {
       "id":39457,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following statements regarding exchange-traded notes (ETNs) is accurate?",
       "choice_a":"Backed by the full faith and credit of the issuer, ETNs are debt securities.",
       "choice_b":"Backed by the exchange they trade on., ETNs are debt securities.",
       "choice_c":"Backed by the full faith and credit of the issuer, ETNs are equity securities.",
       "choice_d":"Backed by the exchange they trade on., ETNs are equity securities.",
       "correct_answer":"A",
       "explanation":"ETNs are unsecured debt securities (notes) issued by banks or financial institutions. Therefore, they are backed only by the good faith and credit of the issuer."
    },
    {
       "id":39465,
       "practice_test_id":4,
       "topic_id":2,
       "question":"One of the following does not align with the definition of a fixed-income security. Which is it?",
       "choice_a":"A common stock that has historically paid dividends.",
       "choice_b":"A preferred stock that has historically paid dividends.",
       "choice_c":"A corporate debt instrument that has historically made on-time interest payments.",
       "choice_d":"A municipal bond that has historically made on-time interest payments",
       "correct_answer":"A",
       "explanation":"Securities that have an agreed fixed rate of return such as bonds, notes, money market instruments, and other debt instruments are defined as fixed-income securities. Because preferred stock has a fixed dividend rate, it too is included in the definition of a fixed-income security. Common stock however, which may or may not pay a dividend and therefore has no fixed rate of return, is not deemed to be a fixed-income security."
    },
    {
       "id":39466,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following would best describe the relationship between prices and yields for outstanding corporate bonds when interest rates are changing?",
       "choice_a":"The relationship is a mutual one.",
       "choice_b":"The relationship has no discernable pattern.",
       "choice_c":"The relationship is dependent upon the issuer\u0027s total outstanding debt.",
       "choice_d":"The relationship is an inverse one.",
       "correct_answer":"D",
       "explanation":"The relationship between prices and yields for outstanding corporate bonds is an inverse one. As yields rise, the prices of outstanding debt instruments will fall. As yields fall, the prices of outstanding debt instruments will rise."
    },
    {
       "id":39470,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An investor makes a purchase of corporate bonds at par having a 3.25 coupon yield. His purchase is in the amount of  $25,000 face value. If he holds them until maturity in 2035, what will he receive when the bonds mature?",
       "choice_a":"The investor will receive $25,000 plus the final semiannual interest payment.",
       "choice_b":"The investor will receive $25,000, plus the final year\u0027s interest payments.",
       "choice_c":"The investor will receive $25,000 plus 3.25 interest accrued from the time of purchase.",
       "choice_d":"The investor will receive 3.25 interest accrued from the time of purchase.",
       "correct_answer":"A",
       "explanation":"At maturity, the investor will receive the face value of the bonds purchased ($25,000) plus the last interest payment. Because corporate bonds pay interest semiannually, the last payment received at the time of maturity is the final semiannual payment."
    },
    {
       "id":39471,
       "practice_test_id":4,
       "topic_id":2,
       "question":"An investor has purchased a bond priced at a premium. Therefore, we know that the yield to maturity is:",
       "choice_a":"lower than the nominal yield.",
       "choice_b":"the same as the current yield",
       "choice_c":"the same as the nominal yield",
       "choice_d":"higher than the current yield",
       "correct_answer":"A",
       "explanation":"When a bond is purchased at a premium, the amount paid is greater than the face amount of the bond. When price is up, yield is down (lower). The premium that has been paid effectively reduces both the current yield and the yield to maturity."
    },
    {
       "id":39472,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following is not included in the definition of a money market instrument?",
       "choice_a":"Warrants expiring within 90 days.",
       "choice_b":"Negotiable CDs issued by banks.",
       "choice_c":"Banker\u0027s acceptances issued by banks.",
       "choice_d":"Treasury bonds maturing within 365 days.",
       "correct_answer":"A",
       "explanation":"All money market instruments are liquid debt securities maturing within a year. Warrants are not money market instruments because they are equity, not debt securities."
    },
    {
       "id":39483,
       "practice_test_id":2,
       "topic_id":2,
       "question":"A municipality issued $200 million in general obligation (GO) debt 4 years ago. The bonds have a 30-year maturity and a 5% coupon. If looking at the bonds today you saw that they were trading at a slight premium, this would mean that the:",
       "choice_a":"yield to maturity is now equal to the current yield.",
       "choice_b":"yield to maturity is now higher than the current yield.",
       "choice_c":"current yield is currently higher than the nominal (coupon) yield.",
       "choice_d":"nominal or coupon yield is currently higher than the yield to maturity.",
       "correct_answer":"D",
       "explanation":"Remember that there is an inverse relationship between bond prices and yields. If the bond is now selling at a slight premium (price higher), the yield to maturity is lower. The yields from highest to lowest for a bond trading at a premium would be as follows; nominal or coupon yield, current yield, and yield to maturity."
    },
    {
       "id":39486,
       "practice_test_id":3,
       "topic_id":2,
       "question":"If interest rates have been rising, this tells you that the prices of bonds already trading in the secondary market have:",
       "choice_a":"remained unchanged.",
       "choice_b":"fallen.",
       "choice_c":"remained unchanged.",
       "choice_d":"no determinable movement based on the change in interest rates.",
       "correct_answer":"B",
       "explanation":"Always remember that there is an inverse relationship between bond prices and interest rates, When interest rates are rising, the prices of bonds trading in the open markets are falling."
    },
    {
       "id":35682,
       "practice_test_id":4,
       "topic_id":3,
       "question":"Why might it be better for an investor to get a stock dividend rather than a cash dividend?",
       "choice_a":"Stock dividends are generally tax free until you sell the stock",
       "choice_b":"Cash dividends generally can\u0027t be reinvested",
       "choice_c":"Stock dividends generally carry twice the voting rights of ordinary shares",
       "choice_d":"Stock dividends are generally paid in preferred shares rather than ordinary shares",
       "correct_answer":"A",
       "explanation":"Stock dividends are generally not taxable when they are received by the investor."
    },
    {
       "id":35683,
       "practice_test_id":5,
       "topic_id":3,
       "question":"The rate at which the Federal Reserve lends money to other banks is called the:",
       "choice_a":"Federal funds rate",
       "choice_b":"Discount rate",
       "choice_c":"LIBOR",
       "choice_d":"Bank loan rate",
       "correct_answer":"B",
       "explanation":"The Federal Reserve lends money to banks at the discount rate."
    },
    {
       "id":35685,
       "practice_test_id":"",
       "topic_id":3,
       "question":"If investors have priced in the expectation for generally increasing prices in the marketplace, the yield curve most likely to reflect that expectation would be:",
       "choice_a":"Flat",
       "choice_b":"Inverted",
       "choice_c":"Ascending",
       "choice_d":"Correlated",
       "correct_answer":"C",
       "explanation":"An ascending or upward sloping yield curve is one which displays higher interest rates for longer term maturities. The increase in interest rates over time reflect investor\u0027s expectations for inflation (increase in prices)."
    },
    {
       "id":35687,
       "practice_test_id":"",
       "topic_id":3,
       "question":"ASR Technologies is involved in the development of microchips and the prospects for the company\u0027s earnings vary according to the expectations for the pricing of its products in the market. ASR\u0027s stock has a beta coefficient of 1.4. The market has gone into a major advance and the broad market is up 10 percent. What has happened to the price of ASR\u0027s stock?",
       "choice_a":"It has increased more in price than the broad market",
       "choice_b":"It has increased in price by 6 percent",
       "choice_c":"The price of ASR has moved inline with the expectations for the pricing of its products and could be up or down in price",
       "choice_d":"It has increased by 14 percent",
       "correct_answer":"D",
       "explanation":"The stock has a beta of 1.4 which means that the stock will tend to rise or fall by 1.4 times the change in the underlying index. Therefore, the price of ASR has most likely increased by 1.4 X 10% or 14%."
    },
    {
       "id":35688,
       "practice_test_id":1,
       "topic_id":3,
       "question":"The President and Congress have been working to pass legislation that will increase the marginal tax rate. Which two of the following choices are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> The stock market will most likely fall</li><li>There will be a decrease in the rate of disintermediation</li><li>Yields on municipal bonds will most likely fall</li><li>The yield curve will become inverted</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"B",
       "explanation":"If there is an increase in the marginal tax rate, income taxes will increase. As a result of the increase in income taxes investors will be more likely to purchase municipal bonds. The increase in demand for the municipal bonds will cause the yields on municipal bonds to fall. An increase in taxes is bearish for the stock market and stock prices will likely fall."
    },
    {
       "id":35690,
       "practice_test_id":"",
       "topic_id":3,
       "question":"If the Federal Reserve undertakes an accommodative monetary policy and begins to reduce interest rates, which of the following is most likely to occur?",
       "choice_a":"The value of the dollar will rise versus the Euro",
       "choice_b":"The value of the dollar will fall versus the Euro",
       "choice_c":"The value of the dollar will not be impacted versus the Euro",
       "choice_d":"The value of the dollar will be positively impacted versus the Euro",
       "correct_answer":"B",
       "explanation":"If the Federal Reserve reduces interest rates the value of the dollar will fall versus the value of all other currencies. In this case the value of the dollar will fall versus the Euro. It will now take more dollars to purchase 1 Euro."
    },
    {
       "id":35691,
       "practice_test_id":"",
       "topic_id":3,
       "question":"The manager of a long only fund has been systematically liquidating securities over the past 6 months and has moved the proceeds into money market funds. The manager is now said to be in \u0022cash\u0022. Which of the following would best describe the manager\u0027s outlook?",
       "choice_a":"He is bullish on rates",
       "choice_b":"He is bullish on bonds",
       "choice_c":"He is bearish on stocks",
       "choice_d":"He expects the FRB to reduce rates",
       "correct_answer":"C",
       "explanation":"The manager of a long only fund is not allowed to sell equities short. As a result the only option for this manager when they turn bearish on the stock market is to move to the sidelines and into cash and short term money market funds."
    },
    {
       "id":35692,
       "practice_test_id":2,
       "topic_id":3,
       "question":"Common stockholders have the right to vote on which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The use of retained earnings to repurchase shares for the treasury</li><li>The issuance of convertible bonds </li><li>The compensation for senior executives </li><li>The declaration of bankruptcy </li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"II only",
       "choice_d":"I and IV",
       "correct_answer":"C",
       "explanation":"Of the choices listed the only item that common stockholders may vote on would be the issuance of convertible debt. Common stockholders are entitled to vote for the issuance of any securities that could result in the dilution of shareholder\u0027s equity."
    },
    {
       "id":35693,
       "practice_test_id":"",
       "topic_id":3,
       "question":"XYZ Construction has just purchased a $5 million piece of equipment, utilizing cash on hand. XYZ plans on depreciating the equipment under an accelerated depreciation method. Which of the following is / are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The cost of the equipment will be recovered more quickly </li><li>XYZ\u0027s income will be reduced more in the first few years of operation </li><li>The majority of cost of the equipment will not be recovered until the equipment is decommissioned </li><li> XYZ\u0027s income will be reduced by a similar amount over the useful life of the equipment </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"III and IV",
       "choice_d":"I and IV",
       "correct_answer":"A",
       "explanation":"Under accelerated depreciation the majority of the cost of the equipment is recovered in the first few years of its useful life. As a result XYZ\u0027s earnings will be reduced more in the first few years. This creates a lower taxable income for the company in the first few years after purchase."
    },
    {
       "id":35694,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following economic indicators would be most useful for figuring out whether the economy is growing quickly or slowly?",
       "choice_a":"Leading",
       "choice_b":"Lagging",
       "choice_c":"Coincident",
       "choice_d":"Fiscal",
       "correct_answer":"C",
       "explanation":"Of the three economic indicators, leading, coincident and lagging, the coincident indicators will be the best measure of how fast or slow the economy is growing."
    },
    {
       "id":35695,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following prescribe that lower taxes will encourage economic activity and help the economy grow resulting in a higher overall level tax collection?",
       "choice_a":"Supply side policy",
       "choice_b":"Fiscal policy",
       "choice_c":"Monetary policy",
       "choice_d":"Keynesian policy",
       "correct_answer":"A",
       "explanation":"Supply side economic policy beleives that lower taxes will encourage economic activity and help the economy grow resulting in a higher overall level tax collection?"
    },
    {
       "id":35697,
       "practice_test_id":3,
       "topic_id":3,
       "question":"A corporation borrows money on an unsecured  intermediate basis at a rate of 4.9%. The corporation then takes the borrowed funds and invests in expanding its operations and generates a return of 9%. The corporation is employing:",
       "choice_a":"Arbitrage",
       "choice_b":"Interest rate spreading",
       "choice_c":"Leverage",
       "choice_d":"Expansionary policy",
       "correct_answer":"C",
       "explanation":"When a corporation borrows money and uses the borrowed funds to generate a return that exceeds the cost of the borrowed money the company is employing leverage."
    },
    {
       "id":35698,
       "practice_test_id":"",
       "topic_id":3,
       "question":"The FOMC has been embarking on a bond buying program in line with its mandate. Which of the following will occur? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Interest rates will increase </li><li>The money supply will decrease</li><li>Interest rates will decrease </li><li>The money supply will increase</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"B",
       "explanation":"When the FOMC purchases bonds it is injecting money into the system increasing the money supply. When the FOMC buys bonds it will lower interest rates ."
    },
    {
       "id":35699,
       "practice_test_id":5,
       "topic_id":3,
       "question":"Which of the following companies would be considered the most highly leveraged?",
       "choice_a":"A small cap company who has received its total capitalization from a recent stock offering",
       "choice_b":"A regulated utility company whose has issued a significant amount of bonds to build a new power plant and has a small float of common stock",
       "choice_c":"A  NASDAQ listed issuer who has an active market and a credit facility available through a syndicate of banks",
       "choice_d":"A large cap company with 300,000,000 shares of common stock outstanding, 30,000,000 shares of preferred stock and  20,000,000 in long term variable rate bonds outstanding",
       "correct_answer":"B",
       "explanation":"A highly leveraged corporation is one that has borrowed a large percentage of its capital usually through the sale of bonds. When a corporation borrows money it is anticipating that it can use the borrowed funds to generate a return on the capital that is greater than the cost of that capital."
    },
    {
       "id":35700,
       "practice_test_id":"",
       "topic_id":3,
       "question":"XYZ mining corporation is considering the purchase of a large piece of mining equipment to modernize its facility. It is anticipated that the new equipment will increase productivity. The purchase of the equipment would make sense if the net present value was:",
       "choice_a":"Depreciated slower than the amortization of the equipment",
       "choice_b":"Zero",
       "choice_c":"Less than zero",
       "choice_d":"Greater than zero",
       "correct_answer":"D",
       "explanation":"The purchase would only make sense if the net present value was greater than zero. The NPV is the difference in present value of the income generated by the equipment relative to the NPV of the expense to purchase the equipment."
    },
    {
       "id":35701,
       "practice_test_id":4,
       "topic_id":3,
       "question":"An investor purchases an 8 percent corporate bond in the marketplace at par. After holding the bond fully paid for, the investor has a total return of 5 percent. Why is the investor\u0027s total return lower than the coupon rate?",
       "choice_a":"Interest rate have fallen",
       "choice_b":"The bond\u0027s total return takes into account commissions and markups paid to acquire the bond",
       "choice_c":"Interest rates have risen",
       "choice_d":"The investor paid accrued interest when the bond was purchased and the accrued interest lowers the total return",
       "correct_answer":"C",
       "explanation":"An investor\u0027s total return is found by adding the income received from the investment with any appreciation in price. If the investment falls in price the loss in value  would be subtracted from the total return. The reason the investor\u0027s total return is lower than the coupon rate is due to the fact that interest rates have increased and this caused the bond to fall in price."
    },
    {
       "id":35703,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following conditions would be persistent during a period of stagflation? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>High unemployment </li><li> Inflation </li><li>Deflation </li><li>Falling interest rates </li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and II",
       "choice_c":"III and IV",
       "choice_d":"II and IV",
       "correct_answer":"B",
       "explanation":"During  a period of stagflation the economy will experience high unemployment and inflation. Interest rates will not decline as rates will remain high  to fight inflation. High unemployment and high inflation and interest rates are persistent during a period of stagflation."
    },
    {
       "id":35704,
       "practice_test_id":"",
       "topic_id":3,
       "question":"The expansionary phase of the business cycle is characterized by: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Falling prices </li><li>Falling savings </li><li>Rising prices </li><li>Rising savings</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"II only",
       "choice_d":"IV only",
       "correct_answer":"B",
       "explanation":"The expansionary phase of the business cycle is characterized by rising prices and rising savings. As people earn more they tend to spend more and save more. This will cause prices to rise as more people buy goods. Balances in savings accounts will also increase."
    },
    {
       "id":35705,
       "practice_test_id":5,
       "topic_id":3,
       "question":"As interest rates rise which of the following is true?",
       "choice_a":"The amount of interest paid on outstanding issues will increase",
       "choice_b":"The amount of interest paid on outstanding issues will decrease",
       "choice_c":"The amount of interest paid on outstanding issues will remain constant",
       "choice_d":"The amount of interest paid on outstanding issues will be adjusted to market rates",
       "correct_answer":"C",
       "explanation":"The amount of interest paid on bonds does not change once the bonds have been issued. The nominal yield or the coupon rate will determine the amount of interest that the bond pays over its entire maturity. Prices of bonds do change in the marketplace and that will cause a bond\u0027s current yield and yield to maturity to change based on the change in price."
    },
    {
       "id":39482,
       "practice_test_id":"",
       "topic_id":3,
       "question":"If utilizing supply-side economics, the government would:",
       "choice_a":"use its taxing power in such a way as to increase or decrease the money supply.",
       "choice_b":"formulate its fiscal policy in such a way as to control the demand for goods and services.",
       "choice_c":"manipulate the money supply in order to stabilize the prices of goods and services.",
       "choice_d":"allow market forces to determine the prices of all goods and services.",
       "correct_answer":"D",
       "explanation":"Supply-side economists believe that governments should allow market forces to determine prices of all goods. In contrast, monetarists believe the money supply is the major determinant of price levels and that governments should therefore attempt to manipulate the money supply, making it either easier or more difficult to borrow, in order to control the demand for goods and services."
    },
    {
       "id":34834,
       "practice_test_id":2,
       "topic_id":4,
       "question":"Which of the following are characteristics of common stock? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Right to vote</li><li>Ownership </li><li> Unlimited liability </li><li> Residual claim on assets </li></ol>",
       "choice_a":"I and  III",
       "choice_b":"III and IV",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"A common stock has all of the characteristics listed except unlimited liability. A stockholder\u0027s liability is limited to the amount of their investment."
    },
    {
       "id":34835,
       "practice_test_id":3,
       "topic_id":4,
       "question":"Which of the following is not true about the owner of an ADR?",
       "choice_a":"He has a currency risk",
       "choice_b":"He will be paid in the currency of the foreign country.",
       "choice_c":"His dividends will be converted to US dollars, and if the conversion rate has dropped, he will lose money.",
       "choice_d":"His dividends will be converted to US dollars, and if the conversion rate has risen, he will make money.",
       "correct_answer":"B",
       "explanation":"The investor will be paid in US dollars converted from the foreign currency."
    },
    {
       "id":34836,
       "practice_test_id":4,
       "topic_id":4,
       "question":"Which of the following is the most junior security?",
       "choice_a":"Preferred stock",
       "choice_b":"Mortgage bond",
       "choice_c":"Subordinated debenture",
       "choice_d":"Common Stock",
       "correct_answer":"D",
       "explanation":"Common stock is always the last to get paid in the event of a bankruptcy and therefore is the most junior security"
    },
    {
       "id":34837,
       "practice_test_id":5,
       "topic_id":4,
       "question":"Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Common stock must be issued before any other type of stock can be issued. </li><li>Authorized stock is the first kind of common stock which a company offers.</li><li>Outstanding stock is stock which has not been bought by investors. </li><li>Treasury stock is stock which has been sold to investors and then repurchased by the company.</li></ol>",
       "choice_a":"I, II, and III",
       "choice_b":"I, II, and IV",
       "choice_c":"I, III, and IV",
       "choice_d":"II, III, and IV",
       "correct_answer":"B",
       "explanation":"III is false because outstanding stock is the stock which has been sold to the public and which remains in their hands."
    },
    {
       "id":34838,
       "practice_test_id":1,
       "topic_id":4,
       "question":"Which type of preferred stock allows the company involved to buy back the stock from the stockholders?",
       "choice_a":"Cumulative preferred",
       "choice_b":"Participating preferred",
       "choice_c":"Convertible preferred",
       "choice_d":"Callable preferred",
       "correct_answer":"D",
       "explanation":"Callable preferred is the only type of stock which benefits the company and not the investor since the company can call in, or buy back at the current market price, the stock outstanding. Callable stock is call protected for the first few years."
    },
    {
       "id":34841,
       "practice_test_id":"",
       "topic_id":4,
       "question":"XYZ is going through reorganization and is electing five new members of the board of directors under the cumulative method of voting. An investor owning 500 shares would have:",
       "choice_a":"500 votes to split evenly among 5 candidates",
       "choice_b":"2500 votes to split anyway they choose",
       "choice_c":"500 votes to cast 100 for each director",
       "choice_d":"2500 votes to split 500 for each candidate",
       "correct_answer":"B",
       "explanation":"An investor with 500 shares of stock voting for 5 directors would have a total of 2500 votes to cast in any way he chooses under the cumulative method of voting."
    },
    {
       "id":34843,
       "practice_test_id":1,
       "topic_id":4,
       "question":"ABC has issued ten million shares and has reacquired one million shares, what are the remaining nine million issued shares called?",
       "choice_a":"Offered stock",
       "choice_b":"Issued stock",
       "choice_c":"Outstanding stock",
       "choice_d":"Treasury stock",
       "correct_answer":"C",
       "explanation":"The stock that remains in the hands of the public is outstanding stock."
    },
    {
       "id":34844,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following statements is not true of stock rights?",
       "choice_a":"Rights are receipts for common stock",
       "choice_b":"Rights are securities evidencing the privilege to buy securities at a stated price within a specified period of time",
       "choice_c":"Rights are securities evidencing the preemptive privilege",
       "choice_d":"One right is usually issued for each share of outstanding common stock",
       "correct_answer":"A",
       "explanation":"All of the choices listed are true of stock rights except they are not a receipt for stock."
    },
    {
       "id":34845,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following is not a right of common stock owners?",
       "choice_a":"Limited access to corporate books",
       "choice_b":"The right to a proportionate share of dividends",
       "choice_c":"The right to recover the par value from the company",
       "choice_d":"The right to a voice in management through voting powers",
       "correct_answer":"C",
       "explanation":"A common stockholder does not have the right to receive the common stock\u0027s par value from the corporation."
    },
    {
       "id":34848,
       "practice_test_id":2,
       "topic_id":4,
       "question":"A holder of an ADR has the same rights as a regular stockholder, except:",
       "choice_a":"The right to exchange the ADR for the underlying shares",
       "choice_b":"Preemptive rights.",
       "choice_c":"The right to transfer ownership.",
       "choice_d":"The right to receive dividends",
       "correct_answer":"B",
       "explanation":"Holders of ADRs do not have preemptive rights. The holder does have the right to sell the ADR, to convert the ADR and receive the underlying shares and to receive dividends if paid."
    },
    {
       "id":34849,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A corporation has a 5% participating preferred stock outstanding. The stated rate of payment is fixed as to the:",
       "choice_a":"Maximum but not as to the minimum.",
       "choice_b":"Minimum but not as to the maximum.",
       "choice_c":"Maximum.",
       "choice_d":"Minimum.",
       "correct_answer":"B",
       "explanation":"The stated dividend on a participating preferred is stated as a minimum but not as a maximum."
    },
    {
       "id":34850,
       "practice_test_id":2,
       "topic_id":4,
       "question":"A preferred stock that can be redeemed by the issuing corporation is called a:",
       "choice_a":"Cumulative preferred.",
       "choice_b":"Convertible preferred.",
       "choice_c":"Participating preferred.",
       "choice_d":"Callable preferred.",
       "correct_answer":"D",
       "explanation":"A preferred stock that can be redeemed by the issuing corporation is a callable preferred"
    },
    {
       "id":34851,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The dividend rate on participating preferred stock:",
       "choice_a":"Is paid quarterly",
       "choice_b":"Are fixed monthly payments",
       "choice_c":"Is paid semi-annually.",
       "choice_d":"Accumulates if it is not paid.",
       "correct_answer":"C",
       "explanation":"The dividend on a participating preferred stock is paid semi annually."
    },
    {
       "id":34852,
       "practice_test_id":5,
       "topic_id":4,
       "question":"All of the following pay dividends except:",
       "choice_a":"Common stock.",
       "choice_b":"Preferred stock.",
       "choice_c":"ADRs.",
       "choice_d":"Warrants.",
       "correct_answer":"D",
       "explanation":"Warrants do not pay dividends."
    },
    {
       "id":34853,
       "practice_test_id":3,
       "topic_id":4,
       "question":"The holders of shares of common stock have:",
       "choice_a":"Part ownership in a corporation.",
       "choice_b":"No ownership in the corporation.",
       "choice_c":"Status as creditors of the corporation.",
       "choice_d":"Status as debtors of the corporation.",
       "correct_answer":"A",
       "explanation":"Owners of commons stock have part ownership in the company."
    },
    {
       "id":34854,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A corporation would primarily declare a forward stock split to:",
       "choice_a":"Increase its retained earnings.",
       "choice_b":"Decrease its retained earnings.",
       "choice_c":"Increase the price of its stock to make it more marketable.",
       "choice_d":"Decrease the price of its stock to make it more marketable.",
       "correct_answer":"D",
       "explanation":"A corporation would primarily declare a forward stock split to decrease its price to make it more attractive to individual investors."
    },
    {
       "id":34855,
       "practice_test_id":3,
       "topic_id":4,
       "question":"A customer owns 200 shares of XYZ Corporation. XYZ splits 3 for 2. How many additional shares of XYZ stock will the customer receive?",
       "choice_a":33,
       "choice_b":50,
       "choice_c":100,
       "choice_d":150,
       "correct_answer":"C",
       "explanation":"The customer will receive 100 additional shares multiply 200 X 3/2"
    },
    {
       "id":34856,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following occurs in a reverse split?",
       "choice_a":"The par value decreases and the capital surplus decreases.",
       "choice_b":"The par value increases and the number of outstanding shares decreases.",
       "choice_c":"Retained earnings decrease and capital surplus increases.",
       "choice_d":"Retained earnings increase and the number of outstanding shares increases.",
       "correct_answer":"B",
       "explanation":"With a reverse stock split the par value increases and the number of outstanding shares decreases. The reverse split is effected to increase the stock price and make it more attractive to institutional investors."
    },
    {
       "id":34858,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following represents an ownership interest in a publicly traded company? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Common stock </li><li>Preferred stock </li><li>Secured debenture </liIii><liIV> Authorized stock</li></ol>",
       "choice_a":"I Only",
       "choice_b":"I and II",
       "choice_c":"I, II and III",
       "choice_d":"I, II, III and IV",
       "correct_answer":"B",
       "explanation":"Common and preferred stock both represent equity or ownership of a corporation. Authorized stock has not yet been issued."
    },
    {
       "id":34859,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Treasury stock has been issued and repurchased by a corporation for which of the following reasons?",
       "choice_a":"Raise new capital",
       "choice_b":"Add to outstanding shares",
       "choice_c":"Increase earnings per share",
       "choice_d":"Create a sinking fund",
       "correct_answer":"C",
       "explanation":"A corporation can increase its earning per share or EPS without increasing income by repurchasing outstanding shares from the public."
    },
    {
       "id":34860,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Owning common stock provides an investor with",
       "choice_a":"Safety of principal",
       "choice_b":"Guaranteed dividend income",
       "choice_c":"Protection against market risk",
       "choice_d":"Capital growth",
       "correct_answer":"D",
       "explanation":"Capital growth is the primary objective for investors who own common stock. There are no guaranteed dividends or protection against market risk associated with common stock. Safety of principal is a benefit of owning debt, not equity securities"
    },
    {
       "id":34862,
       "practice_test_id":4,
       "topic_id":4,
       "question":"Which type of preferred stock is likely to have the lowest stated dividend rate?",
       "choice_a":"Cumulative preferred",
       "choice_b":"Participating preferred",
       "choice_c":"Callable preferred",
       "choice_d":"Straight preferred",
       "correct_answer":"A",
       "explanation":"Cumulative preferred stock has the feature of accruing dividends that are missed and paying them out prior to paying out common stock dividends. This protective feature is a benefit to the shareholder and in exchange the stated dividend rate is relatively lower."
    },
    {
       "id":34863,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Your customer recently purchased common stock shares in Alpha Corp., a clothing manufacturer. When he asks you about how dividends are paid you explain that he can receive all of the following as a taxable dividend except:",
       "choice_a":"Cash",
       "choice_b":"Stock in Alpha Corp.",
       "choice_c":"Stock split shares",
       "choice_d":"Merchandise",
       "correct_answer":"C",
       "explanation":"Stock splits do not represent a dividend payment. It is merely a capital structure reorganization that adjusts outstanding shares and it does not represent any taxable economic benefit to the investor."
    },
    {
       "id":34864,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The transfer agent for a corporation does which of the following?",
       "choice_a":"Audits amount of outstanding shares",
       "choice_b":"Authorizes stock",
       "choice_c":"Transfer payment of dividends to shareholders",
       "choice_d":"Maintains record of ownership",
       "correct_answer":"D",
       "explanation":"The primary function of the transfer agent is to maintain the issuer\u0027s record of ownership. In addition, the transfer agent also cancels old and issues new certificates, as well as handles problems with lost, stolen or destroyed certificates."
    },
    {
       "id":34865,
       "practice_test_id":4,
       "topic_id":4,
       "question":"Ownership of American Depository Receipts is associated with which of the following risks <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Political risk </li><li>Market risk </li><li>Interest rate risk </li><li>Foreign currency risk</li></ol>",
       "choice_a":"II only",
       "choice_b":"I and II",
       "choice_c":"I, II and IV",
       "choice_d":"II, III and IV",
       "correct_answer":"C",
       "explanation":"All marketable securities are subject to market risk. In addition, ADRs carry foreign currency and political risk."
    },
    {
       "id":34866,
       "practice_test_id":"",
       "topic_id":4,
       "question":"REITs provide investors with all of the following advantages except",
       "choice_a":"Pass through income",
       "choice_b":"Liquidity",
       "choice_c":"Limited liability",
       "choice_d":"Tax deduction for losses",
       "correct_answer":"D",
       "explanation":"Only income is passed through to investors in a Real Estate Investment Trust. Losses incurred by the REIT cannot be deducted by an investor."
    },
    {
       "id":34867,
       "practice_test_id":2,
       "topic_id":4,
       "question":"An investor owns 1000 shares of the Omega Company, a company listed on the NYSE. Omega Company has  announced a 5% stock dividend to be paid in stock of its subsidiary company Theta Brands. The investor will receive:",
       "choice_a":"50 shares of Omega Company",
       "choice_b":"5 shares of Omega Company",
       "choice_c":"50 shares of Theta Brands",
       "choice_d":"500 shares of Theta Brands",
       "correct_answer":"C",
       "explanation":"A 5% stock dividend on 1000 shares is equal to 50 shares and the dividend is being paid in shares of Theta Brands."
    },
    {
       "id":34868,
       "practice_test_id":3,
       "topic_id":4,
       "question":"When a company holds its annual meeting and is holding elections to fill seats on its board of directors, which of the following is true about cumulative voting rights?",
       "choice_a":"It benefits large investors who have accumulated more shares",
       "choice_b":"It gives an advantage to the company\u0027s remaining board members",
       "choice_c":"It allows investors who own preferred and common stock to combine their voting rights",
       "choice_d":"It benefits the small investors by giving them the ability to cast all of their votes behind one member in  an election",
       "correct_answer":"D",
       "explanation":"The small investor benefits the most from cumulative voting rights by having the ability to cast all votes from each election for a single board member candidate."
    },
    {
       "id":34869,
       "practice_test_id":4,
       "topic_id":4,
       "question":"The biggest benefit of preferred stock for an investor is:",
       "choice_a":"A low unit price and guaranteed return of the face amount of the shares",
       "choice_b":"A low unit price and guaranteed semi annual payment",
       "choice_c":"A low unit price and secured as a general creditor of the issuer in case of bankruptcy",
       "choice_d":"A stated dividend payment",
       "correct_answer":"D",
       "explanation":"The biggest benefit to an investor in preferred stock is the stated dividend. The dividend is promised at a stated rate but is not guaranteed. A low unit price is generally not a benefit for an investor in preferred shares."
    },
    {
       "id":34871,
       "practice_test_id":5,
       "topic_id":4,
       "question":"You own shares in XYZ, a large multinational manufacturer that is the biggest manufacturer in its industry. The company may be ruled a monopoly by the Government. This is an example of:",
       "choice_a":"Market Risk",
       "choice_b":"Liquidity Risk",
       "choice_c":"Regulatory Risk",
       "choice_d":"Business Risk",
       "correct_answer":"C",
       "explanation":"Any action taken by the Government that may affect the prospects of an industry or a specific company would be an example of regulatory risk."
    },
    {
       "id":34873,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following is an attribute of an investment in an oil and gas partnership program that is not associated with an investment in a real estate partnership program?",
       "choice_a":"Passive loss pass through",
       "choice_b":"Pass through of passive gains",
       "choice_c":"Lack of liquidity",
       "choice_d":"Depletion",
       "correct_answer":"D",
       "explanation":"All DPPs offer the pass through of gains and losses and most lack liquidity. Depletion is an allowance for the reduction in the amount of a natural resource. This takes into consideration the fact that at some point the resource will be completely removed from the ground. Real estate is not a natural resource. The buildings would be depreciated over time to account for the fact that the buildings will not last forever."
    },
    {
       "id":34874,
       "practice_test_id":2,
       "topic_id":4,
       "question":"Which one of the following rights is never directly granted to all common shareholders of a publicly-held corporation?",
       "choice_a":"Pre emptive right",
       "choice_b":"Voting right",
       "choice_c":"Right to receive declared dividends",
       "choice_d":"Right to elect the CEO",
       "correct_answer":"D",
       "explanation":"The CEO of a company is appointed by the Board of Directors. Shareholders do not vote directly for the CEO of the company. Shareholders vote for the Board of Directors and the Board determines who should run the day to day operations of the company"
    },
    {
       "id":34875,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following features would benefit a preferred stock investor during a period of inflation?",
       "choice_a":"Cumulative",
       "choice_b":"Callable",
       "choice_c":"Convertible",
       "choice_d":"Participating",
       "correct_answer":"C",
       "explanation":"During times of inflation the value of fixed payments will become less valuable and the price of the preferred stock may decrease as a result. If the preferred stock is convertible it would lend support to the price of the preferred stock and allow the investor to convert the preferred shares for common shares which tend to do better during times of inflation."
    },
    {
       "id":39450,
       "practice_test_id":2,
       "topic_id":4,
       "question":"When a corporation enlists the services of a transfer agent the expectation is that the transfer agent would handle all of the following functions except:",
       "choice_a":"registration of the corporation\u0027s securities with the state.",
       "choice_b":"the maintenance of shareholder ownership records.",
       "choice_c":"providing for the replacement of lost or destroyed stock certificates.",
       "choice_d":"the cancellation of old certificates and the issuing of new ones.",
       "correct_answer":"A",
       "explanation":"It is the registrar, not the transfer agent, who is responsible for registering a corporation\u0027s securities with the state. The transfer agent for a corporation is a separate entity, and is responsible for all of the following; ensuring that its securities are issued in the correct owner\u0027s name and maintaining records of shareholder ownership, and when physical certificates exist, canceling old certificates and issuing new ones, as well as handling any issues relating to lost, stolen, or damaged stock certificates."
    },
    {
       "id":39455,
       "practice_test_id":"",
       "topic_id":4,
       "question":"When cumulative preferred stock is issued by a company, it will:",
       "choice_a":"pay past and current preferred dividends before it can pay dividends on common shares.",
       "choice_b":"pay the preferred dividend before it can pay any coupons due on its outstanding bonds.",
       "choice_c":"force conversion of the preferred to common, eliminating the need to pay past-due dividends.",
       "choice_d":"pay the current dividends on the preferred, but needn\u0027t pay any missed dividends to pay a dividend on the common stock.",
       "correct_answer":"A",
       "explanation":"When cumulative preferred stock is issued the company must pay the current dividend and any unpaid past dividends (dividends in arrears) before common stockholders can receive a dividend. Additionally, remember that interest on bonds is paid before any dividends can be paid on preferred or common shares."
    },
    {
       "id":39458,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Preemptive rights for common shareholders can best be described as the right to:",
       "choice_a":"vote for members of the board of directors when vacancies arise.",
       "choice_b":"maintain a proportionate share of ownership in the corporation if more shares are issued.",
       "choice_c":"share in the earnings of the corporation through the receipt of dividends when declared.",
       "choice_d":"earn a profit through the increase in share value between the time shares are purchased and sold.",
       "correct_answer":"B",
       "explanation":"Preemptive rights allow shareholders to maintain a proportionate share of ownership in the corporation when additional shares are issued. When a corporation wants to issue additional shares, the existing shareholders will have the right to purchase those shares in an amount that would keep their proportionate ownership in the corporation unchanged before the shares are offered to new investors."
    },
    {
       "id":39460,
       "practice_test_id":3,
       "topic_id":4,
       "question":"For preferred stock, dividends are stated as a percentage of:",
       "choice_a":"the stated par value of the shares.",
       "choice_b":"market value at the time the dividend is paid.",
       "choice_c":"market value on the date the dividend is declared.",
       "choice_d":"the corporation\u0027s book value at the time the dividend is paid.",
       "correct_answer":"A",
       "explanation":"Dividends for preferred shares are stated as a percentage of its par value. Par value can be assumed to be $100 for preferred shares unless it has been stated differently."
    },
    {
       "id":39461,
       "practice_test_id":5,
       "topic_id":4,
       "question":"Regarding preferred stock, which of the following statements is not accurate?",
       "choice_a":"Corporations must offer at least one class of preferred shares if they intend to offer common shares.",
       "choice_b":"In the event of a corporate bankruptcy, preferred shareholders are paid before common shareholders.",
       "choice_c":"Preferred shareholders do not have the right to vote on corporate issues.",
       "choice_d":"Preferred shareholders do not have preemptive rights.",
       "correct_answer":"A",
       "explanation":"Corporations are not required to issue shares of preferred stock in order to issue common stock. However, when they do, it should be recognized that the preferred shareholders will have no voting rights or preemptive rights, but in the case of a corporate dissolution (bankruptcy) will be paid before common shareholders."
    },
    {
       "id":39464,
       "practice_test_id":3,
       "topic_id":4,
       "question":"Which of the following is the definition of a penny stock?",
       "choice_a":"A penny stock is an exchange-listed security trading at $5 or less per share.",
       "choice_b":"A penny stock is an unlisted security trading at less than $5 per share.",
       "choice_c":"A penny stock is an unlisted security trading at a minimum of $5 per share.",
       "choice_d":"A penny stock is a security issued by a company that has filed for protection under US bankruptcy law.",
       "correct_answer":"B",
       "explanation":"A penny stock is an unlisted security, therefore one not listed on a U.S. stock exchange, that is trading at less than $5 per share."
    },
    {
       "id":39468,
       "practice_test_id":"",
       "topic_id":4,
       "question":"In the event of bankruptcy, in which order, first to last, would claims be satisfied when a publicly traded company is forced to liquidate its assets?",
       "choice_a":"Debentures, secured bondholders, common stockholders, preferred stockholders",
       "choice_b":"Secured bondholders, preferred stockholders, common stockholders, debentures",
       "choice_c":"Common stockholders, preferred stockholders, secured bondholders, debentures",
       "choice_d":"Secured bondholders, debentures, preferred stockholders, common stockholders",
       "correct_answer":"D",
       "explanation":"Remember, in bankruptcy claims secured debt holders are paid first and common stockholders last. Only one choice starts with secured bondholders and ends with common stockholders; Secured bondholders, debentures, preferred stockholders, common stockholders."
    },
    {
       "id":39469,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Regarding convertible bonds issued by corporations, which of the following is not true?",
       "choice_a":"Convertible bonds allow the bondholder to convert the debt instrument into common shares, an equity instrument.",
       "choice_b":"Convertible bonds are often issued at a higher price (premium) than nonconvertible bonds issued by the same issuer.",
       "choice_c":"Convertible bondholders are not owners of the corporation, but are instead considered creditors of the corporation.",
       "choice_d":"Coupon yields are usually higher than those of the nonconvertible bonds issued by the same issuer.",
       "correct_answer":"D",
       "explanation":"Convertible bonds allow the owner to convert the bond, a debt instrument, into common shares which are equity securities. Giving the bondholders the extra conversion feature allows the issuer to pay a lower coupon rate on the bond. Therefore, coupon rates are not higher than nonconvertible bond rates, but lower. It also allows the issuer to sell the bonds at a slight premium because buyers are willing to pay more for the added feature. Lastly, bonds represent debt, this makes the bondholders creditors of the issuer."
    },
    {
       "id":39473,
       "practice_test_id":5,
       "topic_id":4,
       "question":"3% preferred stock participating to 4% means that an owner of the preferred shares:",
       "choice_a":"must receive an additional 3% in any year the board declares the 4% dividend.",
       "choice_b":"must receive a participating additional 4% each year the board declares a dividend.",
       "choice_c":"could receive an additional 4% over the stated 3% dividend if the board declares it.",
       "choice_d":"could receive an additional 1% over the stated 3% dividend if the board declares it.",
       "correct_answer":"D",
       "explanation":"3% preferred participating to 4% means that the company can pay its preferred shareholders an additional 1% in dividends above the 3% if the board of directors (BOD) declares it. The additional participating dividend is generally paid in profitable years."
    },
    {
       "id":39474,
       "practice_test_id":"",
       "topic_id":4,
       "question":"For shareholders of common stock, market risk is best characterized as the risk that:",
       "choice_a":"comes with having the lowest priority if a corporation were to declare bankruptcy.",
       "choice_b":"income from dividends can be halted completely if the board chooses not to declare a dividend.",
       "choice_c":"income from dividends will decline if dividends declared are decreased.",
       "choice_d":"shares owned will decline in value after having been purchased.",
       "correct_answer":"D",
       "explanation":"Stock ownership can represent many risks. However, market risk represents the risk that share prices will decline in value after being purchased."
    },
    {
       "id":39475,
       "practice_test_id":4,
       "topic_id":4,
       "question":"When a corporate bankruptcy occurs:",
       "choice_a":"a shareholder\u0027s liability is limited to the total amount invested when the shares were purchased.",
       "choice_b":"a shareholder may be required to pledge personal assets if needed to meet the liabilities of the corporation.",
       "choice_c":"a shareholder may, by court order, have to rebate all dividends received during the time shares were owned.",
       "choice_d":"a shareholder has unlimited liability as an owner of the corporation and can lose more than was initially invested.",
       "correct_answer":"A",
       "explanation":"A shareholder has limited liability. That is liability equal only to the total amount invested. In the event that a corporate bankruptcy occurs, this amount is the most the shareholder can lose."
    },
    {
       "id":39476,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Corporate stockholders have all of the following rights except to:",
       "choice_a":"participate directly in the daily management of the company.",
       "choice_b":"vote for those who will serve on the board of directors.",
       "choice_c":"examine the minutes of any meetings held by the board of directors.",
       "choice_d":"receive audited financial statements annually.",
       "correct_answer":"A",
       "explanation":"Through their vote for those who serve on the board of directors, stockholders have a voice in how a company is run. In this way they have a say in the company\u0027s management, but are not involved in the day-to-day operations. Additionally, they have the right to examine the minutes of board meetings and receive audited financial statements annually."
    },
    {
       "id":39485,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following is the computation for a company\u0027s net worth?",
       "choice_a":"Assets minus liabilities.",
       "choice_b":"Liabilities divided by assets.",
       "choice_c":"Assets divided by liabilities",
       "choice_d":"Liabilities minus assets.",
       "correct_answer":"A",
       "explanation":"A company\u0027s total assets minus the company\u0027s total liabilities equals its net worth. This computation is taken from a company\u0027s balance sheet."
    },
    {
       "id":36128,
       "practice_test_id":4,
       "topic_id":5,
       "question":"A long established Mutual Fund Company wants to place new ads in the financial papers to try to attract new investors. Which of the following is true?",
       "choice_a":"The board of directors of the fund only needs to approve it",
       "choice_b":"The ad must be filed with FINRA 10 days before it is first used",
       "choice_c":"The ad must be filed with FINRA 10 days after it is first used",
       "choice_d":"Mutual funds with track records longer that 10 years don\u0027t have to file their ads",
       "correct_answer":"C",
       "explanation":"Mutual funds must submit their advertisements to FINRA 10 days after they are first used."
    },
    {
       "id":36126,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A diversified investment company is prohibited from all of the following except:",
       "choice_a":"Taking over control of other companies",
       "choice_b":"Borrowing money",
       "choice_c":"Receiving a commission for executing orders or acting as a broker",
       "choice_d":"Continuing to operate with less than $100,000 net worth or less than 100 shareholders",
       "correct_answer":"B",
       "explanation":"An investment company may borrow money on a limited basis."
    },
    {
       "id":36125,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A combination fund does which of the following?",
       "choice_a":"Invests to achieve greater capital appreciation with some current income",
       "choice_b":"Invests to achieve both capital appreciation and current income",
       "choice_c":"Invests to achieve the greatest capital appreciation and the greatest current income",
       "choice_d":"Invests to achieve a balanced tax reduced returns",
       "correct_answer":"B",
       "explanation":"A combination fund seeks to gain the greatest capital appreciation by investing in some common stocks, while it also invests in common and preferred stocks, which are paying the highest dividends to investors for income."
    },
    {
       "id":36124,
       "practice_test_id":2,
       "topic_id":5,
       "question":"A closed-end investment company\u0027s shares are priced:",
       "choice_a":"By formula",
       "choice_b":"As set by the investment advisor",
       "choice_c":"By the exchange or NASDAQ",
       "choice_d":"By supply and demand",
       "correct_answer":"D",
       "explanation":"Closed-end investment company\u0027s shares are priced by supply and demand."
    },
    {
       "id":36123,
       "practice_test_id":3,
       "topic_id":5,
       "question":"A closed-end investment company may issue: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Preferred stock  </li><li>Common shares </li><li>Fractional shares  </li><li>Bonds </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I, II, and IV",
       "correct_answer":"D",
       "explanation":"A closed-end mutual fund may issue all of the choices listed except fractional shares."
    },
    {
       "id":36122,
       "practice_test_id":4,
       "topic_id":5,
       "question":"A balanced fund:",
       "choice_a":"Invests in both stocks and bonds according to a predetermined formula",
       "choice_b":"Invests in stocks to offer a balanced growth and income portfolio",
       "choice_c":"Must invest equally in each stock or bond it chooses",
       "choice_d":"Invests in bonds for a low risk balanced portfolio for the investor",
       "correct_answer":"A",
       "explanation":"A balanced fund invests in both stocks and bonds according to a plan predetermined by the board of directors in order to achieve their goals in investing."
    },
    {
       "id":36207,
       "practice_test_id":5,
       "topic_id":5,
       "question":"A fund must inform its shareholders of their right to reinvest dividends at NAV:",
       "choice_a":"Quarterly",
       "choice_b":"Annually",
       "choice_c":"At the time of each distribution",
       "choice_d":"At the time of original purchase only",
       "correct_answer":"B",
       "explanation":"A fund must notify shareholders at least annually of their right to reinvest, and it usually accomplishes this through the annual report it sends to every investor."
    },
    {
       "id":36208,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A FINRA broker dealer trading in shares of an open end investment company cannot buy shares of the fund:",
       "choice_a":"To cover existing orders",
       "choice_b":"For the firm\u0027s own investment purposes",
       "choice_c":"At a discount",
       "choice_d":"For the purpose of resale at a later date",
       "correct_answer":"D",
       "explanation":"A broker dealer may purchase shares only to fulfill existing orders or for its own investment account, not for inventory."
    },
    {
       "id":36206,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investment company share purchased at its net asset value that can be redeemed later at the then-current net asset value is a share issued by a(n):",
       "choice_a":"Open-end investment company",
       "choice_b":"Closed-end investment company",
       "choice_c":"Front-end load company",
       "choice_d":"No-load open-end investment company",
       "correct_answer":"D",
       "explanation":"A share purchased at its NAV and sold at its NAV is a no-load fund. NAV plus the sales charge equals the POP; if there is no sales charge, the NAV equals the POP."
    },
    {
       "id":36205,
       "practice_test_id":1,
       "topic_id":5,
       "question":"If a mutual fund has a bid price of $9.15 and a sales charge of 8.5%, what is the price an investor will pay for each share of this fund? (Round to the nearest cent.)",
       "choice_a":"$8.37",
       "choice_b":"$9.93",
       "choice_c":"$10",
       "choice_d":"$10.76",
       "correct_answer":"C",
       "explanation":"Mutual fund shares are purchased at the POP. To find the POP use the formula: POP = NAV/(100% 0 SC%).In this example, 9.15/.915 = POP of $10."
    },
    {
       "id":36204,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The ex-date for a closed-end mutual fund is set by the:",
       "choice_a":"Board of Directors of the Fund",
       "choice_b":"FINRA",
       "choice_c":"SEC",
       "choice_d":"Underwriter",
       "correct_answer":"B",
       "explanation":"The ex-dates for closed-end funds (typically 2 business days before the record date) are by FINRA. The ex-date for open-end funds (typically the business day following the record date) is determined by the Board of Directors of the fund."
    },
    {
       "id":36203,
       "practice_test_id":5,
       "topic_id":5,
       "question":"A broker-dealer that buys mutual fund shares from an underwriter may be allowed a discount under which of the following circumstances?",
       "choice_a":"Broker-dealer has signed a selling agreement and is buying shares in antic­ipation of receiving a customer order",
       "choice_b":"Broker-dealer is buying to fill a customer\u0027s order and has a selling agree­ment in force with the underwriter",
       "choice_c":"Broker-dealer is registered with the SEC",
       "choice_d":"All of the choices listed",
       "correct_answer":"B",
       "explanation":"Discounts are available only to broker­ dealers that have signed selling agreements with the principal underwriter. Discounts then can be applied to any and all purchases. Purchases by a member may be made only to fill existing, not anticipated, orders. Purchases can also be made for a member firm\u0027s investment account."
    },
    {
       "id":36202,
       "practice_test_id":1,
       "topic_id":5,
       "question":"Capital gains distributions may be combined with income distributions to calculate annual yield on mutual fund shares under which of the following circumstances?",
       "choice_a":"When the income distributions contain short-term capital gains",
       "choice_b":"When both distributions are accompanied by a source of distribution state­ment",
       "choice_c":"When both distributions resulted from activities occurring within the same year",
       "choice_d":"Under no circumstances",
       "correct_answer":"D",
       "explanation":"Capital gains distributions may never be combined with income distributions for this purpose."
    },
    {
       "id":36201,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Your customer thinks that the telecommunication sector is likely to rebound over the next 24 months. He wants to liquidate his shares in the XYZ income opportunity fund, which has an NAV of $11 and a POP of $11.70. He has 500 shares and wants to move the money into the XYZ telecommunication fund, which has a NAV of $10 and a POP of $10.50. XYZ offers conversion privileges. How many shares can he buy?",
       "choice_a":"550 shares",
       "choice_b":"522.5 shares",
       "choice_c":"585 shares",
       "choice_d":"512 shares",
       "correct_answer":"A",
       "explanation":"The investor will be able to buy 550 shares of the new fund because the fund offers conversion privileges. The investor sells his shares at the NAV of $11 X 500 = $5,500, and buys the new shares at the NAV of $10. $5,500 / 10 = 550."
    },
    {
       "id":36200,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Your customer has just bought $10,000 worth of Kashmir Growth fund. The trade will settle on:",
       "choice_a":"The third business day",
       "choice_b":"The fourth business day",
       "choice_c":"The next business day",
       "choice_d":"The same day",
       "correct_answer":"D",
       "explanation":"The investor has purchased shares of an open-end mutual fund. Every new investor gets a new share and becomes an owner of record on the day of the purchase."
    },
    {
       "id":36199,
       "practice_test_id":1,
       "topic_id":5,
       "question":"Which of the following is true regarding the ex-dividend date for an open-end mutual fund? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is set by FINRA </li><li> It is the day before the record date </li><li> It is set by the board of directors </li><li>It is the day after the record date.</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I and IV",
       "choice_d":"III and IV",
       "correct_answer":"D",
       "explanation":"The ex-dividend date for an open-end mutual fund is set by the board of directors and is the day after the record date."
    },
    {
       "id":36198,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is true about securities in a fund\u0027s portfolio?",
       "choice_a":"The NAV will decrease if the fund distributes dividends or capital gains",
       "choice_b":"The NAV will increase if the fund receives investment income",
       "choice_c":"The NAV will be unchanged by sales charges, portfolio purchases and sales and investor purchases and sales",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are true about the NAV and the securities in a portfolio."
    },
    {
       "id":36197,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is not a function of an investment company\u0027s custodian bank?",
       "choice_a":"Providing safekeeping of securities",
       "choice_b":"Providing portfolio advice regarding transactions",
       "choice_c":"Maintaining books and records for accumulation plans",
       "choice_d":"Safekeeping cash",
       "correct_answer":"B",
       "explanation":"The custodian bank does not provide advice."
    },
    {
       "id":36196,
       "practice_test_id":2,
       "topic_id":5,
       "question":"Which of the following is not a feature of open-end funds?",
       "choice_a":"Unlimited continuous primary offering",
       "choice_b":"Shares are priced by supply and demand",
       "choice_c":"Full and fractional shares",
       "choice_d":"Common shares only",
       "correct_answer":"B",
       "explanation":"Open-end fund shares are priced by the formula NAV + SC = POP."
    },
    {
       "id":36195,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following investment companies is sold with a commission added to the contract price?",
       "choice_a":"Open-end management companies",
       "choice_b":"Unit investment trusts",
       "choice_c":"Face-amount certificate companies",
       "choice_d":"Closed-end investment companies",
       "correct_answer":"D",
       "explanation":"A closed-end investment company share is sold at the market price, plus a commission."
    },
    {
       "id":36194,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following funds would most likely have the highest management fee?",
       "choice_a":"A long term bond fund",
       "choice_b":"A Long term growth fund",
       "choice_c":"An aggressive growth fund",
       "choice_d":"An option income fund",
       "correct_answer":"C",
       "explanation":"The aggressive growth fund would have the highest fee. The more aggressive the fund\u0027s objective, the higher the fee."
    },
    {
       "id":36193,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following are types of sales loads: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Front-end </li><li>Back-end </li><li>Contingent deferred sales charge </li><li>12 b-1 fee</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed are types of sales loads. A sales load is anything that reduces the return to an investor, and a 12b-1 fee is a type of sales load."
    },
    {
       "id":36191,
       "practice_test_id":2,
       "topic_id":5,
       "question":"Which is true about the board of directors?",
       "choice_a":"The board is elected by the vote of the outstanding shares",
       "choice_b":"The board must be made up of at least 60% non-interested or non-affiliated persons",
       "choice_c":"The board may be made up of a maximum of 40% of interested persons, such as a broker, attorney, or immediate family member",
       "choice_d":"None of the choices listed",
       "correct_answer":"A",
       "explanation":"Elected by a vote of the shareholders, the board must be made up of at least a majority of non-interested persons."
    },
    {
       "id":36192,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following are true regarding dollar cost averaging? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is effective in a short period of time </li><li>It is more effective when the dollar amount varies </li><li>It is a long term investment strategy </li><li>It is more effective when the share price varies</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"III and IV",
       "correct_answer":"D",
       "explanation":"Dollar cost averaging is a long term investment strategy that is most effective when the share price varies. The investor invests a fixed amount over a long period of time into a fund with a fluctuating share price."
    },
    {
       "id":36190,
       "practice_test_id":"",
       "topic_id":5,
       "question":"What kind of investment company makes no provision for future purchases or redemptions?",
       "choice_a":"An open-end fund",
       "choice_b":"A closed-end fund",
       "choice_c":"A unit investment trust",
       "choice_d":"A face-amount certificate company",
       "correct_answer":"B",
       "explanation":"A closed-end fund makes no provisions for re-purchasing or redeeming its shares."
    },
    {
       "id":36189,
       "practice_test_id":"",
       "topic_id":5,
       "question":"What is the mutual fund pricing formula?",
       "choice_a":"NAV – SC = POP",
       "choice_b":"NAV + SC = POP",
       "choice_c":"SC + POP = NAV",
       "choice_d":"NAV x SC = POP",
       "correct_answer":"B",
       "explanation":"Net asset value (NAV) plus service charge (SC) equals the public offering price (POP)."
    },
    {
       "id":36188,
       "practice_test_id":2,
       "topic_id":5,
       "question":"What is the maximum percentage of directors of an investment company who may be officers, employees, or investment advisors of the company?",
       "choice_a":"40%",
       "choice_b":"50%",
       "choice_c":"49%",
       "choice_d":"75%",
       "correct_answer":"C",
       "explanation":"A maximum of 49% of the board may hold another position with the fund company."
    },
    {
       "id":36187,
       "practice_test_id":5,
       "topic_id":5,
       "question":"To determine the net asset value of a fund, use the following formula:",
       "choice_a":"Assets plus liabilities equals net asset value",
       "choice_b":"Net asset value equals liabilities minus assets",
       "choice_c":"Assets minus liabilities equals net asset value",
       "choice_d":"Net asset value equals liabilities plus assets",
       "correct_answer":"C",
       "explanation":"Assets - liabilities = NAV, a most important formula."
    },
    {
       "id":36186,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The transfer agent of an investment company does which of the following?",
       "choice_a":"Handles the issuance, cancellation, and redemption of fund shares",
       "choice_b":"Handles name changes",
       "choice_c":"Receives an agreed upon fee for his services",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The transfer agent does all of the choices listed for an investment company."
    },
    {
       "id":36185,
       "practice_test_id":5,
       "topic_id":5,
       "question":"The Securities Act of 1933 requires that all investment company offerings do all of the following except:",
       "choice_a":"Register with the Securities Exchange Commission",
       "choice_b":"Have a net worth at a minimum of $250,000",
       "choice_c":"Give all purchasers a prospectus",
       "choice_d":"Follow specific guidelines on its offerings and keep investors informed",
       "correct_answer":"B",
       "explanation":"The Securities Act of 1933 did not require an investment company to have a net worth, but in order to register with the Securities Exchange Commission, a company must have a minimum net worth of $100,000."
    },
    {
       "id":36184,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The purpose of a letter of intent is:",
       "choice_a":"To let the mutual fund know what the person is considering",
       "choice_b":"To allow an investor to reach a breakpoint within 13 months of his first investment",
       "choice_c":"To provide a binding agreement for both the customer and the fund company for investment planning purposes",
       "choice_d":"To allow the fund company to create an escrow fund to protect itself should the investor default",
       "correct_answer":"B",
       "explanation":"A letter of intent simply allows an investor to reach a breakpoint within 13 months of his first investment; it is binding on the fund company, not on the individual."
    },
    {
       "id":36183,
       "practice_test_id":3,
       "topic_id":5,
       "question":"The pricing formula for an open-end mutual fund is:",
       "choice_a":"NAV = assets - liabilities",
       "choice_b":"POP – SC = NAV",
       "choice_c":"NAV + SC = POP",
       "choice_d":"Supply + demand = POP",
       "correct_answer":"C",
       "explanation":"The pricing formula for an open-end investment company is always NAV + SC = POP."
    },
    {
       "id":36179,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Investment companies are required to report to shareholders:",
       "choice_a":"Monthly",
       "choice_b":"Semi-annually",
       "choice_c":"Annually",
       "choice_d":"No reports are required",
       "correct_answer":"B",
       "explanation":"Investment companies must send reports to shareholders an annual audited report plus an unaudited semi-annual update."
    },
    {
       "id":36180,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The GGF Fund is a diversified mutual fund with net assets of $1,000,000. How much must it invest in securities of other issuers?",
       "choice_a":"$250,000",
       "choice_b":"$500,000",
       "choice_c":"$750,000",
       "choice_d":"None of the choices listed",
       "correct_answer":"C",
       "explanation":"This fund must invest 75% of its net assets in securities of other issuers in order to market itself as a diversified mutual fund."
    },
    {
       "id":36181,
       "practice_test_id":3,
       "topic_id":5,
       "question":"The largest expense of a mutual fund is:",
       "choice_a":"Its sales charge",
       "choice_b":"Its management fee",
       "choice_c":"Its custodial fee",
       "choice_d":"Its redemption fee",
       "correct_answer":"B",
       "explanation":"The largest expense of a mutual fund is the management fee paid to the investment advisor."
    },
    {
       "id":36182,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The maximum amount that a diversified fund may invest in any one target company is:",
       "choice_a":"10%",
       "choice_b":"5%",
       "choice_c":"7%",
       "choice_d":"8.50%",
       "correct_answer":"B",
       "explanation":"A diversified mutual fund may invest no more than 5% of its assets in any one company."
    },
    {
       "id":36178,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An open-end mutual fund has how long to forward proceeds to a customer who has requested redemption?",
       "choice_a":"5 business days",
       "choice_b":"5 calendar days",
       "choice_c":"7 business days",
       "choice_d":"7 calendar days",
       "correct_answer":"D",
       "explanation":"A customer\u0027s redemption request must be honored and the fund company must forward the proceeds to the investor within 7 calendar days."
    },
    {
       "id":36177,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An open-end mutual fund share goes ex-dividend:",
       "choice_a":"2 business days prior to the record date",
       "choice_b":"1 business day prior to the record date",
       "choice_c":"1 business day after the record date",
       "choice_d":"As stated in the prospectus",
       "correct_answer":"C",
       "explanation":"An open-end mutual fund share goes ex-dividend one business day after the record date."
    },
    {
       "id":36176,
       "practice_test_id":5,
       "topic_id":5,
       "question":"An open-end mutual fund may charge 8.5% of the POP if:",
       "choice_a":"They offer breakpoint sales charge reductions; the more money invested, the lower the sales charge",
       "choice_b":"They offer rights of accumulation reductions; the more subsequent investments by one investor, the lower the sales charge based on the value of the investor\u0027s account",
       "choice_c":"They offer automatic reinvestment of dividends and capital gains of the NAV",
       "choice_d":"They offer all of the choices listed",
       "correct_answer":"D",
       "explanation":"An open-end mutual fund may charge 8.5% of the POP, if, and only if, they offer all of the choices listed reductions."
    },
    {
       "id":36174,
       "practice_test_id":3,
       "topic_id":5,
       "question":"An investor purchasing an investment company is told the price is \u0022market plus commission\u0022. He would be purchasing:",
       "choice_a":"An open-end investment company",
       "choice_b":"A closed-end investment company",
       "choice_c":"A fund with redeemable shares outstanding",
       "choice_d":"An open-end diversified common stock fund",
       "correct_answer":"B",
       "explanation":"An investor who purchases a closed-end fund will pay the market price plus a commission to execute the order."
    },
    {
       "id":36175,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor that wires money into their mutual fund account at 10:00 AM on the record date:",
       "choice_a":"Will not receive the dividend",
       "choice_b":"Will receive the dividend",
       "choice_c":"Will only receive the dividend if it\u0027s based on bond interest payments",
       "choice_d":"Will only receive the dividend if it\u0027s based upon common dividends",
       "correct_answer":"B",
       "explanation":"An investor who purchases an open-end mutual fund share on the record date will receive the dividend."
    },
    {
       "id":36173,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor in the XYZ high growth fund could best be described as:",
       "choice_a":"A creditor of XYZ",
       "choice_b":"A stockholder in XYZ",
       "choice_c":"An owner of XYZ",
       "choice_d":"A shareholder with an undivided interest in the fund",
       "correct_answer":"D",
       "explanation":"Any investor in a mutual fund is a shareholder in that fund or portfolio only."
    },
    {
       "id":36172,
       "practice_test_id":4,
       "topic_id":5,
       "question":"An investor in a UIT will receive what as their evidence of ownership in the UIT?",
       "choice_a":"Trust certificates",
       "choice_b":"Shares of beneficial interest",
       "choice_c":"Exchangeable share",
       "choice_d":"Units of ownership",
       "correct_answer":"B",
       "explanation":"Investors who purchase a UIT will receive shares of beneficial ownership."
    },
    {
       "id":36171,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor has chosen to receive the capital gains and dividend distributions from a mutual fund portfolio. Which of the following is true?",
       "choice_a":"Their tax liability has gone up because they have received the distributions",
       "choice_b":"Their capital gains rate is higher than it would have been if they re-invested the distributions",
       "choice_c":"Their proportional ownership of the fund has gone down",
       "choice_d":"Their proportional ownership of the fund has remained constant",
       "correct_answer":"C",
       "explanation":"A mutual fund investor\u0027s proportional ownership of the portfolio will decrease when they elect to receive distributions instead of reinvesting them."
    },
    {
       "id":36169,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investment company\u0027s registration statement must:",
       "choice_a":"Be filed before any offering becomes effective",
       "choice_b":"Contain detailed information on the officers and directors of the company",
       "choice_c":"Contain plans for borrowing, investing, and areas of concentration, if any",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The registration statement must contain all of the choices listed."
    },
    {
       "id":36170,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor has been dollar cost averaging into a mutual fund account for 24 months. The mutual fund shares have been consistently rising over the last two years. The investor will notice that:",
       "choice_a":"They have purchased more shares as the price has increased",
       "choice_b":"They have purchased the same number of shares",
       "choice_c":"They have purchased less shares as the price has increased",
       "choice_d":"They are losing money as their average price increases",
       "correct_answer":"C",
       "explanation":"The investor will notice that they have purchased fewer shares as the price of the mutual fund share has increased."
    },
    {
       "id":36168,
       "practice_test_id":4,
       "topic_id":5,
       "question":"An investment company has an NAV of $8 and is $7 offered. The cost to a customer would be:",
       "choice_a":"$7",
       "choice_b":"$7 + commission",
       "choice_c":"$8",
       "choice_d":"$8 + commission",
       "correct_answer":"B",
       "explanation":"This fund has to be a closed-end fund because the offer is lower than the NAV. The investor would pay $7 plus commission."
    },
    {
       "id":36166,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An aggressive growth fund has realized substantial appreciation in its portfolio and would like to send out the gains to the shareholders. The fund may do this type of distribution:",
       "choice_a":"Annually",
       "choice_b":"Quarterly",
       "choice_c":"Monthly",
       "choice_d":"As declared by the board of directors",
       "correct_answer":"A",
       "explanation":"A mutual fund may only send out capital gains distributions once per year."
    },
    {
       "id":36167,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An index fund:",
       "choice_a":"Follows the performance of a large market index",
       "choice_b":"May be tied to the S & P 500 or the Dow Jones Industrial",
       "choice_c":"Generally has low portfolio turnover which helps to keep the fund\u0027s expenses low",
       "choice_d":"All of the choices listed are correct",
       "correct_answer":"D",
       "explanation":"An index fund is all of the above."
    },
    {
       "id":36165,
       "practice_test_id":5,
       "topic_id":5,
       "question":"All of the following will reduce the NAV of a mutual fund except:",
       "choice_a":"A dividend distribution",
       "choice_b":"A sales charge",
       "choice_c":"A capital gain distribution",
       "choice_d":"Securities prices fall",
       "correct_answer":"B",
       "explanation":"A sales charge does not reduce the NAV of a mutual fund. It is a cost of distribution, which is borne by the investor."
    },
    {
       "id":36164,
       "practice_test_id":4,
       "topic_id":5,
       "question":"All of the following have their portfolios held in the separate account except:",
       "choice_a":"Variable annuity",
       "choice_b":"Variable life policy",
       "choice_c":"Universal variable life policy",
       "choice_d":"UIT",
       "correct_answer":"D",
       "explanation":"The portfolios of a UIT are held by the UIT and it, in turn, issues shares of beneficial interest to the investors."
    },
    {
       "id":36163,
       "practice_test_id":"",
       "topic_id":5,
       "question":"All of the following describe a breakpoint sale except:",
       "choice_a":"A registered representative trying to earn larger commissions by recommending purchase of fund shares just below the breakpoint",
       "choice_b":"A registered representative spreading out a large sum of money over different families of funds",
       "choice_c":"A registered representative notifying an investor of the availability of a sales charge reduction when he is investing a large sum of money which puts him close to the breakpoint",
       "choice_d":"None of the choices listed",
       "correct_answer":"C",
       "explanation":"According to the law, a registered representative must always notify an investor of the availability of a breakpoint when the investor invests enough money to put him close to the breakpoint."
    },
    {
       "id":36162,
       "practice_test_id":"",
       "topic_id":5,
       "question":"All of the following create a tax liability for a mutual fund investor except:",
       "choice_a":"The fund sends out a dividend which the investor reinvests in the fund",
       "choice_b":"The investor redeems shares at an NAV higher than their average cost",
       "choice_c":"The fund sends out a capital gain",
       "choice_d":"The investor signs a letter of intent for a large dollar amount",
       "correct_answer":"D",
       "explanation":"All of the choices listed create a tax liability, except signing a letter of intent."
    },
    {
       "id":39452,
       "practice_test_id":5,
       "topic_id":5,
       "question":"One of the ways in which closed-end investment companies differ from open-end investment companies is in their ability to do which of the following?",
       "choice_a":"Issue preferred shares of stock",
       "choice_b":"Issue common shares of stock.",
       "choice_c":"Act as a lending agent to lend money.",
       "choice_d":"Operate as a non-diversified management company.",
       "correct_answer":"A",
       "explanation":"Open-end investment companies can issue one class of common shares only, while closed-end companies can issue both common and preferred shares of stock. Both open and closed-end investment companies can lend money under certain circumstances, and both can operate as either a diversified or non-diversified management company."
    },
    {
       "id":36647,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A corporation is making a public offering of one million shares and has designated that 200,000 shares be directed to employees of the company. What will the total amount of shares outstanding be as a result of this offering?",
       "choice_a":"200,000.00",
       "choice_b":"800,000.00",
       "choice_c":"1,000,000.00",
       "choice_d":"1,200,000.00",
       "correct_answer":"C",
       "explanation":"1,000,000 shares will be outstanding as a result of the offering. Stock purchased by employees is still outstanding stock"
    },
    {
       "id":36648,
       "practice_test_id":"",
       "topic_id":6,
       "question":"All of the following are required to be included in a preliminary prospectus, according the Federal Acts, except:",
       "choice_a":"A written statement in red on the left border of a preliminary prospectus (red herring) that says that the prospectus may be subject to changes.",
       "choice_b":"The purpose for which the funds that are being raised will be used.",
       "choice_c":"The final offering price.",
       "choice_d":"The financial status and history of the company.",
       "correct_answer":"C",
       "explanation":"The final offering price is not in the preliminary prospectus"
    },
    {
       "id":36649,
       "practice_test_id":2,
       "topic_id":6,
       "question":"All of the following take place during the cooling-off period, except: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The due diligence meeting. </li><li>The issuance of a red herring. </li><li>Stabilization of the issue. </li><li> \u0027Blue-skying\u0027 of the issue.</li></ol>",
       "choice_a":"I only.",
       "choice_b":"I and II only.",
       "choice_c":"III only.",
       "choice_d":"II only.",
       "correct_answer":"C",
       "explanation":"An issue is not stabilized until it is trading in the secondary market."
    },
    {
       "id":36650,
       "practice_test_id":3,
       "topic_id":6,
       "question":"The price at which a new issue of corporate stock will be sold to the public will usually be determined by all of the following, except:",
       "choice_a":"The earnings history of the company.",
       "choice_b":"The past dividend payment record of the company.",
       "choice_c":"A comparison with other corporations in the same industry.",
       "choice_d":"The selling group\u0027s decision as to what the offering price should be.",
       "correct_answer":"D",
       "explanation":"The selling group does not determine the price at which the securities will be sold. They are only allowed to sell the security that is being offered."
    },
    {
       "id":36651,
       "practice_test_id":4,
       "topic_id":6,
       "question":"In an underwriting of a new issue by a syndicate, which of the following is true?",
       "choice_a":"The underwriting spread is larger than the selling concession.",
       "choice_b":"The selling concession is larger than the underwriting spread.",
       "choice_c":"The reallowance is larger than the underwriting spread.",
       "choice_d":"The reallowance is larger than the selling concession.",
       "correct_answer":"A",
       "explanation":"The underwriting spread is larger than the selling concession. The underwriting spread contains the selling concession."
    },
    {
       "id":36652,
       "practice_test_id":"",
       "topic_id":6,
       "question":"In a combined offering who receives the proceeds of the sale?",
       "choice_a":"The issuer",
       "choice_b":"A selling group of stockholders",
       "choice_c":"The issuer and a selling group of stockholders",
       "choice_d":"The issuer and investors who have exercised their rights.",
       "correct_answer":"C",
       "explanation":"In a combined offering the issuing corporation and a selling group of stockholders receive the proceeds from the sale."
    },
    {
       "id":36653,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The SEC rule covering the sale of restricted securities by an officer of a corporation is:",
       "choice_a":144,
       "choice_b":146,
       "choice_c":147,
       "choice_d":"15c3-3.",
       "correct_answer":"A",
       "explanation":"Rule 144 covers the sale of restricted securities by an officer of the issuer."
    },
    {
       "id":36654,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A Tier 2 Regulation A offering pertains to:",
       "choice_a":"An intrastate offering of securities",
       "choice_b":"An offering of bonds",
       "choice_c":"An offering of $50,000,000 or less",
       "choice_d":"An offering of $30,000,000 or less",
       "correct_answer":"C",
       "explanation":"A Tier 2 regulation A offering covers an offering of $50,000,000 or less in a 12 month period"
    },
    {
       "id":36655,
       "practice_test_id":"",
       "topic_id":6,
       "question":"For an insider to sell unregistered stock under an exemption from registration with the SEC, a \u0022Form 144 Notice of Offering\u0022, which contains certain information must be filed with the SEC. The insider can sell securities during the period of time in which the 144 Notice of Offering is effective, which is:",
       "choice_a":"60 days.",
       "choice_b":"6 months.",
       "choice_c":"90 days.",
       "choice_d":"One year.",
       "correct_answer":"C",
       "explanation":"An insider may sell securities under rule 144 for 90 days."
    },
    {
       "id":36656,
       "practice_test_id":2,
       "topic_id":6,
       "question":"Which of the following would be nonexempt securities, according to the Securities Act of 1933?",
       "choice_a":"U.S. Government and municipal securities.",
       "choice_b":"Securities of a publicly held finance company.",
       "choice_c":"Securities of a small business investment company.",
       "choice_d":"Securities of a nonprofit benevolent association.",
       "correct_answer":"B",
       "explanation":"The publicly held finance company would most likely be non exempt and would be required to register under The Securities Act of 1933."
    },
    {
       "id":36657,
       "practice_test_id":3,
       "topic_id":6,
       "question":"After the closing date of the syndicate, a broker/dealer must wait how many days before extending credit on a new issue if the broker/dealer has participated in the distribution of that issue?",
       "choice_a":120,
       "choice_b":60,
       "choice_c":45,
       "choice_d":30,
       "correct_answer":"D",
       "explanation":"Credit may not be extended on new issues for 30 days"
    },
    {
       "id":36658,
       "practice_test_id":4,
       "topic_id":6,
       "question":"When an issuer is in the process of raising additional capital they can do a preemptive rights offering. The advantages to the company\u0027s existing shareholders include all of the following except:",
       "choice_a":"Right to buy new shares below the CMV",
       "choice_b":"Right to sell existing shares back to the issuer",
       "choice_c":"Right to sell the rights in the secondary market",
       "choice_d":"Right to maintain a proportional investment in the company",
       "correct_answer":"B",
       "explanation":"Subscription or preemptive rights are a way for the issuer to raise new capital from existing shareholders."
    },
    {
       "id":36660,
       "practice_test_id":5,
       "topic_id":6,
       "question":"XYZ is a publicly traded company seeking additional capital to fund an expansion of its production facilities. Which of the following would be a suitable way for the company to sell equity to a venture capital firm?",
       "choice_a":"Regulation S offering",
       "choice_b":"Best effort underwriting",
       "choice_c":"A PIPE transaction",
       "choice_d":"A firm commitment underwriting",
       "correct_answer":"C",
       "explanation":"Since XYZ is a publicly traded company wanting to raise new capital through the sale of equity to one firm a PIPE transaction would be the most suitable way to sell the securities. A PIPE transaction is a private investment in a public equity. In This case XYZ, a publicly traded company, will sell XYZ stock to the venture capital firm through a private placement."
    },
    {
       "id":36662,
       "practice_test_id":"",
       "topic_id":6,
       "question":"ABC Tool Co. an aerospace manufacturer is coming public next week. There is a lot of interest in the shares as the company is one of the leaders in the field. Which of the following could purchase shares of ABC during the offering?",
       "choice_a":"The manager of an ERISA regulated pension plan for the benefit of the plan members",
       "choice_b":"A principal of the broker dealer buying the shares in the firm\u0027s trading account to fill customer orders in the secondary market",
       "choice_c":"An agent of the broker dealer who is allowed to purchase 500 shares as a bonus",
       "choice_d":"The son of the broker dealer\u0027s partner",
       "correct_answer":"A",
       "explanation":"Of the choices listed only the manager of the ERISA pension plan may buy the shares for the benefit of the plan members. Employees of broker dealers and their immediate family are restricted from purchasing shares in the offering."
    },
    {
       "id":36664,
       "practice_test_id":"",
       "topic_id":6,
       "question":"New Growth Broker Dealers is underwriting KLM Techno, Inc. A new offering coming to market to be listed on the NASDAQ. The firm and its agents are excited about the prospects for the company. To gauge the demand for the shares, the firm would send:",
       "choice_a":"a red herring",
       "choice_b":"an offering circular",
       "choice_c":"a final prospectus",
       "choice_d":"a research report",
       "correct_answer":"A",
       "explanation":"To determine the level of interest in a new issue the firm would send out a red herring also known as a preliminary prospectus. The preliminary prospectus must be sent in hard copy."
    },
    {
       "id":36666,
       "practice_test_id":1,
       "topic_id":6,
       "question":"An agent at XYZ Broker Dealers, receives a call from an investment advisory client inquiring about Super Chips Inc., a computer chip company that XYZ is taking public next week. The advisor wants to purchase 500 shares of the offering for one of his clients. The interest in Super Chips is strong and the common stock is expected to open at a premium when trading begins. Which of the following is true?",
       "choice_a":"The advisor may not purchase the shares Super Chips for the client",
       "choice_b":"The agent must speak to the client and get the client\u0027s authorization to purchase Super Chips",
       "choice_c":"The agent must speak to the client to ensure that the client is not a restricted person",
       "choice_d":"The agent must obtain a representation by the advisor that the client is not a restricted person",
       "correct_answer":"D",
       "explanation":"When a third party with discretionary authority over a client\u0027s account wishes to purchase shares of a new issue on behalf of that client, the third party must provide a representation that the client is not a restricted person. In this case, it is the responsibility of the advisor placing the order."
    },
    {
       "id":36667,
       "practice_test_id":5,
       "topic_id":6,
       "question":"XYA, a manufacturer of computer circuit boards, has $50,000,000 worth of subordinated debentures outstanding. Each debenture carries an interest rate of 6.5% and has warrants attached to the debenture to purchase 5 shares of XYA at $25 per share. XYA\u0027s stock is trading in the marketplace at $28 per share and the warrants are about to expire. The company would expect to receive proceeds of:",
       "choice_a":"$5,000,000",
       "choice_b":"$7,500,000",
       "choice_c":"$6,250,000",
       "choice_d":"$7,000,000",
       "correct_answer":"C",
       "explanation":"There are 50,000 $1,000 par bonds (50,000,000 / 1000) outstanding each bond has warrants attached to purchase 5 shares of stock at $25 per share. The company would expect that all of the warrants will be exercised as the warrants are in the money and about to expire. As a result the company would expect to  issue 250,000 new shares at $25 and receive proceeds of $6,250,000."
    },
    {
       "id":36668,
       "practice_test_id":1,
       "topic_id":6,
       "question":"XYA, a manufacturer of computer circuit boards, has $50,000,000 worth of subordinated debentures outstanding. Each debenture carries an interest rate of 6.5% and has warrants attached to the debenture to purchase 5 shares of XYA at $25 per share. XYA\u0027s stock is trading in the marketplace at $28 per share and the warrants are about to expire. How many new shares can XYA reasonably expect to issue?",
       "choice_a":"50,000",
       "choice_b":"250,000",
       "choice_c":"500,000",
       "choice_d":"25,000",
       "correct_answer":"B",
       "explanation":"There are 50,000 $1,000  par bonds (50,000,000 / 1000) outstanding each bond has warrants attached to purchase 5 shares of stock at $25 per share. The company would expect that all of the warrants will be exercised as the warrants are in the money and about to expire. As a result the company would expect to issue 250,000 new shares."
    },
    {
       "id":36669,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An investor in Colorado purchases securities as part of a Rule 147 offering. When may the investor sell the securities to a resident of Texas?",
       "choice_a":"6 months from the date he paid for the trade",
       "choice_b":"6 months from the date he purchased the securities",
       "choice_c":"6 months from the date he received his certificate",
       "choice_d":"6 months from the date the offering was completed",
       "correct_answer":"D",
       "explanation":"An investor who purchases securities as part of a Rule 147 may sell the securities to a resident of another state 6 months from the date the offering was completed."
    },
    {
       "id":36670,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A large multinational corporation is selling a new issue of securities to investors in Europe. Which of the following is true?",
       "choice_a":"The securities must be registered with The SEC",
       "choice_b":"The securities must be an offering of debt only",
       "choice_c":"This is an exempt transaction and the securities need not register with The SEC",
       "choice_d":"Prior to offering the securities for sale FINRA\u0027s corporate finance department must issue an exemption",
       "correct_answer":"C",
       "explanation":"The issuer is selling securities in a foreign country to non US residents as such this is an exempt transaction and the securities do not need to be registered with The SEC."
    },
    {
       "id":36671,
       "practice_test_id":2,
       "topic_id":6,
       "question":"All of the following would require the approval of stockholders pursuant to SEC Rule 145 except: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>New shares are issued under the terms of a 3:1 stock split</li><li>XYZ exchanges its shares for all shares of ABC</li><li>TRY offers its shares in exchange for the assets of another company</li><li>A change in the par value of stock after a stock split</li></ol>",
       "choice_a":"I only",
       "choice_b":"II and III",
       "choice_c":"I and IV",
       "choice_d":"II only",
       "correct_answer":"C",
       "explanation":"SEC Rule 145 regulates certain merger, acquisition and reorganization of securities as well as the exchange of corporate assets for securities. While stockholders do vote on stock splits it is not under SEC Rule 415."
    },
    {
       "id":36672,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The rules governing the issuing of corporate securities to the public are covered under which act?",
       "choice_a":"Act of 1929",
       "choice_b":"Act of 1933",
       "choice_c":"Act of 1934",
       "choice_d":"Act of 1935",
       "correct_answer":"B",
       "explanation":"The Act of 1933 was the first legislation Congress passed to address the regulation of the securities markets; and it dealt with the primary, or new issue, market. The Act of 1934 dealt with the secondary market places and the Act of 1935 regulated public utility holding companies."
    },
    {
       "id":36673,
       "practice_test_id":2,
       "topic_id":6,
       "question":"Which of the following is a non-exempt issuer according to the Act of 1933?",
       "choice_a":"ABC, Inc",
       "choice_b":"The State of NY",
       "choice_c":"The City of Miami",
       "choice_d":"The US government",
       "correct_answer":"A",
       "explanation":"In order to become a publicly traded entity a non-exempt security must file a registration statement with the SEC. Most corporate entities are non-exempt. Exempt securities do not need to file with the SEC. Examples of exempt issuers are municipalities and national governments."
    },
    {
       "id":36674,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following activities may an underwriter engage in during the cooling off period? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Blue Sky the issue </li><li>Obtain indications of interest </li><li>Send out red herrings</li></ol>",
       "choice_a":"II only",
       "choice_b":"I, II",
       "choice_c":"II, III",
       "choice_d":"I, II, III",
       "correct_answer":"D",
       "explanation":"During the cooling off period an underwriter cannot solicit sales, but they can obtain indications of interest from investors, which will help them gauge the demand for the new issue. Any customer who gives an indication of interest is given a preliminary prospectus, or red herring. The underwriter will also use the time during the cooling off period to register the securities in the states in which they will be sold, otherwise known as Blue Skying the issue."
    },
    {
       "id":36675,
       "practice_test_id":"",
       "topic_id":6,
       "question":"All of the following are true when a customer gives an indication of interest for a new issue of corporate securities except:",
       "choice_a":"The indication is not binding on the customer",
       "choice_b":"The indication is binding on the broker dealer",
       "choice_c":"The customer will receive a preliminary prospectus",
       "choice_d":"The red herring will not contain the price of the securities",
       "correct_answer":"B",
       "explanation":"Indications of interest are not binding on the part of the customer or the broker dealer. They are used solely to help the underwriter determine demand. When a customer gives an indication of interest he will receive a preliminary prospectus (red herring) which will not contain the final offering price. The final price will be stated in the final prospectus."
    },
    {
       "id":36676,
       "practice_test_id":3,
       "topic_id":6,
       "question":"ECS, Inc., a non-exempt issuer, wishes to issue securities to the public for the first time. All of the following statements are true except:",
       "choice_a":"ECS, Inc. must file a registration statement with the SEC",
       "choice_b":"The cooling off period for ECS, Inc. will last a maximum of 20 days",
       "choice_c":"ECS, Inc. securities will have to be registered in the states in which they will be offered",
       "choice_d":"The preliminary prospectus for ECS, Inc. will be given to prospective buyers",
       "correct_answer":"B",
       "explanation":"The cooling off period for a non-exempt security begins when the issuer\u0027s registration statement is filed with the SEC. It is a minimum of 20 days, and could be longer as the SEC deems necessary. During the cooling off period the issuer\u0027s securities are registered in the states they will be offered in (Blue Sky the issue) and the underwriter will garner indications of interest from prospective investors, who will then receive a preliminary prospectus (red herring)."
    },
    {
       "id":36677,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following are true regarding a final prospectus for a new issue of corporate securities? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The final prospectus must be delivered to all purchasers </li><li>If the prospectus is posted on the SEC website it is considered to have been delivered to the purchasers </li><li> The prospectus will contain the date and price of the offering </li><li> The prospectus will contain the underwriter\u0027s discount</li></ol>",
       "choice_a":"I, III",
       "choice_b":"III, IV",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"A final prospectus contains the date and price of the offering, as well as information regarding how the underwriters are compensated for their services, and must be delivered to all purchasers of a new issue. As per the \u0022access equals delivery\u0022 rule, if the prospectus is posted on the SEC website for inspection it is considered delivered to the customer."
    },
    {
       "id":36678,
       "practice_test_id":3,
       "topic_id":6,
       "question":"When a corporate issuer is granted an effective date by the SEC it means that:",
       "choice_a":"The SEC has approved the securities for sale to the public",
       "choice_b":"The SEC has reviewed the documents and checked for accuracy",
       "choice_c":"The SEC has received the required documentation",
       "choice_d":"The SEC guarantees the integrity of the new issue",
       "correct_answer":"C",
       "explanation":"The SEC disclaimer specifically states that they do not endorse or guarantee anything that relates to the issuer or its securities. When the SEC ends the cooling off period by granting the issuer an effective date it is because they have received all the necessary documentation from the issuer."
    },
    {
       "id":36679,
       "practice_test_id":"",
       "topic_id":6,
       "question":"All of the following statements are true when an issuer runs a tombstone ad except:",
       "choice_a":"The tombstone must be filed with the SEC",
       "choice_b":"The tombstone may run in a National newspaper during the cooling off period",
       "choice_c":"The tombstone will list the names of the underwriters and where to obtain a prospectus",
       "choice_d":"A tombstone is not considered an offer to sell securities",
       "correct_answer":"A",
       "explanation":"Tombstone ads are announcements only and may be run during the cooling off period. The ad contains the names of the underwriters, where to obtain a prospectus and a disclaimer that this is not a solicitation to buy. It does not need to be filed with the SEC."
    },
    {
       "id":36680,
       "practice_test_id":"",
       "topic_id":6,
       "question":"According to FINRA Rule 5130, when a broker dealer is acting as an underwriter for an issuer of securities they must make a bonafide distribution of the securities being offered, and are therefore prohibited from which of the following?",
       "choice_a":"Withholding securities for their own account",
       "choice_b":"Withholding securities for another broker dealer",
       "choice_c":"Withholding securities for the account of a registered representative",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"In making a bonafide distribution of a new issue the underwriter is prohibited from withholding securities for their own account, accounts of other broker dealers or FINRA members, and employees or financially dependent family members of the broker dealer."
    },
    {
       "id":36681,
       "practice_test_id":"",
       "topic_id":6,
       "question":"In an IPO of corporate securities the investment banker is responsible for all of the following except:",
       "choice_a":"Marketing the issuers securities to the public",
       "choice_b":"Establishing the terms of the offering",
       "choice_c":"Buying the securities from the issuer and reselling them to the public",
       "choice_d":"Determining the underwriter\u0027s compensation",
       "correct_answer":"D",
       "explanation":"In an IPO of non-exempt securities the investment banker, or underwriter, is responsible for establishing the terms of the offering and the marketing and selling of the issuer\u0027s securities. The issuer is responsible for determining the duties of the underwriter and how they will be compensated."
    },
    {
       "id":36682,
       "practice_test_id":"",
       "topic_id":6,
       "question":"In an initial offering of non-exempt securities which of the following is the responsibility of the issuer?",
       "choice_a":"Filing a registration statement with the SEC",
       "choice_b":"Marketing the securities to the public",
       "choice_c":"Setting the terms of the offering",
       "choice_d":"Creating and distributing a red herring",
       "correct_answer":"A",
       "explanation":"The issuer is responsible for filing the registration statement with the SEC, registering the securities in the states in which the securities will be offered and determining the underwriters responsibilities and compensation. The underwriter\u0027s duties include setting the terms of the offering, marketing the securities and delivering the red herring."
    },
    {
       "id":36683,
       "practice_test_id":4,
       "topic_id":6,
       "question":"Which of the following is/are true with regard to a hot issue of securities? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> A hot issue trades at an immediate premium to its offering price the first day of trading </li><li>Financially dependent family members of the broker dealer\u0027s employees are prohibited from buying hot issues </li><li>Broker dealers are prohibited from withholding hot issues for their own accounts </li><li>Conditional persons who have never purchased a new issue may buy as long as the amount is insubstantial</li></ol>",
       "choice_a":"I, II",
       "choice_b":"I, III",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"A hot issue is a new issue that trades at an immediate premium to its public offering price the first day of trading. Broker dealers, their employees and their financially dependent family members are all prohibited from purchasing hot issues. Conditional persons may be able to purchase a hot issue if they have a history of buying new issues and the amount is not substantial."
    },
    {
       "id":36684,
       "practice_test_id":"",
       "topic_id":6,
       "question":"All of the following are types of underwriting commitments except:",
       "choice_a":"Firm Commitment",
       "choice_b":"Not held Commitment",
       "choice_c":"Mini max commitment",
       "choice_d":"All or none commitment",
       "correct_answer":"B",
       "explanation":"When acting as an underwriter for an issuer the underwriter can give a firm commitment or a best efforts commitment. Both mini max and all or none are types of best efforts commitments. Not held refers to a type of order, not a type of underwriting commitment."
    },
    {
       "id":36685,
       "practice_test_id":"",
       "topic_id":6,
       "question":"All of the following a regulated under the Act of 1933 except:",
       "choice_a":"An initial public offering",
       "choice_b":"A registered secondary offering",
       "choice_c":"An arbitrated offering",
       "choice_d":"A subsequent primary offering",
       "correct_answer":"C",
       "explanation":"The Act of 1933 regulates the primary market. IPOs, registered secondary offerings and subsequent primary offerings are all primary market transactions. There is no arbitrated offering."
    },
    {
       "id":36686,
       "practice_test_id":4,
       "topic_id":6,
       "question":"A broker dealer that is acting as a selling group member in an initial public offering of corporate securities is paid:",
       "choice_a":"The spread",
       "choice_b":"The total takedown",
       "choice_c":"The underwriting fee",
       "choice_d":"The selling concession",
       "correct_answer":"D",
       "explanation":"When acting as a selling group member the broker dealer assumes no management responsibilities and no risk for the unsold securities and therefore is not entitled to the management fee or the underwriting fee."
    },
    {
       "id":36687,
       "practice_test_id":"",
       "topic_id":6,
       "question":"When acting as a syndicate manager in selling a new issue of corporate securities, how will a broker dealer be compensated?",
       "choice_a":"It will be paid a manager\u0027s fee",
       "choice_b":"It will be paid the underwriting fee",
       "choice_c":"It will be paid the selling concession",
       "choice_d":"It will be paid the underwriting spread",
       "correct_answer":"D",
       "explanation":"When acting as a syndicate manager in an offering of corporate securities the broker dealer will be paid the underwriting spread; which includes the manager\u0027s fee, the underwriting fee and the selling concession."
    },
    {
       "id":36688,
       "practice_test_id":"",
       "topic_id":6,
       "question":"In an offering of corporate securities, which of the following factors determine the size of the underwriting spread? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The number of registered reps the syndicate manager employs </li><li>The type of securities being offered to the public </li><li>The demand for the new issue </li><li>The overall size of the offering</li></ol>",
       "choice_a":"I, III",
       "choice_b":"II, IV",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"The size of the underwriting spread is based on several factors including: the type of securities; the demand for the securities; the size of the offering; the quality of the securities; the quality of the issuer and the type of underwriting agreement the issuer and broker dealer entered into. The number of registered reps employed by the underwriter is not a factor."
    },
    {
       "id":36689,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following is true with regards to Rule 144?",
       "choice_a":"It allows small businesses to file an abbreviated registration statement with the SEC when issuing securities",
       "choice_b":"It sets limitations on how many shares of control stock can be sold by control persons",
       "choice_c":"It only allows for the sale of private placement shares by accredited investors",
       "choice_d":"It eliminates the need for a cooling off period with SEC",
       "correct_answer":"B",
       "explanation":"Rule 144 determines the procedures and limits for the sale of restricted securities (Reg D securities) and the sale of control stock by control persons. It allows the seller to liquidate either 1% of the outstanding shares or the average of the prior 4 weeks trading volume, whichever is greater, every 90 days."
    },
    {
       "id":36690,
       "practice_test_id":5,
       "topic_id":6,
       "question":"ABC corporation located in Bakersfield, CA, wishes to make an offer of its securities only to the residents of California. Which of the following are true statements? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> ABC can make the securities available through a Rule 147 offering </li><li>ABC will not have to file a standard registration statement with the SEC </li><li>80% of the proceeds of the offering must be used in California </li><li>Buyers of ABC securities will have a 6 month resale restriction</li></ol>",
       "choice_a":"I only",
       "choice_b":"II, III",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"When offering securities to residents of one state an issuer may do so through a Rule 147 Intrastate Offering. Rule 147 allows the issuer to forego SEC registration provided 100% of the investors are residents; the company has the corporate headquarters in the state, and meets the 80% tests. Furthermore, resident buyers may not resell their securities to non-residents for a period of 6 months."
    },
    {
       "id":36691,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A member firm offering a private placement may allow offering memoranda to be viewed online, if: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The site is available to all investors </li><li> The visitors are required to submit a questionnaire </li><li>The site has been registered with the SEC as a funding portal</li><li> Access to the pages are protected by passwords</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"A member firm may allow online access to private placement offering memoranda if it requires visitors to fill out and submit a qualification questionnaire. Once the member firm has qualified the investor as accredited or higher, the member may then issue the investor a password to gain access to the offering materials. Access to the material must be protected by a password."
    },
    {
       "id":36692,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A broker dealer who is underwriting a new equity issue, receives an order to purchase the shares for an unknown client of a bank. Which of the following is true?",
       "choice_a":"The broker dealer must ascertain the identity of the final purchaser of the security",
       "choice_b":"The broker dealer must open an account for the ultimate purchaser of the security",
       "choice_c":"The broker dealer must reject the order if the bank is not part of the selling group",
       "choice_d":"The broker dealer must receive notification from the banking intermediary that the purchaser is not restricted",
       "correct_answer":"D",
       "explanation":"When a FINRA member receives an order for a new issue from a third party, the broker dealer is required to obtain the assurance from the financial intermediary that the ultimate purchaser of the securities is not restricted from purchasing new issues. The firm does not need to know the identity of the purchaser nor are they required to open an account for the purchaser."
    },
    {
       "id":36693,
       "practice_test_id":2,
       "topic_id":6,
       "question":"A hedge fund has raised a substantial amount of capital from both restricted and non restricted investors. If the hedge fund receives an allocation of a new issue, under the carve out procedure, what is the maximum amount of the allocation that can be for the benefit of the restricted investors?",
       "choice_a":"5 percent",
       "choice_b":"3 percent",
       "choice_c":"10 percent",
       "choice_d":"15 percent",
       "correct_answer":"C",
       "explanation":"The carve out procedure states that when a fund has investors who are restricted from purchasing a new issue, the fund may allocate a maximum of 10 percent of their allocation for the benefit of restricted persons."
    },
    {
       "id":39478,
       "practice_test_id":3,
       "topic_id":6,
       "question":"As participants in a firm commitment underwriting agreement, the underwriters know that:",
       "choice_a":"they will be acting as an agent for the issuer, and are only committed to make their best effort to sell all of the securities offered.",
       "choice_b":"they will be acting as principals and therefore have contracted to buy the securities from the issuer.",
       "choice_c":"they are not at risk for any securities left unsold at the conclusion of the underwriting.",
       "choice_d":"if they cannot sell all the securities to the public, the issuer will not be able to raise all of the capital it needed to raise.",
       "correct_answer":"B",
       "explanation":"In a firm commitment, the underwriters are acting as principals rather than agents. They contract with the issuer to buy all of the securities from them and thus in this type of underwriting, it is the underwriters who are at risk for any shares they cannot sell to the public, not the issuer. In this underwriting arrangement the issuer knows that ultimately all of the securities will be sold and all of the capital they need will be raised."
    },
    {
       "id":39479,
       "practice_test_id":4,
       "topic_id":6,
       "question":"In order to have a new issue registration become effective at both the state and federal level together, an issuer for a new IPO files the offering with the state at the same time that it files with the Securities and Exchange Commission (SEC). At the state level, this is known as a:",
       "choice_a":"coordination filing.",
       "choice_b":"qualification filing.",
       "choice_c":"notice filing.",
       "choice_d":"dual filing.",
       "correct_answer":"A",
       "explanation":"There are three types of state registration filings; coordination, qualification, and notice. The type of state filing that allows the issuer of an IPO to file with the state at the same time it files with the SEC is known as coordination. With a coordination filing, registration at the state level is effective at the time the federal registration becomes effective."
    },
    {
       "id":39481,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Regarding different types of securities offerings, which of the following is not true?",
       "choice_a":"In a secondary offering, underwriting proceeds can go to investors who are selling their shares.",
       "choice_b":"In a secondary offering, underwriting proceeds can go to employees who are selling their shares.",
       "choice_c":"In an initial public offering (IPO), underwriting proceeds will go to the issuer.",
       "choice_d":"In a primary additional issue, underwriting proceeds will go to the existing stockholders.",
       "correct_answer":"D",
       "explanation":"In all primary offerings, new issue (IPO), or additional issue, underwriting proceeds go to the issuing company. It is in secondary offerings where proceeds will go to existing shareholders who may be investors or sometimes employees of the issuer."
    },
    {
       "id":39484,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following characterizes a split offering?",
       "choice_a":"Shares are being sold by the issuer and existing shareholders.",
       "choice_b":"Shares are being sold by existing shareholders only.",
       "choice_c":"Shares are being sold by the issuing corporation only.",
       "choice_d":"Shares are being sold to existing shareholders only.",
       "correct_answer":"A",
       "explanation":"When shares are issued to the public in a split offering, shares are being sold by both the issuing corporation and existing shareholders."
    },
    {
       "id":34976,
       "practice_test_id":2,
       "topic_id":7,
       "question":"A bullish investor would establish which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Credit put spread </li><li>Long straddle </li><li>Debit call spread </li><li>Short straddle</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"B",
       "explanation":"A debit call spread and a credit put spread are both bullish. Straddles are neither bullish nor bearish."
    },
    {
       "id":34977,
       "practice_test_id":3,
       "topic_id":7,
       "question":"A customer establishes the following position: <ol style='margin-left: 25px; list-style-type: disc;'><li>Sold 10 ABC Oct 50 puts at 4</li><li>Bought 10 ABC Oct 40 puts at 1</li></ol>Their maximum gain is:",
       "choice_a":"$3,000",
       "choice_b":"$1,000",
       "choice_c":"$4,000",
       "choice_d":"$7,000",
       "correct_answer":"A",
       "explanation":"On a credit spread your maximum gain is always the credit received."
    },
    {
       "id":34978,
       "practice_test_id":4,
       "topic_id":7,
       "question":"A customer has sold 5 ABC Oct 45 puts at 3.10. Their maximum loss is:",
       "choice_a":"$1,550",
       "choice_b":"$20,950",
       "choice_c":"Unlimited",
       "choice_d":"$24,050",
       "correct_answer":"B",
       "explanation":"Their maximum loss is $20,950 found by taking the strike price - premium 45- 3.10 = 41.90 x 500= $20,950"
    },
    {
       "id":34979,
       "practice_test_id":5,
       "topic_id":7,
       "question":"A customer has sold short 1000 XYZ at 38 and sold 10 XYZ May 35 puts at 3.20. The customer will have a maximum gain of:",
       "choice_a":"$41,200",
       "choice_b":"$6,200",
       "choice_c":"$31,800",
       "choice_d":"Unlimited",
       "correct_answer":"B",
       "explanation":"The investor\u0027s maximum gain is found by subtracting the strike price from their break even 41.20 - 35 = 6.20 x 1000 =$6,200."
    },
    {
       "id":34980,
       "practice_test_id":"",
       "topic_id":7,
       "question":"A MSFT June 50 call is in the money when MSFT trades at which of the following prices?",
       "choice_a":"$48.00",
       "choice_b":"$49.00",
       "choice_c":"$50.00",
       "choice_d":"$51.00",
       "correct_answer":"D",
       "explanation":"A call is in-the-money when the underlying instrument trades ABOVE the strike price."
    },
    {
       "id":34981,
       "practice_test_id":"",
       "topic_id":7,
       "question":"A MSFT June 65 put @3 has how much intrinsic value with MSFT @65?",
       "choice_a":"$0",
       "choice_b":"$2",
       "choice_c":"$65",
       "choice_d":"$3",
       "correct_answer":"A",
       "explanation":"There is no value in the \u0022right to sell @65\u0022 when the stock is actually worth $65 per share. The $3 in this question would represent time value, since there is no intrinsic value at this point."
    },
    {
       "id":34982,
       "practice_test_id":1,
       "topic_id":7,
       "question":"All but which of the following are possible outcomes for options:",
       "choice_a":"Many investors will sell the options to another investor rather than exercise them",
       "choice_b":"Many investors will exercise their options by buying or selling the stocks involved",
       "choice_c":"Some options are allowed to expire, being neither bought nor sold",
       "choice_d":"Some options can be deposited with the SEC for exercising in the future, being postponed options",
       "correct_answer":"D",
       "explanation":"Options cannot be deposited with any company or held by any company or regulatory body for future purchases."
    },
    {
       "id":34983,
       "practice_test_id":"",
       "topic_id":7,
       "question":"All of the following are not false except:",
       "choice_a":"An investor who is long a straddle has the potential for an unlimited gain",
       "choice_b":"An investor who is short a naked put has the potential for an unlimited loss",
       "choice_c":"An investor who establishes a debit put spread is bearish",
       "choice_d":"An investor who establishes a credit call spread is bearish",
       "correct_answer":"B",
       "explanation":"All of the choices listed are true (not false) except an investor who is short a naked put does not have the potential for an unlimited loss."
    },
    {
       "id":34984,
       "practice_test_id":1,
       "topic_id":7,
       "question":"All XYZ Jan 60 Calls would be grouped within the same:",
       "choice_a":"Kind",
       "choice_b":"Type",
       "choice_c":"Class",
       "choice_d":"Series",
       "correct_answer":"D",
       "explanation":"All XYZ Jan 60 calls would be the same series of options."
    },
    {
       "id":34985,
       "practice_test_id":"",
       "topic_id":7,
       "question":"An IBM Mar 75 put @3 has how much time value with IBM @74?",
       "choice_a":"$1",
       "choice_b":"$3",
       "choice_c":"$2",
       "choice_d":"$0",
       "correct_answer":"C",
       "explanation":"There is $1 of intrinsic value, so the rest of the $3 premium represents time value."
    },
    {
       "id":34987,
       "practice_test_id":"",
       "topic_id":7,
       "question":"An investor has sold short 500 GET at 29.12 and sold 5 GET August 30 puts at 4.05. What is the investor\u0027s maximum gain?",
       "choice_a":"Unlimited",
       "choice_b":"$3,170",
       "choice_c":"$1,585",
       "choice_d":"$317",
       "correct_answer":"C",
       "explanation":"The investor has sold the stock short at 29.12 and sold puts against the position at 4.05 for a total credit of 33.17 per share. If the stock declines the investor will be put the stock at 30. Therefore their maximum gain is 3.17 per share X 500 shares = $1,585 for the entire position."
    },
    {
       "id":34988,
       "practice_test_id":2,
       "topic_id":7,
       "question":"An investor buys 10 JTR April 60 calls at 4.10 and also buys 10 JTR April 60 puts at 5.05 when JTR is at 58.22. In April JTR closes at 67.30 and the investor closes out the position at its intrinsic value. What is the investor\u0027s gain or loss?",
       "choice_a":"$185 Gain",
       "choice_b":"$1,850 Gain",
       "choice_c":"$185 Loss",
       "choice_d":"$1,850 Loss",
       "correct_answer":"D",
       "explanation":"The investor is long the straddle and paid a total premium of 9.15 or $9,150 for the whole position. The intrinsic value of the call is 7.30 and the intrinsic value of the put is 0. The investor lost 1.85 X 1000 or $1,850 for the entire position."
    },
    {
       "id":34989,
       "practice_test_id":"",
       "topic_id":7,
       "question":"An investor buys 10 XYZ May 70 calls at 3.10 when XYZ is at 68. At expiration the stock is at 77 and the investor closes out the position at its intrinsic value. What is the profit or loss?",
       "choice_a":"$7,000 profit",
       "choice_b":"$7,000 loss",
       "choice_c":"$3,100 loss",
       "choice_d":"$3,900 profit",
       "correct_answer":"D",
       "explanation":"The options are worth $7,000 at expiration. They paid $3,100 to establish the position. Therefore the profit is $3,900."
    },
    {
       "id":34990,
       "practice_test_id":2,
       "topic_id":7,
       "question":"An investor buys 100 shares of ABC @50, and also buys an ABC Apr 55 call @2, and writes an ABC Apr 50 put @2.25. With ABC @56, he sells the stock and closes the options contracts at intrinsic value, for a",
       "choice_a":"gain of $275",
       "choice_b":"gain of $725",
       "choice_c":"loss of $275",
       "choice_d":"loss unlimited",
       "correct_answer":"B",
       "explanation":"In your T-chart, you should have $50 per share in the \u0022money out\u0022 column and $2 for the April 55 call. $2.25 is in the \u0022money in\u0022 column, as well as the $56 for the stock. To finish the question, place the intrinsic value of the call ($1) in the \u0022money in\u0022 column and the intrinsic value of the put (0) in the \u0022money out\u0022 column. The investor made $7.25 per share."
    },
    {
       "id":34991,
       "practice_test_id":"",
       "topic_id":7,
       "question":"An investor buys 1000 KO at $41.70 and sells 10 KO May $42.50 calls at $1.80. If KO goes to $47.20 and the investor has the options exercised against him. The investor will have a:",
       "choice_a":"$260 profit",
       "choice_b":"$7,300 profit",
       "choice_c":"$2,600 profit",
       "choice_d":"$730 profit",
       "correct_answer":"C",
       "explanation":"The investor sold 10 $42.50 calls at $1.80. Subtract the premium received from the price the investor paid for the stock, in this case $41.70 and you get the investor\u0027s breakeven of $39.90. Subtract the investor\u0027s breakeven from the strike price of the short call and you get the investor\u0027s maximum gain per share. 42.50 - 39.90 = 2.60. The investor\u0027s total profit for the position is therefore $2,600."
    },
    {
       "id":34992,
       "practice_test_id":5,
       "topic_id":7,
       "question":"An investor is long an IBM Mar 90 call @3. With IBM @94.75, the investor closes the option for its intrinsic value. He has a:",
       "choice_a":"Loss of $175",
       "choice_b":"Gain of $175",
       "choice_c":"Loss of $300",
       "choice_d":"Gain of $475",
       "correct_answer":"B",
       "explanation":"When the stock moves in the buyer\u0027s favor by more than the breakeven, the amount that it moves beyond the breakeven is the buyer\u0027s gain."
    },
    {
       "id":34993,
       "practice_test_id":3,
       "topic_id":7,
       "question":"An investor is short an IBM Mar 90 call @3. With the underlying security trading @92, she closes the contract for its intrinsic value. She has a",
       "choice_a":"Loss of $100",
       "choice_b":"Gain of $100",
       "choice_c":"Loss of $9,000",
       "choice_d":"Gain of $9,000",
       "correct_answer":"B",
       "explanation":"The seller wrote the contract for $3 per share, and closed it out by paying just $2 per share. There are 100 shares per contract, so the gain is $100."
    },
    {
       "id":34994,
       "practice_test_id":"",
       "topic_id":7,
       "question":"An investor is short an IBM May 80 put @3.50. With IBM @78, she closes the option for intrinsic value. She has a",
       "choice_a":"Gain of $150",
       "choice_b":"Loss of $350",
       "choice_c":"Gain of $350",
       "choice_d":"Loss of $150",
       "correct_answer":"A",
       "explanation":"The investor sold the contract for $350 and can buy it back/close it out for the intrinsic value of $2 per share or $200. The difference of $150 represents her gain."
    },
    {
       "id":34995,
       "practice_test_id":3,
       "topic_id":7,
       "question":"An investor purchases an XYZ Nov. 75 call in September at 4.15 when XYZ is 73.50. Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The option has $4.15 in time value </li><li>The investor wants to exercise the option </li><li> The investor\u0027s maximum loss is $4.15 </li><li>The option has no intrinsic value</li></ol>",
       "choice_a":"I, II, and III",
       "choice_b":"I, II, and IV",
       "choice_c":"II and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed are correct. Option buyers always want to be able to exercise the option and have a maximum loss equal to the premium paid. This option is out of the money and therefore has no intrinsic value."
    },
    {
       "id":34996,
       "practice_test_id":"",
       "topic_id":7,
       "question":"An investor sells 10 CSC Oct 75 puts at 5.30 to open. CSC trades down to 71 at expiration and the investor closes out the position at intrinsic value with a closing purchase. What is the investor\u0027s gain or loss?",
       "choice_a":"$1,300 loss",
       "choice_b":"$1,300 gain",
       "choice_c":"$300 loss",
       "choice_d":"$300 gain",
       "correct_answer":"B",
       "explanation":"The investor closes out the position at its intrinsic value of $4 with a closing purchase. The investor sold the puts at $5.30 so the investor made $1.30 per share or $1,300 for the entire position."
    },
    {
       "id":34997,
       "practice_test_id":"",
       "topic_id":7,
       "question":"An investor sells 12 IJK Nov 50 puts at 4.90 to open when IJK is at 48.30. At expiration IJK is at 46.40 and the investor closes out the position at its intrinsic value. Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor is bullish </li><li>The investor made a profit of $1,560 </li><li>The investor closed the position by purchasing the options </li><li>The investor lost money on the investment</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I, II, and III",
       "choice_d":"I, III and IV",
       "correct_answer":"C",
       "explanation":"The investor purchased the options back at expiration and realized a profit of $1,560. The investor sold the options at 4.90 and bought them back at 3.60, realizing a profit of 1.30 X 1200 = $1,560."
    },
    {
       "id":34998,
       "practice_test_id":5,
       "topic_id":7,
       "question":"An investor sells 12 OWG 22.50 calls at 3.04 to open when OWG is trading at 23.12. OWG trades up to 25.30 at expiration and the investor closes out the position at its intrinsic value with a closing purchase. What is the investor\u0027s gain or loss?",
       "choice_a":"$288 Gain",
       "choice_b":"$240 Gain",
       "choice_c":"$288 loss",
       "choice_d":"$240 loss",
       "correct_answer":"A",
       "explanation":"The investor made $288. The investor sold the options at $3.04 and bought them back at their intrinsic value of $2.80 therefore making a profit of 24 cents per share. 24 cents X 1200 shares = $288."
    },
    {
       "id":34999,
       "practice_test_id":"",
       "topic_id":7,
       "question":"An investor sells 2 ZAQ Nov 60 puts at 3.5 when ZAQ is at 62.70. ZAQ falls to 56.05 at expiration and the investor closes the position at its intrinsic value. What is their gain or loss?",
       "choice_a":"$90 gain",
       "choice_b":"$900 gain",
       "choice_c":"$90 loss",
       "choice_d":"$45 gain",
       "correct_answer":"C",
       "explanation":"The investor\u0027s breakeven was 56.50 found by subtracting the premium from the put\u0027s strike price. The stock closed at 56.05 so the investor lost 45 cents per share or $90 for the position."
    },
    {
       "id":35000,
       "practice_test_id":4,
       "topic_id":7,
       "question":"An investor sells 7 TGH April 45 calls at 4.15 to open when TGH is at $46.35. At expiration TGH closes $47.41 and the investor closes out the position at its intrinsic value. What is the investor\u0027s gain or loss?",
       "choice_a":"$1,218 gain",
       "choice_b":"$742 gain",
       "choice_c":"$1,960 loss",
       "choice_d":"$1,960 gain",
       "correct_answer":"A",
       "explanation":"The investor sold the calls at $4.15 and bought them back at 2.41 for a 1.74 profit. $1.74 X 700 = $1,218"
    },
    {
       "id":35001,
       "practice_test_id":"",
       "topic_id":7,
       "question":"An investor sells 7 TGH April 45 puts at 3.15 to open when TGH is at $46.35. At expiration TGH closes $43.11 and the investor closes out the position at its intrinsic value. What is the investor\u0027s gain or loss?",
       "choice_a":"$882 gain",
       "choice_b":"$882 loss",
       "choice_c":"$1,890 gain",
       "choice_d":"$1,890 loss",
       "correct_answer":"A",
       "explanation":"The investor sold the options at $3.15 and bought them back at $1.89, making $1.26 per share. $1.26 X 700 = $882"
    },
    {
       "id":35002,
       "practice_test_id":"",
       "topic_id":7,
       "question":"An investor sells 9 KIO April 45 puts at 2.15 to open when KIO is at $46.04. At expiration KIO closes $43.09 and the investor closes out the position at its intrinsic value. What is the investor\u0027s gain or loss?",
       "choice_a":"$216 gain",
       "choice_b":"$216 loss",
       "choice_c":"$1,719 loss",
       "choice_d":"$1,719 gain",
       "correct_answer":"A",
       "explanation":"The investor sold the options at 2.15 and bought them back at 1.91, making 24 cents. .24 x 900 = $216"
    },
    {
       "id":35003,
       "practice_test_id":4,
       "topic_id":7,
       "question":"An investor who anticipates stability, shorts a June 90 call @4 and a June 90 put @3.50. He closes both positions for their intrinsic value at expiration, when the underlying stock is trading at $111. What is the investor\u0027s gain or loss per share?",
       "choice_a":"$5 loss",
       "choice_b":"$13.50 loss",
       "choice_c":"$13.50 gain",
       "choice_d":"Unlimited",
       "correct_answer":"B",
       "explanation":"The investor would have had no loss if the stock moved by no more than $7.50 in either direction (breakeven). Since the stock moved by $21, the writer of the straddle loses the difference between $21 and $7.50 per share."
    },
    {
       "id":35004,
       "practice_test_id":"",
       "topic_id":7,
       "question":"An investor who is long 1000 shares of HJT stock at 56.22 sells 10 HJT DEC 55 calls at 3.05 to open against his long stock position. HJT increases to 59.30 by expiration and the investor closes out the option position at its intrinsic value and sells the stock at 59.30. What was the investor\u0027s gain or loss?",
       "choice_a":"$1,830 loss",
       "choice_b":"$1,830 gain",
       "choice_c":"$2,470 loss",
       "choice_d":"$2,470 gain",
       "correct_answer":"B",
       "explanation":"The investor purchased the stock at 56.22 and sold it at 59.30 for a gain of 3.08 per share. The investor also sold December 55 calls at 3.05 and bought them back at 4.30 for a loss of 1.25. When you net the gain on the stock position and the loss on the option position the investor made 1.83 per share found as follows: 3.08 &ndash; 1.25 = 1.83. The gain for the entire position is found as follows: 1.83 X 1000 = $1,830"
    },
    {
       "id":35005,
       "practice_test_id":"",
       "topic_id":7,
       "question":"An investor writes an XYZ Mar 75 put @4. With XYZ @74, he closes the contract for its intrinsic value. He has a",
       "choice_a":"Gain of $400",
       "choice_b":"Gain of $100",
       "choice_c":"Loss of $400",
       "choice_d":"Gain of $300",
       "correct_answer":"D",
       "explanation":"He sold the contract for $400 and can buy it back for just $100. The \u0022right to sell @75\u0022 is worth exactly $1 per share with the stock at $74 per share."
    },
    {
       "id":35006,
       "practice_test_id":2,
       "topic_id":7,
       "question":"An XYZ May 50 call is quoted at 4.35 when XYZ is at 51.10. Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The time value is 1.10 </li><li>The option is in the money </li><li>The time value is 3.25 </li><li>The intrinsic value is more than the time value</li></ol>",
       "choice_a":"II and III",
       "choice_b":"III and IV",
       "choice_c":"I and II",
       "choice_d":"I and IV",
       "correct_answer":"A",
       "explanation":"A call option is in the money when the stock price is higher than the strike price. The time value of an option is the amount by which the option\u0027s premium exceeds the intrinsic value."
    },
    {
       "id":35007,
       "practice_test_id":3,
       "topic_id":7,
       "question":"How far are the IBM Aug 70 calls in the money if IBM trades at $77?",
       "choice_a":"$77",
       "choice_b":"$7",
       "choice_c":"$0",
       "choice_d":"$10",
       "correct_answer":"B",
       "explanation":"A call option is in-the-money by the amount that the underlying security trades ABOVE the call\u0027s strike price."
    },
    {
       "id":35008,
       "practice_test_id":4,
       "topic_id":7,
       "question":"How far is a MSFT Jan 90 call in the money with MSFT trading at $85?",
       "choice_a":"$5",
       "choice_b":"$90",
       "choice_c":"$87.50",
       "choice_d":"$0",
       "correct_answer":"D",
       "explanation":"A call is only in-the-money when the underlying instrument trades for more than the strike price. In this question, the underlying stock is trading for $5 less than the strike price."
    },
    {
       "id":35009,
       "practice_test_id":5,
       "topic_id":7,
       "question":"In July an investor purchases an ABC Oct. 95 call at 5.72 when ABC is at 92. In October ABC goes to 102.40 and the investor closes out the position at its intrinsic value on expiration. Their gain or loss is:",
       "choice_a":"$96.66 Gain",
       "choice_b":"$168 Loss",
       "choice_c":"$168 Gain",
       "choice_d":"$96.66 Loss",
       "correct_answer":"C",
       "explanation":"To determine the investor\u0027s breakeven add the option premium of 5.72 to the strike price of 95. The investor in this case will breakeven at 100.72 subtract the breakeven from the closing price and you get 1.68 X 100 = $168"
    },
    {
       "id":35010,
       "practice_test_id":"",
       "topic_id":7,
       "question":"The advantages an option buyer might obtain include: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Limiting his risk </li><li>Positioning against the option </li><li>Leverage</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"III only",
       "choice_d":"I, II and III",
       "correct_answer":"D",
       "explanation":"An option investor would obtain all of the benefits listed."
    },
    {
       "id":35011,
       "practice_test_id":"",
       "topic_id":7,
       "question":"Which of the following are not false about a put seller? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor wants the option to exercise.</li><li>The investor\u0027s maximum loss is unlimited. </li><li>The investor\u0027s maximum gain is the premium. </li><li>The investor would be considered bullish.</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"III and IV",
       "choice_d":"I, III, and IV",
       "correct_answer":"C",
       "explanation":"The investor is short a put. The investor would be considered bullish and their maximum gain is the premium received. The other choices are false."
    },
    {
       "id":35012,
       "practice_test_id":"",
       "topic_id":7,
       "question":"Which of the following are not false? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>All XYZ Oct 25 calls and puts will be at the money at the same time </li><li>If a put is in the money a call with the same strike price can not be in the money </li><li>The sale of a naked put contains more risk than the sale of a naked call </li><li> The maximum gain from the sale of a call is the premium received</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"The sale of a naked put contains less risk than the sale of a naked call. III is therefore false. All of the other choices are not false or are true."
    },
    {
       "id":35013,
       "practice_test_id":2,
       "topic_id":7,
       "question":"Which of the following are true about an option? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is a contract between two parties which determines the time and place at which a security may be bought or sold </li><li>The two parties are known as the buyer and the seller. The money paid by the buyer of the option is known as the option\u0027s premium </li><li>The buyer has bought the right to buy or sell the security depending on the type of option </li><li>The seller has an obligation to perform under the contract, possibly to buy or sell the stock depending on the option involved</li></ol>",
       "choice_a":"I, II, & III",
       "choice_b":"II, III, & IV",
       "choice_c":"I, III, & IV",
       "choice_d":"I, II, III, & IV",
       "correct_answer":"B",
       "explanation":"I is incorrect in that an option is a contract between two parties which determines the time and price at which a security may be bought or sold."
    },
    {
       "id":35014,
       "practice_test_id":3,
       "topic_id":7,
       "question":"Which of the following are true about out of the money options? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>They are less valuable than an in the money option </li><li>They are more speculative than an at the money option </li><li>They have no intrinsic value </li><li>The premium will be lower than the premium for an option that is in the money</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of the choices are correct relating to an out of the money option."
    },
    {
       "id":35015,
       "practice_test_id":4,
       "topic_id":7,
       "question":"Which of the following is true about a put buyer?",
       "choice_a":"They want the option to expire",
       "choice_b":"Their maximum gain is unlimited",
       "choice_c":"They are not bullish on the stock",
       "choice_d":"Their maximum loss is unlimited",
       "correct_answer":"C",
       "explanation":"A buyer of a put is not bullish on the underlying stock, they are bearish."
    },
    {
       "id":35016,
       "practice_test_id":"",
       "topic_id":7,
       "question":"Which of the following options is \u0027in-the-money\u0027? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Call at 55 - Stock at 55. </li><li>Call at 60 - Stock at 63. </li><li>Put at 55 - Stock at 53. </li><li>Put at 60 - Stock at 60.10.</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"III and IV",
       "choice_d":"I and II",
       "correct_answer":"A",
       "explanation":"A call is in the money when the stock price exceeds the strike price. A put is in the money when the strike price exceeds the stock price."
    },
    {
       "id":35017,
       "practice_test_id":"",
       "topic_id":7,
       "question":"With XYZ trading @52.50, none of the following options are in the money except:",
       "choice_a":"XYZ Mar 55 call",
       "choice_b":"XYZ Mar 55 put",
       "choice_c":"XYZ Mar 50 put",
       "choice_d":"XYZ Mar 45 put",
       "correct_answer":"B",
       "explanation":"Only the XYZ March 55 put is in the money with XYZ at 52.50."
    },
    {
       "id":35018,
       "practice_test_id":2,
       "topic_id":7,
       "question":"Your customer has just been approved to trade options and purchases 10 JNT Oct. 75 Puts at 11.05 when JNT is at 68. The stock falls to 61 and the customer closes out the position at expiration at its intrinsic value. The customer will have:",
       "choice_a":"A profit of $2,950",
       "choice_b":"A loss of $2,950",
       "choice_c":"A gain of $1,400",
       "choice_d":"A loss of $1,400",
       "correct_answer":"A",
       "explanation":"The investor purchased 10 JNT 75 puts at 11.05 at expiration they are worth 14. The customer made $2.95 per share or $2,950 for the entire position."
    },
    {
       "id":35019,
       "practice_test_id":3,
       "topic_id":7,
       "question":"Your investor is long 100 shares ABC @60 and short an ABC Mar 65 call @2. With ABC @64, she sells the stock and closes the option for its intrinsic value. She has a",
       "choice_a":"Gain of $200",
       "choice_b":"Loss of $200",
       "choice_c":"Gain of $600",
       "choice_d":"Gain of $700",
       "correct_answer":"C",
       "explanation":"The intrinsic value of a March 65 call with the stock at $64 is ZERO. So, the investor gained $400 on the stock and $200 on the call when it expired."
    },
    {
       "id":35020,
       "practice_test_id":4,
       "topic_id":7,
       "question":"Your investor is short 100 shares XYZ @50 and long an XYZ Oct 55 call @2. Therefore, her maximum gain is",
       "choice_a":"Unlimited",
       "choice_b":"$5,225",
       "choice_c":"$4,800",
       "choice_d":"$5,275",
       "correct_answer":"C",
       "explanation":"If you short a stock at $50, $50 is the maximum gain, should the stock actually drop to zero. Since you paid $2 a share to protect yourself against a sudden upsurge, $48 per share is now the maximum gain, should the stock become worthless."
    },
    {
       "id":35021,
       "practice_test_id":5,
       "topic_id":7,
       "question":"Standard VIX options measure the volatility of which of the following?",
       "choice_a":"S & P 100",
       "choice_b":"S & P 500",
       "choice_c":"Dow Jones",
       "choice_d":"NASDAQ 100",
       "correct_answer":"B",
       "explanation":"Standard VIX options measure the volatility of the S&P 500 index. As the market falls the VIX increases and vice versa."
    },
    {
       "id":39477,
       "practice_test_id":"",
       "topic_id":7,
       "question":"Which of the following is an accurate explanation regarding owners and writers of listed equity call option contracts?",
       "choice_a":"The owner of a call is obligated to exercise the contract. When exercised the owner will sell the shares to the writer at the strike price.",
       "choice_b":"The owner of a call is obligated to exercise the contract. When exercised a writer would then be assigned the obligation to buy the shares from the owner at the strike price.",
       "choice_c":"The owner of a call has the right to exercise the contract. If exercised the writer would then have the right to buy the shares from the owner at the strike price.",
       "choice_d":"The owner of a call has the right to exercise the contract. If exercised the writer would then be assigned and obligated to sell the shares to the owner at the strike price.",
       "correct_answer":"D",
       "explanation":"Owners of listed equity option contracts have the right to exercise, and writers are obligated to perform when they are assigned. With call contracts the owner has the right to exercise the contract to buy shares at the strike price. The writer would then be assigned and must fulfill the obligation to sell the shares to the owner at the strike price."
    },
    {
       "id":35595,
       "practice_test_id":"",
       "topic_id":8,
       "question":"As per FINRA Rule 2210, electronic communications with the public:",
       "choice_a":"must be based on the principles of fair dealing",
       "choice_b":"must include price predictions",
       "choice_c":"are prohibited unless the individual is an existing client",
       "choice_d":"must be pre-filed with the FINRA 15 days prior to use",
       "correct_answer":"A",
       "explanation":"All communications with the public must be based on the principles of fair dealing. It is a violation of the rule to omit material information, or to give misleading information via electronic communication."
    },
    {
       "id":35596,
       "practice_test_id":"",
       "topic_id":8,
       "question":"All of the following are true except:",
       "choice_a":"emails to 25 or more potential clients must be approved by the principal prior to use",
       "choice_b":"a principal must approve a research report before it is posted on the firm\u0027s website",
       "choice_c":"all correspondence requires principal approval prior to use",
       "choice_d":"electronic retail communication requires prior principal approval",
       "correct_answer":"C",
       "explanation":"A principal must approve all retail communication  prior to use, whether it is written or electronic. Correspondence must be maintained at the firm, but does not require prior principal approval."
    },
    {
       "id":35598,
       "practice_test_id":2,
       "topic_id":8,
       "question":"A registered rep has created an online blog where she writes about her thoughts on the equity market. This is an example of:",
       "choice_a":"an outside business which is exempt from principal approval",
       "choice_b":"a violation",
       "choice_c":"institutional communication which is exempt from principal approval",
       "choice_d":"retail communication which requires principal approval",
       "correct_answer":"D",
       "explanation":"FINRA Rule 2210 states that publicly available websites, including blogs, are retail communication. All retail communication requires prior principal approval."
    },
    {
       "id":35599,
       "practice_test_id":3,
       "topic_id":8,
       "question":"A registered rep makes a recommendation to a customer via email. Which of the following is (are) true?",
       "choice_a":"the rep must make a reasonable effort to obtain the customer\u0027s investment objective and financial situation",
       "choice_b":"the rep must have reasonable grounds for believing the recommendation is suitable for the client",
       "choice_c":"the email would be considered correspondence",
       "choice_d":"all of the choices listed",
       "correct_answer":"D",
       "explanation":"Regardless of how a recommendation is made to a customer, the rep must obtain suitability information from the client and then have reasonable grounds for believing the recommendation is suitable. Any email sent to an individual client is considered to be correspondence."
    },
    {
       "id":35600,
       "practice_test_id":4,
       "topic_id":8,
       "question":"Member Conduct Rules state that registered reps must avoid conflicts of interest when dealing with customers. With respect to equity research reports:",
       "choice_a":"written research reports are exempt from the conflict of interest rules",
       "choice_b":"electronic research reports are exempt from the conflict of interest rules",
       "choice_c":"both of the choices listed",
       "choice_d":"neither of the choices listed",
       "correct_answer":"D",
       "explanation":"Both written and electronic research reports require that conflicts of interest be disclosed to the public."
    },
    {
       "id":35601,
       "practice_test_id":"",
       "topic_id":8,
       "question":"A broker dealer\u0027s public website is:",
       "choice_a":"retail communication",
       "choice_b":"public appearance",
       "choice_c":"not covered by FINRA rules",
       "choice_d":"not covered by FINRA rules if it is password protected",
       "correct_answer":"A",
       "explanation":"A broker dealer\u0027s public website is considered retail communication even If it is password protected if even a single retail investor may see any part of the site."
    },
    {
       "id":35602,
       "practice_test_id":5,
       "topic_id":8,
       "question":"Which of the following are important with respect to a broker dealer\u0027s website?",
       "choice_a":"the name of the firm should be prominently displayed",
       "choice_b":"risk disclosures should clearly state the potential risks",
       "choice_c":"information on the website must be updated to keep information current",
       "choice_d":"all of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are important considerations when a broker dealer maintains a public website. If the firm uses the FINRA logo on its site, it must have a hyperlink to the FINRA website."
    },
    {
       "id":35603,
       "practice_test_id":"",
       "topic_id":8,
       "question":"All of the following are examples of retail communication except:",
       "choice_a":"blogs",
       "choice_b":"chat rooms",
       "choice_c":"websites",
       "choice_d":"a video conference with a client",
       "correct_answer":"D",
       "explanation":"All of the answers listed would be considered to be retail communications except a video conference with a single client."
    },
    {
       "id":35604,
       "practice_test_id":"",
       "topic_id":8,
       "question":"If a broker dealer refers to its membership in FINRA on it\u0027s website:",
       "choice_a":"it is required by the Conduct Rules",
       "choice_b":"the firm must provide a hyperlink to the FINRA website",
       "choice_c":"both of the choices listed",
       "choice_d":"neither of the choices listed",
       "correct_answer":"B",
       "explanation":"There is no requirement that a member refer to FINRA on it\u0027s website. However, if the firm chooses to mention it\u0027s FINRA membership, it must provide a hyperlink to FINRA\u0027s homepage that is close to the FINRA reference on the site."
    },
    {
       "id":35605,
       "practice_test_id":1,
       "topic_id":8,
       "question":"The FINRA logo:",
       "choice_a":"may be used on a firm\u0027s website",
       "choice_b":"may not be used on the firm\u0027s website",
       "choice_c":"may not be used on business cards",
       "choice_d":"should be displayed prominently on all member communications",
       "correct_answer":"A",
       "explanation":"The FINRA logo may be used only to convey the firm\u0027s membership in FINRA, not to imply endorsement. The FINRA logo should not be displayed more prominently than other items on the communication. The FINRA logo may be used on a firm\u0027s website so long as there is a hyperlink in close proximity to the logo connecting the the FINRA home page."
    },
    {
       "id":35608,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Which of the following are true when a broker dealer receives a complaint from a customer?",
       "choice_a":"when a customer mails a complaint to the firm it must be reported to FINRA",
       "choice_b":"when a customer faxes a complaint to the firm it must be reported to FINRA",
       "choice_c":"when a customer emails a complaint to the firm it must be reported to FINRA",
       "choice_d":"all of the choices listed",
       "correct_answer":"D",
       "explanation":"All customer written customer complaints are reported to FINRA monthly."
    },
    {
       "id":35609,
       "practice_test_id":5,
       "topic_id":8,
       "question":"If a registered rep sends a business related email to his client via his Yahoo email account all of the following are true except:",
       "choice_a":"the communication is not required to be supervised by the firm since it was sent from outside the office",
       "choice_b":"the communication is required to be supervised by the firm",
       "choice_c":"the communication must be retained by the firm for 3 years",
       "choice_d":"the firm may have policies that prohibit this communication",
       "correct_answer":"A",
       "explanation":"Not all firm\u0027s allow reps to send emails from their personal addresses. If the firm does not prohibit this practice, the electronic communications are to be supervised and maintained by the firm."
    },
    {
       "id":35611,
       "practice_test_id":1,
       "topic_id":8,
       "question":"You have a client that is looking for an investment that will generate current income but is concerned about the taxation of dividends. List the following from the most favorable tax treatment to the most highly taxed. <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A municipal bond ETF </li><li>A common stock ETF </li><li>A Treasury bond ETF </li><li>A Real estate investment trust</li></ol>",
       "choice_a":"I,II,III,IV",
       "choice_b":"I,III,II,IV",
       "choice_c":"IV,I,II, III",
       "choice_d":"II,I,IV,III",
       "correct_answer":"B",
       "explanation":"Dividends received by investors from a municipal bond ETF are free from federal income taxes and this investment would receive the most favorable tax treatment. Dividends received from a Treasury bond ETF would be free from state taxes and a common stock ETF would generate qualified dividends currently taxed at a maximum of 15% or 20% for high income earners. Dividends generated by a REIT are not qualified and would be taxed at the investor\u0027s income tax rate."
    },
    {
       "id":35612,
       "practice_test_id":"",
       "topic_id":8,
       "question":"An agent of a broker dealer, guarantees a client that the securities they are investing in will outperform US Bonds. This is:",
       "choice_a":"Acceptable because they are an agent as well",
       "choice_b":"Not acceptable because they are guaranteeing performance",
       "choice_c":"Acceptable because they do not cite a specific rate",
       "choice_d":"Not acceptable if the agent does not have approval of the broker dealer",
       "correct_answer":"B",
       "explanation":"An agent may never guarantee the performance of any investment, promise a return or promise no loss for any reason."
    },
    {
       "id":35613,
       "practice_test_id":"",
       "topic_id":8,
       "question":"When can an investment adviser reveal information about their client? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>If the client gives permission </li><li>If legally forced </li><li>At their discretion </li><li>If asked by family</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II",
       "choice_c":"I and IV",
       "choice_d":"I, II, III and IV",
       "correct_answer":"B",
       "explanation":"An investment adviser may only reveal information about their client if the client gives permission or if they are required to legally, such as under a subpoena."
    },
    {
       "id":35615,
       "practice_test_id":1,
       "topic_id":8,
       "question":"A client sends a written complaint about an agent being rude. The company is required to:",
       "choice_a":"Contact the state administrator with the charges",
       "choice_b":"Do nothing as this is not a substantial claim",
       "choice_c":"Investigate the matter",
       "choice_d":"Suspend the agent immediately",
       "correct_answer":"C",
       "explanation":"A firm that receives a written customer complaint is required to investigate the matter no matter how small the claim."
    },
    {
       "id":35616,
       "practice_test_id":"",
       "topic_id":8,
       "question":"An investment adviser says that they will compensate the customer for any losses that a security will have. This is:",
       "choice_a":"Not allowed because it is guaranteeing a return",
       "choice_b":"Not allowed as they may not have enough money to cover the loss",
       "choice_c":"An acceptable practice",
       "choice_d":"Allowed only if approved by the principal at the home office",
       "correct_answer":"A",
       "explanation":"No firm, adviser or agent may guarantee a result or promise no loss to a client for any reason."
    },
    {
       "id":35617,
       "practice_test_id":"",
       "topic_id":8,
       "question":"An agent knows there will be an over subscription to the offering of a security. He then, acting on verbal authority, opens an account for his wife where he puts many of the securities. This is:",
       "choice_a":"A violation as you cannot act for another person",
       "choice_b":"Acceptable because it is his wife",
       "choice_c":"An example of withholding and a violation",
       "choice_d":"This is acceptable if the amount of the securities is less than $10,000",
       "correct_answer":"C",
       "explanation":"All securities that are the subject of an underwriting must be offered to the public and can not be withheld for the account of a broker dealer, an agent or anyone who is financially dependent upon the agent, such as spouse or a child."
    },
    {
       "id":35618,
       "practice_test_id":2,
       "topic_id":8,
       "question":"An agent is three mutual fund sales away from a bonus. It is unethical for the representative to:",
       "choice_a":"Tell clients about the bonus",
       "choice_b":"Solicit help from family and friends to meet the bonus",
       "choice_c":"Call clients and tell them that there is a great deal on a fund",
       "choice_d":"Establish a dollar cost averaging plan for a client at the client\u0027s request",
       "correct_answer":"C",
       "explanation":"The agent may not recommend the fund for which the sales are the basis for a bonus and use that potential bonus as the basis for the recommendation."
    },
    {
       "id":35619,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Anyone who invests, including individual investors is subject to:",
       "choice_a":"Keeping documents",
       "choice_b":"Not committing fraud",
       "choice_c":"Registering securities",
       "choice_d":"Registering as a broker-dealer",
       "correct_answer":"B",
       "explanation":"No one may commit fraud including individual investors. There is no requirement that an investor maintain records."
    },
    {
       "id":35620,
       "practice_test_id":"",
       "topic_id":8,
       "question":"A 90 year old man living on social security has just won a legal settlement in the amount of $250,000 and wants to invest the money to receive additional income to supplement his monthly social security check. He would also like to leave some money for his children. Which of the following would be the best selection?",
       "choice_a":"A ladder Treasury bond portfolio",
       "choice_b":"A ladder municipal bond portfolio",
       "choice_c":"An index ETF and CMOs",
       "choice_d":"A portfolio of both common and preferred stock",
       "correct_answer":"A",
       "explanation":"This is an elderly person who has an investment objective of current income and preservation of capital. His objective of preservation of capital is identified by the fact that he wants to leave money to his heirs. A laddered portfolio of Treasury bonds would be the best option . A bond ladder consists of a portfolio of bonds with maturities ranging over a period of years. The interest payments will be received frequently as the interest payment dates will vary. The treasury bonds will also protect the principal investment."
    },
    {
       "id":35621,
       "practice_test_id":"",
       "topic_id":8,
       "question":"A 45 year old in the 28 percent tax bracket is speaking to you as his representative seeking an investment to augment his 401K plan. Which of the following would be the best recommendation for your client?",
       "choice_a":"Variable annuity, accumulation units",
       "choice_b":"Variable annuity, annuity units",
       "choice_c":"A growth mutual fund",
       "choice_d":"An S & P 500 index fund",
       "correct_answer":"A",
       "explanation":"An investor who is looking to augment or supplement a retirement plan would be most suitable for a deferred variable annuity contract. During the accumulation phase the money is allowed to grow tax deferred and the investor will own accumulation units."
    },
    {
       "id":35623,
       "practice_test_id":2,
       "topic_id":8,
       "question":"A city councilman meets a registered representative at a local charity event. During the conversation the registered representative tells the councilman how much he loves sports. A few days later the councilman sends the registered representative two tickets to a hockey game valued at $150 each. Which of the following is correct?",
       "choice_a":"The registered representative may accept the tickets with no obligation as the councilman is not a client",
       "choice_b":"The registered representative may accept the tickets with the approval of the firm",
       "choice_c":"The registered representative may accept the tickets if one of the tickets is intended for the councilman",
       "choice_d":"The registered representative and his wife may use the tickets without further restriction if the councilman is seated in the same box",
       "correct_answer":"C",
       "explanation":"The only way that the representative may accept the tickets is if the councilman is intending on going to the game with the RR. If the councilman attends with the RR it is considered to be entertainment and not a gift."
    },
    {
       "id":35624,
       "practice_test_id":"",
       "topic_id":8,
       "question":"An investor with a 2 year time horizon has $75,000 to invest. He is seeking semiannual payments of interest income. Which of the following would you recommend?",
       "choice_a":"Treasury note",
       "choice_b":"Treasury bond",
       "choice_c":"2 year STRIP",
       "choice_d":"Treasury bill",
       "correct_answer":"A",
       "explanation":"Of the choices listed the only option that actually pays interest is the Treasury note. All of the other choices are discount securities which do not pay interest. Discounted securities appreciate to their par or face value at maturity."
    },
    {
       "id":35627,
       "practice_test_id":"",
       "topic_id":8,
       "question":"A registered representative has a long standing client who is 73 years old. The RR speaks to the client twice per month. The RR also has the client\u0027s 43 year old daughter as a client. During the last several months the client has consistently said that his investment objectives have changed and he is now looking for income and wants to purchase a particular income fund. The representative notices that the client often seems to forget speaking to the RR. However, each time they speak he says he wants to purchase the income fund and that his objectives have changed. The registered representative should:",
       "choice_a":"Purchase the fund for the client and mark the order unsolicited",
       "choice_b":"Invite the daughter to the next meeting with the client",
       "choice_c":"Have the daughter obtain written power of attorney for client\u0027s account",
       "choice_d":"Refuse to execute the order",
       "correct_answer":"A",
       "explanation":"The registered representative should execute the order at the customer\u0027s request. Inviting the daughter to the meeting is not a correct choice as an RR may never disclose details of the investor\u0027s holdings to another party without the customer\u0027s consent. The choices in the question make you take an action. If there was an option to consult a principal of the firm prior to executing an order, that would be a better option."
    },
    {
       "id":35628,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Your client is in his mid fifties and will be retiring several years. He wants to make several changes to his portfolio and is seeking steady income and protection of principal. As his representative which of the following would you most likely recommend?",
       "choice_a":"Buy a portfolio of corporate bonds maturing in 2-7 years",
       "choice_b":"Buy a portfolio of AAA rate municipal bonds with 30 year maturity",
       "choice_c":"Buy a portfolio the highest yielding municipal securities",
       "choice_d":"Buy a portfolio of high yielding corporate bonds",
       "correct_answer":"A",
       "explanation":"The investor is looking for income and safety of principal, the High yield bonds are not appropriate as they contain too much risk. The AAA rated  munis would subject the investor to too much principal risk if interest rates changed. The short term corporate bonds therefore  the best choice in this situation."
    },
    {
       "id":35630,
       "practice_test_id":2,
       "topic_id":8,
       "question":"An investor wishing to purchase open end mutual funds with the performance characteristics of the S&P index would be said to have an investing style that is:",
       "choice_a":"Aggressive",
       "choice_b":"Passive",
       "choice_c":"Based on bottom up analysis",
       "choice_d":"Based on top down analysis",
       "correct_answer":"B",
       "explanation":"An investor who is seeking an investment that tracks the performance of an index such as the S&P 500 is engaging in a passive investment strategy. The assets in the fund are selected based on the makeup of the stocks in the index. Portfolio managers do not select the assets to be purchased or sold."
    },
    {
       "id":35631,
       "practice_test_id":"",
       "topic_id":8,
       "question":"A wealthy client is in the maximum federal tax bracket and is seeking to avoid the potential impact of the AMT. Which of the following bonds would you most likely recommend?",
       "choice_a":"A 6% taxable municipal bond",
       "choice_b":"A 5.2% GO bond",
       "choice_c":"A 5.4% Treasury bond",
       "choice_d":"A 5.2% interest protected AMT bond",
       "correct_answer":"B",
       "explanation":"Certain high income earners can be subject to the AMT on certain municipal revenue bonds. As such the best recommendation for this person is the GO bond. A Treasury bond is not the correct choice as the interest will always be taxed at the federal level."
    },
    {
       "id":35632,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Which of the following investments would be least suitable for an investor seeking a short term, liquid investment providing safety of principal?",
       "choice_a":"T\u0027 Bills",
       "choice_b":"Auction rate securities",
       "choice_c":"Money market funds",
       "choice_d":"30-90 day brokered CDs",
       "correct_answer":"B",
       "explanation":"Auction rate securities are long term bonds that reset the interest rate paid on the bonds at set intervals. ARS are 20-30 years in maturity which pay interest based on the auction rate every 7, 28 or 35 days. If the auction fails investors will not be able to sell the bonds immediately."
    },
    {
       "id":35635,
       "practice_test_id":"",
       "topic_id":8,
       "question":"An investor owns $50,000 worth of US T\u0027 bonds  with an interest rate of 5%. The investor is in the 30% tax bracket at the federal level and 9% at the state level. The investor will have a tax liability based on the income of:",
       "choice_a":"$2,500",
       "choice_b":"$750",
       "choice_c":"$225",
       "choice_d":"$975",
       "correct_answer":"B",
       "explanation":"Interest on US T bonds is not taxed at the state or local level. The interest is only taxed that federal level. In this case the investor earned $2,500 in interest and is in the 30% tax rate. The tax liability is $750. ($2,500 X 30%)"
    },
    {
       "id":35636,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Which of the following DPP programs would provide an investor with the largest write-offs?",
       "choice_a":"Raw land",
       "choice_b":"Oil and gas drilling",
       "choice_c":"Oil and income producing",
       "choice_d":"Real estate existing property",
       "correct_answer":"B",
       "explanation":"An oil and gas program  would provide an investor with the largest write offs through the intangible drilling costs / IDCs. IDCs are passed through to the investors in the program and create large write-offs for investors."
    },
    {
       "id":35638,
       "practice_test_id":3,
       "topic_id":8,
       "question":"A client who is interested in investing in a whole loan private label CMO is asking you about the collateral and guarantees associated with the security. Upon review of the security you should tell him:",
       "choice_a":"The securities are backed by the full faith and credit of Ginnie Mae",
       "choice_b":"The securities are tied to a pool of mortgages backed by Freddie Mac",
       "choice_c":"The securities are tied to a pool of mortgages backed by Fannie Mae",
       "choice_d":"The securities are tied to a pool of mortgages backed by a letter of credit and or insurance taken out by the issuer",
       "correct_answer":"D",
       "explanation":"A private labeled CMO is created  when a broker dealer purchases a large portfolio of mortgages and sells off the interest in the pool to investors in CMOs. Whole loan CMOs are backed by the pool of mortgages which in turn may have insurance or a letter of credit backing the loans in the pool, not the CMO itself."
    },
    {
       "id":35639,
       "practice_test_id":"",
       "topic_id":8,
       "question":"A long standing client is seeking to make an initial deposit into a college plan for his son\u0027s college expenses. His son will start college in 11 years. Which of the following is the lowest priority when determining the amount of the initial deposit?",
       "choice_a":"Client\u0027s current income",
       "choice_b":"The current average cost of college",
       "choice_c":"The time until his son starts college",
       "choice_d":"The projected annual increase in tuition",
       "correct_answer":"A",
       "explanation":"The lowest priority would be the client\u0027s current income as the client is seeking to make an initial deposit. The deposit will be coming from savings so the amount of the client\u0027s savings would be far more important. The other factors can be used to estimate what the anticipated cost of college may be and are therefore of high importance."
    },
    {
       "id":35640,
       "practice_test_id":"",
       "topic_id":8,
       "question":"In response to a customer\u0027s request for information on a private label CMO you may inform them of all of the following except:",
       "choice_a":"The securities in the portfolio are all issued by a US agency and carry the same guarantees",
       "choice_b":"Interest payments due to investors are subject the credit risk of the issuing broker dealer",
       "choice_c":"If the interest payments in the portfolio are guaranteed by a Government agency the investor\u0027s interest payments are equally assured",
       "choice_d":"Private label CMOs may carry additional risks due the nature of the issuer\u0027s business",
       "correct_answer":"C",
       "explanation":"If the collateral in the portfolio of a private label CMO is guaranteed by a Government agency that guarantee does not pass through to the investors in the CMOs. There is no guarantee that the issuer will receive the payments and pass them on to the investors in a timely manner"
    },
    {
       "id":35641,
       "practice_test_id":3,
       "topic_id":8,
       "question":"Income from which of the following is most likely to subject a high income investor to the AMT (alternative minimum tax)?",
       "choice_a":"General Obligation (GO) bond",
       "choice_b":"Industrial revenue bond",
       "choice_c":"T Bill",
       "choice_d":"T Bond",
       "correct_answer":"B",
       "explanation":"Income from a private purpose municipal bond also known as an industrial revenue development bond is most likely to subject a high income investor to the AMT (alternative minimum tax)."
    },
    {
       "id":35642,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Which of the following is  a feature of a 529 college plan?I. High contribution limit II. Pre tax contributionsIII. Federally tax free withdrawals for college expenses IV. Contributions subject to income restrictions",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"I, III and IV",
       "choice_d":"I,II, III, IV",
       "correct_answer":"A",
       "explanation":"529 plans allow for high contribution limits. There are no income limits for contributors to a 529 plan. Students may make withdrawals from 529 plans federally tax free to meet college expenses."
    },
    {
       "id":35643,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Which of the following is not a feature of a 529 college plan?I. High contribution limitII. Pre tax contributionsIII. Federally tax free withdrawals for college expensesIV. Contributions subject to income restrictions",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"A",
       "explanation":"529 plans do not allow contributions to be made with pre tax dollars. There are no income limits for contributors to a 529 plan"
    },
    {
       "id":35644,
       "practice_test_id":5,
       "topic_id":8,
       "question":"A 42 year old investor wants to put $20,000 into a plan to help meet the educational expenses of their 12 year old son. They want to make a lump sum deposit. Which would you recommend?",
       "choice_a":"A 529 plan",
       "choice_b":"A Coverdell IRA",
       "choice_c":"A Roth IRA",
       "choice_d":"A Growth mutual fund",
       "correct_answer":"A",
       "explanation":"A 529 plan would allow the investor to make a lump sum deposit. The key is that the investor is looking for a \u0022plan\u0022 to put money into and has a large sum of money to invest. The 529 plan is the correct option for this investor."
    },
    {
       "id":35645,
       "practice_test_id":"",
       "topic_id":8,
       "question":"An investor in a high tax bracket would receive the most benefit from the purchase of which of the following securities?",
       "choice_a":"CMOs",
       "choice_b":"Municipal bonds",
       "choice_c":"GMNAs",
       "choice_d":"US Treasury bonds",
       "correct_answer":"B",
       "explanation":"CMOs and GMNAs pay interest that is fully taxable, and US government securities pay interest that is federally taxed only. However, municipal bonds pay interest that is federally tax free. So investors in higher tax brackets receive the most tax benefits from investing in municipal bonds."
    },
    {
       "id":35646,
       "practice_test_id":3,
       "topic_id":8,
       "question":"CMOs are the most appropriate investment for a person seeking:",
       "choice_a":"Tax relief",
       "choice_b":"Long term growth potential",
       "choice_c":"Income",
       "choice_d":"Liquidity",
       "correct_answer":"C",
       "explanation":"CMOs are not a suitable investment for an investor seeking tax relief, as interest on CMOs is fully taxable. Many of the more complex CMOs can be highly illiquid; and being a pass through investment there is no long term growth potential However, CMOs do pay regular income in the form of principal, interest or both to the investor."
    },
    {
       "id":35647,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Joe Smith, a customer of XYZ broker dealer wishes to diversify his portfolio by investing in many different types of securities. Joe will have to sign a suitability statement before investing in all of the following except:",
       "choice_a":"A CMO with a planned amortization class",
       "choice_b":"An Industrial development bond",
       "choice_c":"Penny stocks",
       "choice_d":"A real estate limited partnership",
       "correct_answer":"B",
       "explanation":"Due to a high degree of risk and a low degree of liquidity investors are required to sign a suitability statement when investing in CMOs, penny stocks and DPPs. IDRs are a type of municipal note and do not require a suitability statement."
    },
    {
       "id":35648,
       "practice_test_id":"",
       "topic_id":8,
       "question":"John Sno, a 38 year old customer with a 5 year old daughter, wants to begin saving for his daughter\u0027s college education. He is interested in a 529 plan. You tell him:",
       "choice_a":"He can choose a 529 plan that is a prepaid tuition plan and begin contributing immediately",
       "choice_b":"He can choose a 529 plan that is a college savings plan and begin contributing immediately",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"C",
       "explanation":"A 529 plan can be set up as either a prepaid tuition plan, which locks in today\u0027s tuition cost at a specific college; or as a college savings plan, which allows the contributions to grow tax deferred."
    },
    {
       "id":35649,
       "practice_test_id":4,
       "topic_id":8,
       "question":"Which of the following are considered benefits of a 529 plan?",
       "choice_a":"Contributions grow tax deferred",
       "choice_b":"The cost of tuition a specific school can be locked in",
       "choice_c":"The donor maintains ownership of the account",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Contributions to a 529 plan grow tax deferred and can be used to pre-pay the cost of tuition at a specific college at today\u0027s rate. And unlike an Education IRA, the individual who set up the plan retains ownership of the contributions."
    },
    {
       "id":35650,
       "practice_test_id":"",
       "topic_id":8,
       "question":"If a client wishes to open an account for a minor whereby he, the donor, retains ownership of the account he would most likely open a:",
       "choice_a":"Coverdell IRA",
       "choice_b":"529 plan",
       "choice_c":"UGMA",
       "choice_d":"UTMA",
       "correct_answer":"B",
       "explanation":"In a 529 plan the donor remains the owner of the account even when the minor reaches the age of majority. In a Coverdell IRA, UGMA and UTMA account, the minor is the beneficial owner of the account from its inception."
    },
    {
       "id":35651,
       "practice_test_id":"",
       "topic_id":8,
       "question":"All of the following are true regarding 529 plans except:",
       "choice_a":"Once established the account becomes the property of the minor",
       "choice_b":"The account can be established as a college savings plan",
       "choice_c":"Withdrawals for educational expenses are federally tax free",
       "choice_d":"The account can be established as a prepaid tuition plan",
       "correct_answer":"A",
       "explanation":"When a 529 plan is created the donor makes after tax contributions to the account and the withdrawals are federally tax free if used for educational expenses. The account is set up for the benefit of a minor, but the donor remains the owner of the account."
    },
    {
       "id":35652,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Which of the following are considered benefits of a 529 plan? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Contributions grow tax deferred </li><li>A pre-paid tuition plan locks in today\u0027s tuition rates for future enrollment at specific school </li><li>Withdrawals are federally tax free if used for educational expenses </li><li>Depending on the state, withdrawals may be state tax free</li></ol>",
       "choice_a":"I, III",
       "choice_b":"III, IV",
       "choice_c":"I, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"A 529 plan allows for contributions to grow tax deferred and withdrawals to be federally and, many times, state tax free. If the customer decides on a prepaid tuition program he will lock in the price of a future education."
    },
    {
       "id":35653,
       "practice_test_id":4,
       "topic_id":8,
       "question":"An investor who is concerned with liquidity risk would be least likely to purchase which of the following?",
       "choice_a":"Common stock",
       "choice_b":"Variable annuities",
       "choice_c":"Money market securities",
       "choice_d":"Mutual fund shares",
       "correct_answer":"B",
       "explanation":"Common stock, money market securities and mutual funds are all liquid investments. A variable annuity follows the same rules as a traditional IRA in that the investor cannot liquidate the annuity before the age of 59\u00BD without a penalty and tax consequence."
    },
    {
       "id":35654,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Which of the following is most suitable for a customer who is looking for growth potential with a minimum guaranteed rate of return?",
       "choice_a":"A balanced fund",
       "choice_b":"A variable annuity",
       "choice_c":"A money market fund",
       "choice_d":"A combination annuity",
       "correct_answer":"D",
       "explanation":"A combination annuity provides a guaranteed rate of return by investing in the general account plus a variable rate of return by investing in the separate account."
    },
    {
       "id":35655,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Which of the following investors would be most likely to purchase an inverse ETF?",
       "choice_a":"A long term investor",
       "choice_b":"An institutional investor",
       "choice_c":"A bearish investor",
       "choice_d":"A bullish investor",
       "correct_answer":"C",
       "explanation":"An inverse ETF offers price performance that moves in the opposite direction of the underlying index. The S&P 500 inverse ETF will increase in price as the value of the S&P 500 falls. An investor who was bearish or who thought that the market may generally fall would be the most likely to purchase an inverse ETF."
    },
    {
       "id":35656,
       "practice_test_id":"",
       "topic_id":8,
       "question":"An investor who is long a large portfolio of large cap common stocks would most likely execute which of the following to protect the portfolio from a market correction?",
       "choice_a":"Purchase an inverse bond fund ETF",
       "choice_b":"Purchase a bond fund",
       "choice_c":"Purchase the S&P 500 inverse ETF",
       "choice_d":"Purchase puts on each holding in the portfolio",
       "correct_answer":"C",
       "explanation":"An investor who is long a large portfolio of large cap common stocks would most likely purchase the S&P 500 inverse ETF to provide protection to the overall portfolio in the event of a market correction. The price of the inverse ETF will increase as the value of the S&P 500 falls. Buying the inverse ETF is more efficient than purchasing puts on each and every stock in the portfolio."
    },
    {
       "id":35657,
       "practice_test_id":4,
       "topic_id":8,
       "question":"An inverse ETF would be suitable for which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Long term protection  </li><li>Short term protection  </li><li>Gaining short exposure </li><li>Portfolio hedging </li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"I, II and IV",
       "choice_d":"II, III and IV",
       "correct_answer":"D",
       "explanation":"An inverse ETF could be used for short term protection, to gain short exposure to the market, or to hedge an overall portfolio against a market decline. An inverse ETF is not designed for long term protection."
    },
    {
       "id":39459,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Which of the following is an accurate statement regarding shareholder\u0027s investment objectives?",
       "choice_a":"A growth or capital appreciation objective is achieved when the value of shares owned increases.",
       "choice_b":"Neither an income nor growth objective is achieved when dividends are declared by the board of directors.",
       "choice_c":"An income objective is achieved when the value of shares owned increases.",
       "choice_d":"A growth and capital appreciation objective is achieved when dividends are declared by the board of directors.",
       "correct_answer":"A",
       "explanation":"Any increase in the value of shares owned achieves a growth or capital appreciation objective for shareholders. Dividend declaration and payment will achieve an income objective for shareholders, not a growth objective."
    },
    {
       "id":39467,
       "practice_test_id":"",
       "topic_id":8,
       "question":"If an investor\u0027s objective is to receive quarterly income, of the following, the most likely investment to meet the objective would be:",
       "choice_a":"US Treasury bonds.",
       "choice_b":"Separate Trading of Registered Interest and Principal of Securities (STRIPS).",
       "choice_c":"corporate investment grade bonds.",
       "choice_d":"a utility company\u0027s common stock.",
       "correct_answer":"D",
       "explanation":"Of the choices offered, utility stocks which generally pay quarterly dividends, is the only investment that could possibly meet the investor\u0027s objective. Corporate and US Treasury bonds pay interest semiannually and STRIPS pay at the time of maturity."
    },
    {
       "id":35943,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Why do variable annuities contain more risk?",
       "choice_a":"Because the number of accumulation units is fixed",
       "choice_b":"Because they invest in stocks, bonds, and mutual funds which contain inherent risk",
       "choice_c":"Because they are considered both a security and an insurance company product",
       "choice_d":"Because the money may be invested either directly or indirectly",
       "correct_answer":"B",
       "explanation":"Variable annuities contain more risk because the funds are invested in stocks, bonds, and mutual funds which may increase or decrease in value."
    },
    {
       "id":35942,
       "practice_test_id":2,
       "topic_id":9,
       "question":"Which of the following is true about taxation of annuities?",
       "choice_a":"Contributions are made with after tax money",
       "choice_b":"The investment is allowed to grow tax deferred",
       "choice_c":"When the investor withdraws money from the contract, only the growth is taxed",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are true about the taxation of annuities."
    },
    {
       "id":35941,
       "practice_test_id":3,
       "topic_id":9,
       "question":"Tax sheltered annuities and tax deferred annuities are established as retirement plans for all of the following except:",
       "choice_a":"Union members for an auto company",
       "choice_b":"Public schools and educational personnel",
       "choice_c":"Non-profit organizations",
       "choice_d":"Religious organizations",
       "correct_answer":"A",
       "explanation":"Tax sheltered annuities and tax deferred annuities are only established for non-profit organizations."
    },
    {
       "id":36070,
       "practice_test_id":4,
       "topic_id":9,
       "question":"Which of the following investments exposes the investor to the most purchasing power risk?",
       "choice_a":"Growth fund",
       "choice_b":"Income fund",
       "choice_c":"Money market fund",
       "choice_d":"Fixed annuity",
       "correct_answer":"D",
       "explanation":"A fixed annuity will not provide any real protection from inflation and will subject the investor to the most purchasing power risk."
    },
    {
       "id":36069,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A qualified retirement plan differs from a non-qualified retirement plan in all of the following ways except:",
       "choice_a":"Contributions for the qualified plan are pre-tax, while contributions for the non-qualified plan are after tax",
       "choice_b":"Participation must be allowed for everyone in the qualified plan while the corporation may choose who participates in the non-qualified plan",
       "choice_c":"IRS approval is required for both plans",
       "choice_d":"Withdrawals from a qualified plan are 100% taxed as ordinary income while growth in excess of the cost base is taxed as ordinary income in a non-qualified plan",
       "correct_answer":"C",
       "explanation":"IRS approval is required for participation in a qualified plan, but IRS approval is not required for a non-qualified plan."
    },
    {
       "id":36051,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Who would realize the greatest benefit as it relates to a defined benefit plan? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Employees who have fewer years until retirement </li><li>Employees with many years until retirement </li><li>Employees who have high salaries </li><li>Employees who have modest salaries</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I only",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"A",
       "explanation":"Employees with the highest salaries with the fewest years until retirement would realize the greatest benefit from participation in a defined benefit plan. A defined benefit plan provides a stated benefit such as a set percentage of the employee\u0027s income during retirement"
    },
    {
       "id":36068,
       "practice_test_id":5,
       "topic_id":9,
       "question":"Which of the following is a qualified account? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>SEP IRA </li><li>Traditional IRA </li><li>Educational IRA </li><li>Roth IRA</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"A",
       "explanation":"Only the SEP and the Traditional IRAs are funded with pretax dollars."
    },
    {
       "id":36067,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A Keogh plan is available for all of the following except:",
       "choice_a":"An independent coffee shop owner",
       "choice_b":"A lawyer",
       "choice_c":"A janitor at a local college",
       "choice_d":"A nurse at a local doctor\u0027s office",
       "correct_answer":"C",
       "explanation":"The janitor at a local college is not self-employed nor do they work for someone who is self-employed."
    },
    {
       "id":35940,
       "practice_test_id":"",
       "topic_id":9,
       "question":"If an investor wants to purchase an annuity by making regular scheduled payments into the contract, he should invest in which of the following types of annuities?",
       "choice_a":"Single payment deferred annuity",
       "choice_b":"Multiple payment periodic annuity",
       "choice_c":"Regular payment immediate annuity",
       "choice_d":"Periodic payment deferred annuity",
       "correct_answer":"D",
       "explanation":"A periodic payment deferred annuity allows an investor to make regularly scheduled payments into a contract annuity which has a deferred pay out time."
    },
    {
       "id":36066,
       "practice_test_id":2,
       "topic_id":9,
       "question":"A Keogh plan (HR-10) is which of the following?",
       "choice_a":"A qualified retirement plan",
       "choice_b":"Usually set up by individuals, sole proprietors, or unincorporated businesses",
       "choice_c":"May be funded only with earned income during a period when the business showed a gross profit",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"A Keogh plan allows individuals, sole proprietors, and unincorporated small businesses to establish a retirement plan for themselves and their employees."
    },
    {
       "id":36065,
       "practice_test_id":3,
       "topic_id":9,
       "question":"A client who is a lawyer making $230,000 per year makes the maximum contribution to his Keogh plan. He has a full time paralegal that earns $65,000 per year and wants to know what he must do for his employee\u0027s retirement. You should tell him:",
       "choice_a":"Since you are self-employed, you can decide what to pay your own people",
       "choice_b":"You must contribute the same amount of money to the employee\u0027s Keogh as you did to yours",
       "choice_c":"You must make a contribution to the employee\u0027s Keogh at the same percentage rate as your own",
       "choice_d":"The employee is not self-employed and may not have a Keogh plan",
       "correct_answer":"C",
       "explanation":"A self-employed individual who has a full time employee must make a contribution for that employee at the same rate as his or her own contribution."
    },
    {
       "id":36064,
       "practice_test_id":4,
       "topic_id":9,
       "question":"A simplified Employee Pension IRA is:",
       "choice_a":"Frequently used by small companies and individuals to plan for retirement",
       "choice_b":"Attractive to small employers because it allows them to establish a retirement plan for their employees quickly and inexpensively",
       "choice_c":"A plan which requires all eligible employees to participate as well as the employer, both of whom are contributing to the fund",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are true about a SEP IRA."
    },
    {
       "id":36063,
       "practice_test_id":5,
       "topic_id":9,
       "question":"A client who is 65 years old has invested $10,000 in a Roth IRA. It has now grown to $14,000. He plans to retire and take a lump sum distribution. He will pay taxes on:",
       "choice_a":"$14,000",
       "choice_b":"$4,000",
       "choice_c":"$10,000",
       "choice_d":"$0",
       "correct_answer":"D",
       "explanation":"The money has been deposited in a Roth IRA after taxes. It is allowed to grow tax deferred. If you are over 59\u00BD and the money has been there for at least 5 years, then it may all be returned without paying taxes on the growth."
    },
    {
       "id":36061,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An investor in a variable annuity may change their payout option:",
       "choice_a":"Under no circumstances",
       "choice_b":"If their financial needs change significantly",
       "choice_c":"To convert to a lump sum withdrawal",
       "choice_d":"Upon the death of a spouse for joint with last survivor",
       "correct_answer":"A",
       "explanation":"An investor may never change their payout option once it has been set."
    },
    {
       "id":36062,
       "practice_test_id":5,
       "topic_id":9,
       "question":"A 55 year old investor who withdraws money from a variable annuity to meet a family emergency will pay:",
       "choice_a":"Ordinary income taxes only",
       "choice_b":"Capital gains taxes only",
       "choice_c":"Ordinary income taxes plus a 10% penalty",
       "choice_d":"No taxes because the money deposited into a variable annuity are after tax dollars",
       "correct_answer":"C",
       "explanation":"The investor will have to pay the ordinary income taxes on the money as well as a 10% penalty because he is under 59\u00BD."
    },
    {
       "id":36001,
       "practice_test_id":1,
       "topic_id":9,
       "question":"Insurance companies deduct a fee from the separate account of an annuity to cover the risk involved in issuing these annuity contracts; which is not one of the risks involved?",
       "choice_a":"Operating expense risk",
       "choice_b":"Sales risk",
       "choice_c":"Mortality risk",
       "choice_d":"Unexpected rise in the cost of doing business risk",
       "correct_answer":"B",
       "explanation":"There is no such thing as a sales risk involved in issuing annuities."
    },
    {
       "id":36002,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An annuitant is interested in the largest monthly payment from her annuity now that she has retired; which of the following payout options will give her the greatest monthly payment?",
       "choice_a":"Joint with last survivor",
       "choice_b":"Life with period certain",
       "choice_c":"Life without period",
       "choice_d":"Life only/straight life",
       "correct_answer":"D",
       "explanation":"The payout options in order from largest monthly payment to smallest are: life only/straight life, life with period certain, and lastly joint with last survivor."
    },
    {
       "id":36000,
       "practice_test_id":1,
       "topic_id":9,
       "question":"If your customer wants to purchase an annuity by making regular scheduled payments into the contract, he should invest in which of the following types of annuities?",
       "choice_a":"Single payment deferred annuity",
       "choice_b":"Multiple payment periodic annuity",
       "choice_c":"Regular payment immediate annuity",
       "choice_d":"Periodic payment deferred annuity",
       "correct_answer":"D",
       "explanation":"A periodic payment deferred annuity allows an investor to make regularly scheduled payments into a contract annuity which has a deferred payout time."
    },
    {
       "id":35997,
       "practice_test_id":"",
       "topic_id":9,
       "question":"ERISA regulates all of the following except:",
       "choice_a":"Public sector pension plans",
       "choice_b":"Funding",
       "choice_c":"Vesting",
       "choice_d":"Communication",
       "correct_answer":"A",
       "explanation":"ERISA only regulates private sector non government plans. All of the other choices listed are regulated by the act."
    },
    {
       "id":35998,
       "practice_test_id":"",
       "topic_id":9,
       "question":"ERISA regulates:",
       "choice_a":"All retirement accounts",
       "choice_b":"IRA\u0027s and pension plans",
       "choice_c":"Public sector pension plans",
       "choice_d":"Private sector pension plans",
       "correct_answer":"D",
       "explanation":"ERISA only regulates private sector pension plans not public sector plans."
    },
    {
       "id":35999,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An investor is seeking maximum safety of principal. Which type of investment should a representative recommend for him?",
       "choice_a":"Fixed annuity",
       "choice_b":"Variable annuity",
       "choice_c":"Contractual annuity",
       "choice_d":"Combination annuity",
       "correct_answer":"A",
       "explanation":"A fixed annuity has no investment risk, so General Green should be offered a fixed annuity."
    },
    {
       "id":35995,
       "practice_test_id":5,
       "topic_id":9,
       "question":"Employees of which of the following are eligible to participate in a TSA? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Zoo\u0027s </li><li>Trade school </li><li>Private School</li><li> Private hospital</li></ol>",
       "choice_a":"II and III",
       "choice_b":"II and IV",
       "choice_c":"II, III, and IV",
       "choice_d":"I, II, III, and  IV",
       "correct_answer":"D",
       "explanation":"An employee who works for any of those listed may participate in a TSA."
    },
    {
       "id":35996,
       "practice_test_id":"",
       "topic_id":9,
       "question":"ERISA governs retirement plans for all of the following except:",
       "choice_a":"Municipal employee",
       "choice_b":"Corporate vice president",
       "choice_c":"Paralegal",
       "choice_d":"Private Nurse",
       "correct_answer":"A",
       "explanation":"ERISA only governs private sector retirement plans. A municipal employee works in the public sector."
    },
    {
       "id":35993,
       "practice_test_id":"",
       "topic_id":9,
       "question":"As it relates to life insurance all of the following are deducted from the separate account except:",
       "choice_a":"Mortality risk fee",
       "choice_b":"Expense risk fee",
       "choice_c":"Administrative fee",
       "choice_d":"Investment management fee",
       "correct_answer":"C",
       "explanation":"The administrative fee is a one time fee to set up the policy and is deducted from the gross premium."
    },
    {
       "id":35994,
       "practice_test_id":2,
       "topic_id":9,
       "question":"An investor is considered an annuitant because:",
       "choice_a":"He has entered into a contract with an insurance company",
       "choice_b":"He has retired from a company and is collecting an annual annuity called a pension",
       "choice_c":"He has invested his money with an annuity firm",
       "choice_d":"He has retired and is living off his retirement income called his annuity",
       "correct_answer":"A",
       "explanation":"The individual who enters into a contract, called an annuity, with an insurance company is called an annuitant."
    },
    {
       "id":35992,
       "practice_test_id":"",
       "topic_id":9,
       "question":"As it relates to corporate retirement plans which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The contribution to a defined benefit plan varies  </li><li>The sponsor of a defined contribution plan assumes the investment risk </li><li>A defined contribution plan benefits older employees </li><li>The participant in a defined contribution plan assumes the investment risk</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"I, III, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"B",
       "explanation":"The contribution to a defined benefit plan will vary according to the investment results of the plan and based on the benefit promised. The participants in a defined contribution plan assume the investment risk of the plan"
    },
    {
       "id":35991,
       "practice_test_id":2,
       "topic_id":9,
       "question":"Another name for an educational IRA is:",
       "choice_a":"A Coverdell",
       "choice_b":"A 529",
       "choice_c":"A UGMA",
       "choice_d":"A SEP",
       "correct_answer":"A",
       "explanation":"An educational IRA is also called a Coverdell IRA"
    },
    {
       "id":35989,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An investor who owns a fixed annuity is subject to:",
       "choice_a":"Expense risk",
       "choice_b":"Investment risk",
       "choice_c":"Purchasing power risk",
       "choice_d":"Mortality risk",
       "correct_answer":"C",
       "explanation":"An investor who purchases a fixed annuity is subject to purchasing power risk."
    },
    {
       "id":35990,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An investor who purchases an annuity is known as:",
       "choice_a":"Annuitized",
       "choice_b":"Annuitant",
       "choice_c":"Annuitor",
       "choice_d":"Annuitee",
       "correct_answer":"B",
       "explanation":"An investor who purchases an annuity is known as the annuitant."
    },
    {
       "id":35988,
       "practice_test_id":5,
       "topic_id":9,
       "question":"An investor purchases a tax deferred annuity through a payroll deduction plan. They have deposited $20,000 over a 7 year period. Over the 7 years the money has grown to $28,300. The investor annuitizes the contract and wants to known what his tax liability is for each payment you should tell them:",
       "choice_a":"It is 100% taxed because you purchased it with pre tax dollars.",
       "choice_b":"The exclusion ratio will tell you what your tax liability is for each payment.",
       "choice_c":"You will be taxed on the growth at the capital gains rate",
       "choice_d":"It will be 100% taxed as ordinary income",
       "correct_answer":"B",
       "explanation":"The investor purchased the annuity with after tax dollars and will only pay taxes on the growth. The exclusion ratio will tell the investor how much of each payment is subject to tax."
    },
    {
       "id":35987,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An investor has deposited $100,000 into a qualified retirement account over a 10-year period. The value of the account has grown to $175,000 and the investor plans to retire and take a lump sum withdrawal. He will pay:",
       "choice_a":"Capital gains tax on $75,000 only",
       "choice_b":"Ordinary income taxes on the $75,000 only",
       "choice_c":"Ordinary income taxes on the whole $175,000",
       "choice_d":"Ordinary income taxes on the $100,000 and capital gains on the $75,000",
       "correct_answer":"C",
       "explanation":"Because the retirement account is qualified, the investors has deposited the money pretax, therefore all of the money is taxed when it is withdrawn. All taxable distributions from retirement plans are taxed as ordinary income."
    },
    {
       "id":35986,
       "practice_test_id":2,
       "topic_id":9,
       "question":"An investor has decided to move his IRA. He may do this:",
       "choice_a":"Once per year",
       "choice_b":"Twice per year",
       "choice_c":"Quarterly",
       "choice_d":"As often as he may choose",
       "correct_answer":"D",
       "explanation":"An investor may transfer or move their IRA as often as they like. Don\u0027t get this confused with a roll over which can  only be done once per year."
    },
    {
       "id":35985,
       "practice_test_id":3,
       "topic_id":9,
       "question":"An investor has been investing in his IRA for the past three years and has deposited a total of $9,000 into his account. He will be vested:",
       "choice_a":"100% after 5 years",
       "choice_b":"20% per year from 3-7 years",
       "choice_c":"100% after 7 years",
       "choice_d":"100% immediately",
       "correct_answer":"D",
       "explanation":"The money put into an IRA by the investor is always theirs. Vesting refers to how an employer\u0027s contribution to a corporate retirement plan becomes the property of the employee."
    },
    {
       "id":35983,
       "practice_test_id":4,
       "topic_id":9,
       "question":"An individual who cancels their variable life policy during the free look period will receive:",
       "choice_a":"Cash value only",
       "choice_b":"Cash value plus a refund of any sales charges in excess of 10% of the payments",
       "choice_c":"Refund of all premiums",
       "choice_d":"Refund of premiums minus any sales charges",
       "correct_answer":"C",
       "explanation":"An individual who cancels his policy during the free look period will receive a refund of all premiums paid."
    },
    {
       "id":35984,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An investor buying an immediate annuity buys:",
       "choice_a":"Accumulation units that are fixed in number",
       "choice_b":"Annuity units that are fixed in number",
       "choice_c":"Accumulation units that vary in number",
       "choice_d":"Annuity units that vary in number",
       "correct_answer":"B",
       "explanation":"An investor who purchases an immediate annuity buys annuity units that remain fixed in number."
    },
    {
       "id":35981,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An employee must be allowed to  participate in a corporate pension plan at:",
       "choice_a":18,
       "choice_b":21,
       "choice_c":25,
       "choice_d":19,
       "correct_answer":"B",
       "explanation":"An employee must be allowed  to participate in a corporate pension plan at 21."
    },
    {
       "id":35982,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An individual owns a variable life insurance policy with an assumed interest rate of 5%. The separate account earns 4%, the individual would expect? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The death benefit to go up </li><li>The death benefit to go down </li><li>The cash value to go up </li><li>The cash value to go down</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I and II",
       "choice_d":"II and III",
       "correct_answer":"D",
       "explanation":"The individual would expect the death benefit to go down and the cash value to go up. The AIR is only concerned about the death benefit, not the cash value as long as the performance of the separate account is positive the cash goes up"
    },
    {
       "id":35980,
       "practice_test_id":3,
       "topic_id":9,
       "question":"An annuity is a contract between:",
       "choice_a":"An individual and a corporation",
       "choice_b":"An individual and a mutual fund company",
       "choice_c":"An individual and an insurance company",
       "choice_d":"An individual and a plan company",
       "correct_answer":"C",
       "explanation":"An annuity is a contract between an individual and an insurance company."
    },
    {
       "id":35979,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An annuity has an AIR of 4%. The separate account earns 5% in April, and 7% in May. If the separate account earns 4% in June the payment to annuitants in July will be:",
       "choice_a":"Higher than the payment in  June",
       "choice_b":"Lower than the payment in June",
       "choice_c":"The same as the payment In June",
       "choice_d":"Lower than the payment in May",
       "correct_answer":"C",
       "explanation":"The separate account\u0027s performance equals the AIR so the payment will remain the same as the payment in June"
    },
    {
       "id":35978,
       "practice_test_id":3,
       "topic_id":9,
       "question":"All variable insurance policies must offer the investor all of the following except:",
       "choice_a":"90-day free look period",
       "choice_b":"Ability to borrow against cash value",
       "choice_c":"Contract exchange privileges",
       "choice_d":"Voting rights",
       "correct_answer":"A",
       "explanation":"All variable insurance policies must offer the investor a 45-day free look period."
    },
    {
       "id":35945,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An investor has annuitized her variable annuity. Which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Accumulation units have been exchanged for annuity units </li><li>Annuity units have been exchanged for accumulation units </li><li>The number of accumulation units is fixed </li><li>The number of annuity units is fixed</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"II and IV",
       "choice_d":"I and III",
       "correct_answer":"B",
       "explanation":"When an investor annuities a contract, they trade in their accumulation units for annuity units and the number of annuity units remains fixed."
    },
    {
       "id":35946,
       "practice_test_id":2,
       "topic_id":9,
       "question":"An investor has deposited $14,500 into a variable annuity over a three-year period. The money has grown to $17,800. The investor is 61 years old and must make a random withdrawal of $3,000. On what amount must he pay taxes?",
       "choice_a":"$0",
       "choice_b":"$3,000",
       "choice_c":"$700",
       "choice_d":"$2,300",
       "correct_answer":"B",
       "explanation":"The money taken from a variable annuity during a random withdrawal will be done on a LIFO basis, which means the growth will come out first and will be taxed. The investor will pay taxes on the entire $3,000."
    },
    {
       "id":35947,
       "practice_test_id":3,
       "topic_id":9,
       "question":"An investor has just begun the payout phase of their variable annuity and is wondering about the tax consequences of their payments. You should tell them:",
       "choice_a":"Your payments will be tax free",
       "choice_b":"You will have to pay capital gains on the money",
       "choice_c":"You will have to pay ordinary income taxes on the entire amount",
       "choice_d":"You will only be taxed on the growth portion of the payment",
       "correct_answer":"D",
       "explanation":"The investor will only be taxed on the distribution of growth and it will be taxed as ordinary income. The investor\u0027s cost base will be returned tax free."
    },
    {
       "id":35975,
       "practice_test_id":4,
       "topic_id":9,
       "question":"All of the following investments are allowed in an IRA except:",
       "choice_a":"US gold coins",
       "choice_b":"CD\u0027s",
       "choice_c":"Annuities",
       "choice_d":"Rare coins",
       "correct_answer":"D",
       "explanation":"Rare coins are not permitted in an IRA. US minted coins however, are allowed."
    },
    {
       "id":35976,
       "practice_test_id":5,
       "topic_id":9,
       "question":"All of the following may participate in a TSA plan except:",
       "choice_a":"A nurse",
       "choice_b":"A town clerk",
       "choice_c":"A school nurse",
       "choice_d":"A self-employed vendor",
       "correct_answer":"D",
       "explanation":"A TSA is only for employees of not for profit organizations and employees of municipal organizations. A self-employed person may not have a TSA."
    },
    {
       "id":35977,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All qualified corporate retirement plans must be:",
       "choice_a":"Set up in writing",
       "choice_b":"Set up as a trust",
       "choice_c":"Have a plan administrator or trustee to administer the plan",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are true about a qualified corporate retirement plan."
    },
    {
       "id":35974,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following have their portfolios held in the separate account except:",
       "choice_a":"Variable annuity",
       "choice_b":"Variable life policy",
       "choice_c":"Universal variable life policy",
       "choice_d":"UIT",
       "correct_answer":"D",
       "explanation":"The portfolios of a UIT are held by the UIT and it in turn issues shares of beneficial interest to the investors."
    },
    {
       "id":35973,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following have a fixed payment schedule except:",
       "choice_a":"Variable life insurance",
       "choice_b":"Whole life insurance",
       "choice_c":"Contractual plan",
       "choice_d":"Universal life insurance",
       "correct_answer":"D",
       "explanation":"All of those listed in the question have a fixed payment schedule except universal life."
    },
    {
       "id":35971,
       "practice_test_id":4,
       "topic_id":9,
       "question":"All of the following are true regarding a variable life insurance policy except:",
       "choice_a":"It is both a security and an insurance product",
       "choice_b":"Its investments are held in the general account",
       "choice_c":"It has a fixed premium",
       "choice_d":"It builds a cash value that may vary in amount",
       "correct_answer":"B",
       "explanation":"All of the choices are true except the investment portfolio is not held in the general account it is held in the separate account."
    },
    {
       "id":35972,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following are true regarding qualified retirement plans except:",
       "choice_a":"Contributions are currently tax deductible",
       "choice_b":"All eligible employees must be allowed to participate",
       "choice_c":"Excess over cost basis is taxed upon withdrawal",
       "choice_d":"All plans must be approved by the IRS",
       "correct_answer":"C",
       "explanation":"With a qualified plan, there is no cost base so that all the money is taxed when it is taken out."
    },
    {
       "id":35944,
       "practice_test_id":4,
       "topic_id":9,
       "question":"All of the following are ways an investor may purchase a variable annuity except:",
       "choice_a":"Periodic payment deferred annuity",
       "choice_b":"Single payment deferred annuity",
       "choice_c":"Single payment immediate annuity",
       "choice_d":"Periodic payment immediate annuity",
       "correct_answer":"D",
       "explanation":"There is no such thing as a periodic payment immediate annuity."
    },
    {
       "id":35970,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following are true about annuity units except:",
       "choice_a":"When an investor annuitizes a contract, he trades in his accumulation units for annuity units",
       "choice_b":"The number of annuity units is variable depending upon the fluctuation of the investments",
       "choice_c":"The number of annuity units an investor receives depends partially upon the annuitant\u0027s age and sex",
       "choice_d":"The number of annuity units an investor receives depends partially upon the payout option selected, the value of the account, and the assumed interest risk",
       "correct_answer":"B",
       "explanation":"The number of annuity units is fixed and represents the proportion of the owner\u0027s shares in the separate accounts portfolio."
    },
    {
       "id":35951,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A simplified Employee Pension IRA is:",
       "choice_a":"Frequently used by small companies and individuals to plan for retirement",
       "choice_b":"Attractive to small employers because it allows them to establish a retirement plan for their employees quickly and inexpensively",
       "choice_c":"A plan which requires all eligible employees to participate as well as the employer, both of whom are contributing to the fund",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are true about a SEP IRA."
    },
    {
       "id":35952,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A client who is a lawyer making $230,000 per year makes the maximum contribution to his Keogh plan. He has a full time paralegal that earns $65,000 per year and wants to know what he must do for his employee\u0027s retirement. You should tell him:",
       "choice_a":"Since you are self-employed, you can decide what to pay your own people",
       "choice_b":"You must contribute the same amount of money to the employee\u0027s Keogh as you did to yours",
       "choice_c":"You must make a contribution to the employee\u0027s Keogh at the same percentage rate as your own",
       "choice_d":"The employee is not self-employed and may not have a Keogh plan",
       "correct_answer":"C",
       "explanation":"A self-employed individual who has a full time employee must make a contribution for that employee at the same rate as his or her own contribution."
    },
    {
       "id":35953,
       "practice_test_id":2,
       "topic_id":9,
       "question":"A Keogh plan (HR-10) is which of the following?",
       "choice_a":"A qualified retirement plan",
       "choice_b":"Usually set up by individuals, sole proprietors, or unincorporated businesses",
       "choice_c":"May be funded only with earned income during a period when the business showed a gross profit",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"A Keogh plan allows individuals, sole proprietors, and unincorporated small businesses to establish a retirement plan for themselves and their employees."
    },
    {
       "id":35954,
       "practice_test_id":3,
       "topic_id":9,
       "question":"A Keogh plan is available for all of the following except:",
       "choice_a":"An independent coffee shop owner",
       "choice_b":"A lawyer",
       "choice_c":"A janitor at a local college",
       "choice_d":"A nurse at a local doctor\u0027s office",
       "correct_answer":"C",
       "explanation":"The janitor at a local college is not self-employed nor do they work for someone who is self-employed."
    },
    {
       "id":35955,
       "practice_test_id":4,
       "topic_id":9,
       "question":"Which of the following is a qualified account? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>SEP IRA </li><li>Traditional IRA </li><li>Educational IRA </li><li>Roth IRA</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"A",
       "explanation":"Only the SEP and the Traditional IRAs are funded with pretax dollars."
    },
    {
       "id":35956,
       "practice_test_id":5,
       "topic_id":9,
       "question":"A qualified retirement plan differs from a non-qualified retirement plan in all of the following ways except:",
       "choice_a":"Contributions for the qualified plan are pre-tax, while contributions for the non-qualified plan are after tax",
       "choice_b":"Participation must be allowed for everyone in the qualified plan while the corporation may choose who participates in the non-qualified plan",
       "choice_c":"IRS approval is required for both plans",
       "choice_d":"Withdrawals from a qualified plan are 100% taxed as ordinary income while growth in excess of the cost base is taxed as ordinary income in a non-qualified plan",
       "correct_answer":"C",
       "explanation":"IRS approval is required for participation in a qualified plan, but IRS approval is not required for a non-qualified plan."
    },
    {
       "id":35957,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An employee participating in a SEP IRA will be vested:",
       "choice_a":"After 2 years",
       "choice_b":"Gradually between 3-7 years",
       "choice_c":"After 5 years",
       "choice_d":"Immediately",
       "correct_answer":"D",
       "explanation":"Investors in SEP IRAs are vested immediately"
    },
    {
       "id":35958,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following investments exposes the investor to the most purchasing power risk?",
       "choice_a":"Growth fund",
       "choice_b":"Income fund",
       "choice_c":"Money market fund",
       "choice_d":"Fixed annuity",
       "correct_answer":"D",
       "explanation":"A fixed annuity will not provide any real protection from inflation and will subject the investor to the most purchasing power risk."
    },
    {
       "id":35959,
       "practice_test_id":1,
       "topic_id":9,
       "question":"A 401K retirement plan is all of the following except:",
       "choice_a":"A defined contribution plan",
       "choice_b":"Allows employee to contribute a portion of his salary to the plan each month",
       "choice_c":"Based on the concept of profit sharing",
       "choice_d":"Allows the employer to match some or all of the employee\u0027s contribution",
       "correct_answer":"C",
       "explanation":"A 401K retirement plan is not involved with profit sharing."
    },
    {
       "id":35960,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A 42 year old investor wants to put $20,000 into a plan to help meet the educational expenses of their 12 year old son. They want to make a lump sum deposit. Which would you recommend?",
       "choice_a":"A 529 plan",
       "choice_b":"A Coverdell IRA",
       "choice_c":"A Roth IRA",
       "choice_d":"A Growth mutual fund",
       "correct_answer":"A",
       "explanation":"A 529 plan would allow the investor to make a lump sum deposit. The key is that the investor is looking for a \u0022plan\u0022 to put money into and has a large sum of money to invest. The 529 plan is the correct option for this investor."
    },
    {
       "id":35961,
       "practice_test_id":2,
       "topic_id":9,
       "question":"A 45-year-old investor has rolled over $10,000 from an IRA to buy a car. How long does he have to deposit the money in another qualified plan?",
       "choice_a":"45 days",
       "choice_b":"60 days",
       "choice_c":"30 days",
       "choice_d":"90 days",
       "correct_answer":"B",
       "explanation":"An investor may roll over their IRA once per year and has 60 days to get the money into a qualified plan."
    },
    {
       "id":35962,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A customer has an unexpected expense to meet and would like to take a loan from his variable life insurance policy. Which of the following is not true?",
       "choice_a":"At least 75% of their cash value must be made available to them in the form of a loan",
       "choice_b":"Loans must be made available after 3 years",
       "choice_c":"Interest must be charged to the loan",
       "choice_d":"Interest must be charged on the loan and the rate must be equal to the prime rate at the time the loan is made",
       "correct_answer":"D",
       "explanation":"All of the answers in the question are true except there is no requirement that the interest rate be equal to the prime rate."
    },
    {
       "id":35963,
       "practice_test_id":3,
       "topic_id":9,
       "question":"A customer has just had their first child and they want to start putting money away for his future. They ask about the maximum contribution to an educational IRA. You should tell them:",
       "choice_a":"The maximum contribution is $2,000 per year after tax",
       "choice_b":"The maximum contribution is $2,000 per year pre tax",
       "choice_c":"The maximum contribution is $5,500 per year after tax",
       "choice_d":"The maximum contribution is $5,500 per year pre tax",
       "correct_answer":"A",
       "explanation":"The maximum contribution to an educational IRA is $2,000. All contributions to educational IRAs are made after taxes."
    },
    {
       "id":35964,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A fixed annuity guarantees all of the following except:",
       "choice_a":"Income for life",
       "choice_b":"Protection from inflation",
       "choice_c":"Rate of return",
       "choice_d":"Protection from investment risk",
       "correct_answer":"B",
       "explanation":"A fixed annuity provides all of those listed except protection from inflation. If inflation rises, the holder of a fixed annuity may end up worse off due to the loss of value of the dollar."
    },
    {
       "id":35965,
       "practice_test_id":4,
       "topic_id":9,
       "question":"A principal in a school has deposited $15,000 in a tax deferred annuity through a payroll deduction plan. The account has grown in value to $22,000. The principal plans to retire and take a lump sum distribution. On what amount does he pay taxes?",
       "choice_a":"$22,000",
       "choice_b":"$15,000",
       "choice_c":"$7,000",
       "choice_d":"$0",
       "correct_answer":"C",
       "explanation":"This is a non qualified plan meaning the money is deposited after taxes so the retiree will only pay taxes on the growth. The cost base will be returned to them tax free as they have already paid taxes on that amount."
    },
    {
       "id":35966,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A Single investor has invested $8,000 in his IRA for the current year. Which of the following is true?",
       "choice_a":"The investor may add an additional $1,000",
       "choice_b":"The investor is subject to a 6% penalty on the overage per year for as long as it remains in the IRA",
       "choice_c":"The investor is subject to a 10% penalty on the overage",
       "choice_d":"The investor is subject to a 6% penalty on the entire amount",
       "correct_answer":"B",
       "explanation":"The investor is subject to a 6% penalty on the excess amount for each year it remains in the plan."
    },
    {
       "id":35967,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A variable life insurance policyholder cancels her contract after the first year. She has paid $1,500 in premiums and she has $810 in cash value. $450 went towards sales charges and $340 went towards fees and the cost of insurance. What will she receive from the company when she cancels the contract?",
       "choice_a":"$1,010",
       "choice_b":"$810",
       "choice_c":"$1,050",
       "choice_d":"$1,500",
       "correct_answer":"B",
       "explanation":"The individual is entitled to receive the cash value only in this case. The insurance company may keep up to 30% of the first year\u0027s payments as sales charges."
    },
    {
       "id":35968,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following are deducted from the separate account for a variable life policy except:",
       "choice_a":"Mortality risk fee",
       "choice_b":"Management fee",
       "choice_c":"Expense risk fee",
       "choice_d":"Administrative fee",
       "correct_answer":"D",
       "explanation":"All of the choices listed are deducted from the separate account except the administrative fee, which is deducted from the gross premium"
    },
    {
       "id":35969,
       "practice_test_id":2,
       "topic_id":9,
       "question":"All of the following are true about an educational IRA except:",
       "choice_a":"Individuals may contribute up to $5,000 in after tax money to an educational IRA for each student",
       "choice_b":"The contributions are allowed to grow tax deferred",
       "choice_c":"The growth is allowed to be withdrawn tax-free as long as it is used for educational purposes",
       "choice_d":"If all of the funds have not been used by the time the student is 30 years of age, the account must be rolled over to another family member or distributed to the original student and taxed",
       "correct_answer":"A",
       "explanation":"Individuals may contribute up to $2,000 only to an educational IRA."
    },
    {
       "id":35948,
       "practice_test_id":3,
       "topic_id":9,
       "question":"An investor in a variable annuity may change their payout option:",
       "choice_a":"Under no circumstances",
       "choice_b":"If their financial needs change significantly",
       "choice_c":"To convert to a lump sum withdrawal",
       "choice_d":"Upon the death of a spouse for joint with last survivor",
       "correct_answer":"A",
       "explanation":"An investor may never change their payout option once it has been set."
    },
    {
       "id":35949,
       "practice_test_id":4,
       "topic_id":9,
       "question":"A 55 year old investor who withdraws money from a variable annuity to meet a family emergency will pay:",
       "choice_a":"Ordinary income taxes only",
       "choice_b":"Capital gains taxes only",
       "choice_c":"Ordinary income taxes plus a 10% penalty",
       "choice_d":"No taxes because the money deposited into a variable annuity are after tax dollars",
       "correct_answer":"C",
       "explanation":"The investor will have to pay the ordinary income taxes on the money as well as a 10% penalty because he is under 59\u00BD."
    },
    {
       "id":35950,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A client who is 65 years old has invested $10,000 in a Roth IRA. It has now grown to $14,000. He plans to retire and take a lump sum distribution. He will pay taxes on:",
       "choice_a":"$14,000",
       "choice_b":"$4,000",
       "choice_c":"$10,000",
       "choice_d":"$0",
       "correct_answer":"D",
       "explanation":"The money has been deposited in a Roth IRA after taxes. It is allowed to grow tax deferred. If you are over 59\u00BD and the money has been there for at least 5 years, then it may all be returned without paying taxes on the growth."
    },
    {
       "id":36060,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An investor has just begun the payout phase of their variable annuity and is wondering about the tax consequences of their payments. You should tell them:",
       "choice_a":"Your payments will be tax free",
       "choice_b":"You will have to pay capital gains on the money",
       "choice_c":"You will have to pay ordinary income taxes on the entire amount",
       "choice_d":"You will only be taxed on the growth portion of the payment",
       "correct_answer":"D",
       "explanation":"The investor will only be taxed on the distribution of growth and it will be taxed as ordinary income. The investor\u0027s cost base will be returned tax free."
    },
    {
       "id":35046,
       "practice_test_id":"",
       "topic_id":10,
       "question":"If a FINRA member wishes to include a recommendation in its customer communication, which of the following are true?",
       "choice_a":"The firm must have a reasonable basis for making the recommendation",
       "choice_b":"The firm must disclose if they are a market maker in the security they are recommending",
       "choice_c":"The firm must disclose if they have been a manager or co-manager in any of the issuers public securities offerings in the prior 12 months",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The firm must have a reasonable basis for making the recommendation and must also disclose any information that could be construed as a possible conflict of interest."
    },
    {
       "id":35048,
       "practice_test_id":1,
       "topic_id":10,
       "question":"According to FINRA Rule 2210, copies of all institutional communications must be kept by the broker dealer for a minimum of how long?",
       "choice_a":"1 year",
       "choice_b":"2 years",
       "choice_c":"3 years",
       "choice_d":"5 years",
       "correct_answer":"C",
       "explanation":"Copies of all institutional communications must be retained by the broker dealer for 3 years."
    },
    {
       "id":35049,
       "practice_test_id":1,
       "topic_id":10,
       "question":"According to FINRA Rule 2210, copies of all retail communication must be kept by the broker dealer for a minimum of how long?",
       "choice_a":"1 year",
       "choice_b":"2 years",
       "choice_c":"3 years",
       "choice_d":"5 years",
       "correct_answer":"C",
       "explanation":"Copies of all retail communications must be retained by the broker dealer for 3 years."
    },
    {
       "id":35050,
       "practice_test_id":1,
       "topic_id":10,
       "question":"All of the following are considered institutional investors under FINRA Rule 2210 except:",
       "choice_a":"An investment advisor with $30 million in total assets",
       "choice_b":"An individual with $40 million in total assets",
       "choice_c":"A government entity",
       "choice_d":"An insurance company with $75 million in total assets",
       "correct_answer":"B",
       "explanation":"Investment advisors, government entities, insurance companies, banks and S&Ls and employee benefit plans with at least 100 participants are automatically considered institutional investors under the Rule. However, an individual person must have at least $50 million in total assets to qualify as such."
    },
    {
       "id":35051,
       "practice_test_id":"",
       "topic_id":10,
       "question":"Joe Smith, a registered representative of DCH, Inc. a registered broker dealer, will be making a public appearance next week. In his speech he will be making a recommendation of TRF common stock. What information must Joe disclose?",
       "choice_a":"If there is any conflict of interest in making the public appearance",
       "choice_b":"Whether Joe has a long or short position in the stock",
       "choice_c":"Whether Joe owns rights or warrants on the stock",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Any time an associated person makes a public appearance he must disclose if there is a potential conflict of interest. This includes disclosing if the person has any financial interest in the security he is recommending."
    },
    {
       "id":35052,
       "practice_test_id":"",
       "topic_id":10,
       "question":"When making a public appearance, members must file which of the following with FINRA? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Any power point slides that will be used in the presentation </li><li>All handouts that will be distributed to the participants </li><li>The script that the presenter will be using</li></ol>",
       "choice_a":"III only",
       "choice_b":"I and II",
       "choice_c":"II and III",
       "choice_d":"I, II, III",
       "correct_answer":"D",
       "explanation":"According to FINRA Rule 2210, when a member is making a public appearance any script, slides or handouts are treated as retail communication and must be filed with FINRA."
    },
    {
       "id":35053,
       "practice_test_id":2,
       "topic_id":10,
       "question":"When an established broker dealer wishes to place a recruitment ad in a local newspaper all of the following are true except:",
       "choice_a":"The ad does not have to state the name of the firm",
       "choice_b":"The ad does not need principal approval",
       "choice_c":"The ad cannot contain exaggerated claims",
       "choice_d":"The ad is considered retail communication",
       "correct_answer":"B",
       "explanation":"A recruitment ad is treated as retail communication by FINRA. Therefore, it must be approved by a licensed principal. And although member\u0027s may place a blind recruitment ad (without the firm\u0027s name on it), the ad cannot make any exaggerated claims about opportunities in the securities business."
    },
    {
       "id":35056,
       "practice_test_id":2,
       "topic_id":10,
       "question":"All of the following are prohibited practices except:",
       "choice_a":"Front running",
       "choice_b":"Hypothecating",
       "choice_c":"Commingling",
       "choice_d":"Unauthorized trading",
       "correct_answer":"B",
       "explanation":"Hypothecation occurs when a customer has agreed to allow the broker dealer to pledge his securities to the bank as collateral for a margin loan. In order for hypothecation to be permitted a customer must sign a hypothecation agreement. Front running, commingling, and unauthorized trading are all examples of prohibited practices."
    },
    {
       "id":35058,
       "practice_test_id":2,
       "topic_id":10,
       "question":"Which of the following statements are true regarding the Act of 1933? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It regulates the new issues </li><li>It regulates the primary market </li><li>It regulates trades between issuers and the public </li><li>It regulates investor to investor trades</li></ol>",
       "choice_a":"I, II",
       "choice_b":"III, IV",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"The Act of 1933 regulates the primary market, also known as the new issue market, where issuers sell securities to the public for the first time. Once the securities are in the public hands, they are traded between investors, and those trades are regulated by the Act of 1934."
    },
    {
       "id":35059,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A customer is seeking to execute an order with your broker dealer. Utilizing FINRA\u0027s 5 percent policy what will be the basis for the mark down?",
       "choice_a":"The highest offer",
       "choice_b":"The highest bid",
       "choice_c":"The lowest offer",
       "choice_d":"The lowest bid",
       "correct_answer":"B",
       "explanation":"The key to this question is \u0022mark down\u0022. A mark down is only charged when the customer is the seller of a security. As such the marked down will be calculated based on the highest (best) bid."
    },
    {
       "id":35060,
       "practice_test_id":"",
       "topic_id":10,
       "question":"As it relates to the firm element continuing education plan requirement which of the following is correct?",
       "choice_a":"It is based on the agent\u0027s initial registration date",
       "choice_b":"It is based on the date the agent submitted the most recent U4",
       "choice_c":"It is based on a needs analysis",
       "choice_d":"It must be performed every 2 years",
       "correct_answer":"C",
       "explanation":"The firm element portion of the continuing education plan is based on a needs analysis conducted by the firm. The firm must conduct its firm element training every year."
    },
    {
       "id":35061,
       "practice_test_id":3,
       "topic_id":10,
       "question":"An agent who has been registered continuously for fifteen years leaves the industry for 18 months to pursue other interests. After 18 months the agent becomes re-associated with another member firm. Which of the following is true?",
       "choice_a":"The agent\u0027s regulatory continuing education requirement is based on the date of re-association",
       "choice_b":"The agent\u0027s regulatory continuing education requirement is based on the date on their last U5",
       "choice_c":"The agent\u0027s regulatory continuing education requirement is based on the date of initial association",
       "choice_d":"The agent\u0027s regulatory continuing education requirement is based on the date of original association less the time spent out of the industry",
       "correct_answer":"C",
       "explanation":"An agent who leaves the industry for less than 24 months will have their regulatory continuing education requirement based on the date of initial association."
    },
    {
       "id":35063,
       "practice_test_id":3,
       "topic_id":10,
       "question":"A member has received a written notice from a representative of a customer claiming that the member firm has acted in bad faith by recommending investments that were too risky and which caused the customer to suffer large losses. Which of the following Actions is not required of the member who received the notice?",
       "choice_a":"The firm must electronically file the complaint within 15 calendar days of the end of the quarter",
       "choice_b":"The principal must review the complaint and respond within 10 days",
       "choice_c":"The complaint is subject to retention for 4 years",
       "choice_d":"The complaint must be maintained in a supervising OSJ",
       "correct_answer":"B",
       "explanation":"All of the choices listed are required of a member firm who receives a complaint except there is no time frame in which the firm must respond to the complaint. The principal must review all complaints"
    },
    {
       "id":35064,
       "practice_test_id":3,
       "topic_id":10,
       "question":"A member firm with multiple offices each differing in size, location and function must do which of the following?",
       "choice_a":"Designate an office with custody of customer assets as a corporate headquarters",
       "choice_b":"Designate in writing to FINRA which offices are OSJs",
       "choice_c":"Assign a duly qualified principal to oversee each branch",
       "choice_d":"Require satellite offices to use the address of the satellite and its OSJ on all communications",
       "correct_answer":"B",
       "explanation":"A member firm must designate in writing to FINRA which offices are OSJs. A satellite office may not use its address on communications. It may only use the address of its branch or OSJ. A branch office may  be managed by a resident agent and an office with custody of customer assets must be designated as an OSJ."
    },
    {
       "id":35065,
       "practice_test_id":"",
       "topic_id":10,
       "question":"An agent who lives in Connecticut and works in New York maintains a vacation home in Florida. During the Winter the agent spends a considerable amount of time in the vacation home in Florida. The agent must be assigned to a branch if the agent works out of the vacation home:",
       "choice_a":"for more than 45 days",
       "choice_b":"for more than 30 days",
       "choice_c":"for more than 60 days",
       "choice_d":"for more than 90 days",
       "correct_answer":"B",
       "explanation":"The agent must be assigned to a branch if the agent works out of the vacation home for more than 30 days"
    },
    {
       "id":35067,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A firm that receives currency from a client in excess of $10,000 must fill out and submit a currency transaction report (CTR) form 4789:",
       "choice_a":"on the day the currency is received",
       "choice_b":"within 10 days of receipt",
       "choice_c":"within 15 days of receipt",
       "choice_d":"within 48 hours",
       "correct_answer":"C",
       "explanation":"A firm that receives currency from a client in excess of $10,000 must  fill out and submit a currency transaction report (CTR) form 4789 within 15 days of receipt."
    },
    {
       "id":35068,
       "practice_test_id":5,
       "topic_id":10,
       "question":"As it relates to a member\u0027s AML program which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It must be approved by senior management </li><li>A SARs must be filed for any suspicious activity exceeding $10,000 </li><li>All SARs must be kept for 3 years, 2 years readily accessible </li><li>AML programs must ensure customers do not appear on the OFAC list </li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"A",
       "explanation":"All AML programs must be approved by members of senior management. AML programs must ensure that customers do not appear on the OFAC list of known or suspected terrorists. SARs must be filed for suspicious activity involving amounts of $5,000 or more and all SARs must be kept for 5 years."
    },
    {
       "id":35379,
       "practice_test_id":"",
       "topic_id":10,
       "question":"JKL Manufacturing is seeking to go public and is in the process of preparing its S1 Registration statement. As it relates to the review of the information contained therein, which of the following is correct?",
       "choice_a":"The documents will be reviewed by both FINRA and the SEC for a minimum of 20 days",
       "choice_b":"The documents will be reviewed by both FINRA and the SEC for a minimum of 25 days",
       "choice_c":"The documents will be reviewed by the SEC for a minimum of 20 days",
       "choice_d":"The documents will be reviewed by FINRA for a minimum of 20 days",
       "correct_answer":"C",
       "explanation":"The S1 registration statement is filed with the SEC prior to a company going public. The registration statement is reviewed by the SEC for a minimum of 20 days. This is known as the cooling off period."
    },
    {
       "id":35380,
       "practice_test_id":4,
       "topic_id":10,
       "question":"An investor who is not associated with the issuer has purchased 10,000 shares of TYU common stock through a private placement conducted 3 months ago. The investor is asking when he can sell the shares. You should advise him:",
       "choice_a":"You can sell your shares now subject to the volume limitation of rule 144",
       "choice_b":"You can sell your shares in 3 months subject to the volume limitation of rule 144",
       "choice_c":"You can sell your shares now without being subject to the volume limitation of rule 144",
       "choice_d":"You can sell your shares in 3 months without being subject to the volume limitation of rule 144",
       "correct_answer":"D",
       "explanation":"The holding period for a private placement is 6 months. Since this investor purchased the shares 3 months ago, they must wait an additional 3 months prior to selling the shares. As the investor is not affiliated with the issuer, the investor may sell the shares without being subject to the volume limitations of rule 144."
    },
    {
       "id":35381,
       "practice_test_id":4,
       "topic_id":10,
       "question":"Tom is a CPA who purchased shares of RET through a private placement several years ago. Tom is not looking to liquidate his share in RET. Which of the following is correct?",
       "choice_a":"Tom must file form 144 within 6 months of selling his shares",
       "choice_b":"Tom must file form 144 within 90 days of selling his shares",
       "choice_c":"If the shares being sold are less than 10,000 shares and less than $100,000 in value Tom will not be required to file form 144",
       "choice_d":"Once the shares are sold by Tom, the shares will increase the amount of shares in the company\u0027s float",
       "correct_answer":"D",
       "explanation":"Once shares are sold under Rule 144, those shares become part of the publicly traded float for the company. Form 144 must be filed at the time the investor enters the order to sell."
    },
    {
       "id":39462,
       "practice_test_id":"",
       "topic_id":10,
       "question":"Under Rule 144 an investor is selling his restricted stock after holding it the required length of time (holding period). For the buyer of these shares, the stock they are purchasing is:",
       "choice_a":"now considered registered and is no longer subject to a holding period.",
       "choice_b":"now considered registered, but is still subject to a holding period.",
       "choice_c":"still considered unregistered and will still be subject to a holding period.",
       "choice_d":"still considered unregistered, but is no longer subject to a holding period.",
       "correct_answer":"A",
       "explanation":"Once the holding period has been met, shares being sold subject to Rule 144 are effectively considered to be registered shares. For buyers of these shares, they are being purchased unencumbered and are no longer subject to any holding period."
    },
    {
       "id":39463,
       "practice_test_id":4,
       "topic_id":10,
       "question":"Under the penny stock cold-calling rule, an established customer is one who has held an account with a broker-dealer for at least one year, and has within the past calendar year:",
       "choice_a":"made a deposit of cash or securities into the brokerage account.",
       "choice_b":"made a purchase or sale of either stocks or bonds in the account.",
       "choice_c":"made a purchase or sale of a penny stock in the account.",
       "choice_d":"made a purchase of either stocks or bonds totaling $1,000 or more in value in the account.",
       "correct_answer":"A",
       "explanation":"Under the penny stock cold-calling rule an established customer is someone who has held an account with a broker-dealer for at least one year and has made a deposit of funds or securities into the account or has made at least 3 penny stock purchases of different issuers on different days in the account."
    },
    {
       "id":39480,
       "practice_test_id":"",
       "topic_id":10,
       "question":"When an associated person is barred from the securities industry by the Securities Exchange Commission (SEC), that person may:",
       "choice_a":"only associate with another member firm with SEC permission.",
       "choice_b":"never associate with another member firm for life.",
       "choice_c":"still be employed by a member firm but not in a registered capacity.",
       "choice_d":"still serve as an officer or director of a member firm but have no sales function.",
       "correct_answer":"A",
       "explanation":"When an associated person is barred from the industry by the SEC, no member firm may allow that person to associate with it in any capacity. The only exception would be if the SEC were to grant express permission to do so."
    },
    {
       "id":39488,
       "practice_test_id":"",
       "topic_id":10,
       "question":"The Municipal Securities Rulemaking Board (MSRB) does all of the following except for:",
       "choice_a":"writing all of the municipal securities rules and regulations.",
       "choice_b":"regulating the trading of state or local municipal securities on exchanges.",
       "choice_c":"regulating the function of underwriting municipal securities.",
       "choice_d":"regulating the municipalities that are issuing municipal securities.",
       "correct_answer":"D",
       "explanation":"The MSRB writes its own rules and regulates all matters related to the underwriting and trading of municipal securities issued at both the state and local level. It does not however regulate municipal issuers (municipalities). Additionally, remember that the MSRB has no power to enforce its own rules and regulations. The enforcement of MSRB rules and regulations is left to other self-regulatory organizations (SROs), such as FINRA."
    },
    {
       "id":39489,
       "practice_test_id":5,
       "topic_id":10,
       "question":"Registration with the Securities and Exchange Commission (SEC) by a broker-dealer conveys which of the following?",
       "choice_a":"That the SEC has accepted and approved the member firm\u0027s registration to do business.",
       "choice_b":"That the SEC has made a positive determination as to the financial strength of the member firm.",
       "choice_c":"That the SEC has approved the member firm\u0027s business model and affirms no anti-trust laws have been violated.",
       "choice_d":"That the SEC guarantees that the conduct of the member firm will abide by all securities industry rules.",
       "correct_answer":"A",
       "explanation":"Registration only conveys that the SEC has accepted and approved the member firm\u0027s registration to do business. Registration with the SEC by any company, broker-dealer or otherwise, in no way implies that the SEC has passed upon or approved a company\u0027s financial standing, business model, or conduct."
    },
    {
       "id":35729,
       "practice_test_id":"",
       "topic_id":11,
       "question":"An investor is considered bearish if all of the following are true except:",
       "choice_a":"He believes that the stock\u0027s value will decrease over time.",
       "choice_b":"He buys calls so he can sell them again quickly.",
       "choice_c":"He buys puts on the belief that the stock will decrease in value.",
       "choice_d":"He sells calls in hopes of making some money.",
       "correct_answer":"B",
       "explanation":"A bearish investor doesn\u0027t buy calls; he sells them."
    },
    {
       "id":35730,
       "practice_test_id":5,
       "topic_id":11,
       "question":"An investor is considered bullish if:",
       "choice_a":"He believes that a stock\u0027s value will increase over time",
       "choice_b":"He buys calls on the belief that the value will rise over time.",
       "choice_c":"He sells puts on the belief that the securities price will rise.",
       "choice_d":"All of the choices listed.",
       "correct_answer":"D",
       "explanation":"Buying calls allows the buyer to buy at a set price in the future and selling puts obligates the seller to purchase the stock now. Both are hoping for a rise in the market price of the stock."
    },
    {
       "id":35732,
       "practice_test_id":1,
       "topic_id":11,
       "question":"Securities which are not listed on any of the worldwide exchanges trade:",
       "choice_a":"At the centralized location in New York known as NASDAQ headquarters.",
       "choice_b":"Over the counter (OTC) or on the NASDAQ via computers and phone lines.",
       "choice_c":"In auction markets known as NASDAQ.",
       "choice_d":"Investor to broker directly on the phone or computer.",
       "correct_answer":"B",
       "explanation":"NASDAQ has no physical location, is not an auction market, and stocks are traded broker to broker without the investors being aware of the terms."
    },
    {
       "id":35733,
       "practice_test_id":"",
       "topic_id":11,
       "question":"The Third Market and the fourth Market differ in that:",
       "choice_a":"In the Third Market brokers deal directly with individuals on exchange-listed stocks, and the Fourth Market individuals deal with individuals directly on exchange-listed stocks.",
       "choice_b":"In the Third Market brokers deal directly with brokers on exchange-listed stocks, and the Fourth Market brokers deal with individuals directly on exchange-listed stocks.",
       "choice_c":"In the Third Market brokers deal directly with brokers on exchange-listed stocks, and the Fourth Market brokers deal with large corporations directly on exchange-listed stocks.",
       "choice_d":"In the Third Market brokers deal directly with brokers on exchange-listed stocks, and the Fourth Market large corporations deal with large corporations directly on exchange-listed stocks.",
       "correct_answer":"D",
       "explanation":"Neither the Third Market nor the Fourth Market uses the floor of the exchange, but rather deals directly through a NASDAQ environment. This environment for the Fourth Market is called INSTINET."
    },
    {
       "id":35734,
       "practice_test_id":1,
       "topic_id":11,
       "question":"Which of the following expose the investor to unlimited risk? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Sell a naked put </li><li>Sell a naked call </li><li>Short sale of a stock </li><li>Purchase of a call</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"III and IV",
       "choice_d":"I,II and IV",
       "correct_answer":"B",
       "explanation":"The sale of a naked call and the short sale of stock subject the investor to unlimited risk."
    },
    {
       "id":35735,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following investors has unlimited risk?",
       "choice_a":"A call buyer",
       "choice_b":"A put buyer",
       "choice_c":"A call Seller",
       "choice_d":"A put seller",
       "correct_answer":"C",
       "explanation":"The seller of a call has unlimited risk because there is no limit to how high the stock can go."
    },
    {
       "id":35737,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Who acts as the customer\u0027s agent?",
       "choice_a":"Broker",
       "choice_b":"Dealer",
       "choice_c":"Neither",
       "choice_d":"Both",
       "correct_answer":"A",
       "explanation":"A firm acting as a broker is the customer\u0027s agent. The firm will charge the customer a fee or a commission to execute the customer\u0027s order."
    },
    {
       "id":35738,
       "practice_test_id":2,
       "topic_id":11,
       "question":"Who charges a commission?",
       "choice_a":"Broker",
       "choice_b":"Dealer",
       "choice_c":"Neither",
       "choice_d":"Both",
       "correct_answer":"A",
       "explanation":"A broker charges a commission to execute the order. A dealer acts as a principal in the trade and charges a markup."
    },
    {
       "id":35739,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Who charges a markup or markdown when executing an order?",
       "choice_a":"Broker",
       "choice_b":"Dealer",
       "choice_c":"Neither",
       "choice_d":"Both",
       "correct_answer":"B",
       "explanation":"A dealer charges a markup or markdown as a profit when acting in a principal capacity. A dealer is entitled to a fair profit when executing orders on a principal basis."
    },
    {
       "id":35743,
       "practice_test_id":2,
       "topic_id":11,
       "question":"Who must disclose the amount involved in the  commission?",
       "choice_a":"Broker",
       "choice_b":"Dealer",
       "choice_c":"Neither",
       "choice_d":"Both",
       "correct_answer":"A",
       "explanation":"A broker must disclose the amount of commission involved in any transaction."
    },
    {
       "id":35744,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Who participates in the trade as a principal?",
       "choice_a":"Broker",
       "choice_b":"Dealer",
       "choice_c":"Neither",
       "choice_d":"Both",
       "correct_answer":"B",
       "explanation":"A dealer will participate in a trade as a principal. If the customer is  buying the stock the dealer will sell the stock to the customer. Alternatively, if the customer is selling the stock the dealer will buy the stock from the customer."
    },
    {
       "id":35745,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Your brokerage firm acts as a market maker for several high volume stocks that are quoted on the NASDAQ. What is the firm\u0027s consideration for being a market maker:",
       "choice_a":"Commission",
       "choice_b":"Fees",
       "choice_c":"Spread",
       "choice_d":"5%",
       "correct_answer":"C",
       "explanation":"Firms that act as market makers in NASDAQ securities are trying to make the spread that is the difference between the bid and the ask."
    },
    {
       "id":35746,
       "practice_test_id":3,
       "topic_id":11,
       "question":"Your brokerage firm regularly trades stock in the third market. Which of the following best describes what they do?",
       "choice_a":"They regularly trade stocks with institutions",
       "choice_b":"They regularly act as an underwriter",
       "choice_c":"They regularly trade listed stocks over the NASDAQ system",
       "choice_d":"They regularly participate in private securities transactions",
       "correct_answer":"C",
       "explanation":"A third market transaction is a transaction in an exchange listed security executed over the NASDAQ workstation"
    },
    {
       "id":35747,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Your customer is the manager of a large pension fund and tells you that he regularly trades stock in the fourth market. He regularly trades stock with:",
       "choice_a":"Market makers",
       "choice_b":"Other institutions",
       "choice_c":"Broker dealers",
       "choice_d":"Issuers",
       "correct_answer":"B",
       "explanation":"Fourth market transactions are transactions which take place between two large institutions without the use of a broker dealer."
    },
    {
       "id":35754,
       "practice_test_id":3,
       "topic_id":11,
       "question":"Which level in the NASDAQ System allows market-makers the ability to change quotes?",
       "choice_a":"Level I",
       "choice_b":"Level II",
       "choice_c":"Level III",
       "choice_d":"Level IV",
       "correct_answer":"C",
       "explanation":"Level III NASDAQ subscription service allows market makers to enter quotes."
    },
    {
       "id":35756,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following is true of a market-maker?",
       "choice_a":"They function as a principal",
       "choice_b":"Quoted prices are for odd lots only",
       "choice_c":"They will buy only in a rising market",
       "choice_d":"They need not accept round lot orders",
       "correct_answer":"A",
       "explanation":"Market makers are always acting as a principal. Quotes are for round lot orders."
    },
    {
       "id":35758,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following statements is true concerning FINRA\u0027s \u00275% markup\u0027 policy?",
       "choice_a":"Allows no deviation from a markup of precisely 5%.",
       "choice_b":"Is general policy only and does not apply to all transactions",
       "choice_c":"Places a limit on dealer loans",
       "choice_d":"Tends to reduce markups on very low priced stock",
       "correct_answer":"B",
       "explanation":"The 5% policy is a guideline not a rule and it does not apply to all transactions."
    },
    {
       "id":35759,
       "practice_test_id":5,
       "topic_id":11,
       "question":"Which of the following is an order to buy that allows the floor broker to exercise judgment as to the price?",
       "choice_a":"Market order",
       "choice_b":"Not held order",
       "choice_c":"Fill or kill",
       "choice_d":"AON",
       "correct_answer":"B",
       "explanation":"A not held order allows the floor broker to determine the best time and price to execute and order."
    },
    {
       "id":35760,
       "practice_test_id":"",
       "topic_id":11,
       "question":"What is the name of a special order that must be executed for the entire amount of shares or not at all without regard to time?",
       "choice_a":"FOK",
       "choice_b":"IOC",
       "choice_c":"AON",
       "choice_d":"DNR",
       "correct_answer":"C",
       "explanation":"An all or none order requires that all the shares be bought or sold. It may be entered as a day order or GTC."
    },
    {
       "id":35761,
       "practice_test_id":4,
       "topic_id":11,
       "question":"Which of the following statements is true concerning NASDAQ quotes?",
       "choice_a":"They relate the price and volume of each transaction",
       "choice_b":"They include markup/commission",
       "choice_c":"They are the highest bid and lowest offer by any dealer",
       "choice_d":"They are prepared separately for each FINRA district",
       "correct_answer":"C",
       "explanation":"NASDAQ quotes contain the highest bid and lowest offer displayed by any dealer and do not include markups or commissions."
    },
    {
       "id":35762,
       "practice_test_id":"",
       "topic_id":11,
       "question":"A stock with a current market value of $35 splits 5-for-4. What price would the stock be adjusted to immediately following the split?",
       "choice_a":"$43.75",
       "choice_b":"$26.25",
       "choice_c":"$28.00",
       "choice_d":"There is no adjustment",
       "correct_answer":"C",
       "explanation":"To determine the price of the stock multiply the stock price by the reciprocal of the fraction. In this case 35 X 4/5 = 28"
    },
    {
       "id":35763,
       "practice_test_id":"",
       "topic_id":11,
       "question":"All of the following would be traded in the secondary market, except:",
       "choice_a":"Listed common stocks.",
       "choice_b":"Unlisted bonds.",
       "choice_c":"Bonds that are trading flat.",
       "choice_d":"New issues.",
       "correct_answer":"D",
       "explanation":"New Issues are not traded in the secondary market. All new issue transactions take place in the primary market."
    },
    {
       "id":35764,
       "practice_test_id":4,
       "topic_id":11,
       "question":"The PINK OTC market shows:",
       "choice_a":"Bond prices and market makers",
       "choice_b":"Retail stock prices and firm quotes",
       "choice_c":"Bid and asked quotes for stocks and broker/dealers making a market in stocks",
       "choice_d":"All new issue prices",
       "correct_answer":"C",
       "explanation":"The Pink OTC market shows bid and ask prices for securities and the names of the broker dealers quoting the securities. The Pink OTC market shows firm quotes and has real time reporting."
    },
    {
       "id":35765,
       "practice_test_id":"",
       "topic_id":11,
       "question":"The over-the-counter market is:",
       "choice_a":"Where customers buy and sell publicly with each other.",
       "choice_b":"An auction market.",
       "choice_c":"The fourth market.",
       "choice_d":"Negotiated between broker/dealers.",
       "correct_answer":"D",
       "explanation":"The over the counter market is a negotiated market."
    },
    {
       "id":35766,
       "practice_test_id":"",
       "topic_id":11,
       "question":"When the underlying common stock sells ex-dividend, a GTC buy-limit order will:",
       "choice_a":"Remain unchanged.",
       "choice_b":"Be reduced.",
       "choice_c":"Be increased.",
       "choice_d":"None of the choices listed.",
       "correct_answer":"B",
       "explanation":"Buy limit orders entered GTC are entered below the market price and will be reduced by the amount of the dividend."
    },
    {
       "id":35767,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Assume an order was placed prior to the opening-\u0027Sell Short 500 X  67.20 STOP LIMIT GTC.\u0027 At what price was the stop activated? (Assume trades occurred as follows): Open 67.22 ...67.19.... 67.20",
       "choice_a":"67.19.",
       "choice_b":"67.20.",
       "choice_c":"67.22.",
       "choice_d":"The stop was not activated.",
       "correct_answer":"A",
       "explanation":"The price that activated the order was 67.19. In order for a stop to be activated the stock has to trade at or through the stop price."
    },
    {
       "id":35769,
       "practice_test_id":5,
       "topic_id":11,
       "question":"A broker enters a day order for a customer. Later in the day the customer changes the order to a good-until-cancelled (GTC) order, leaving the price and the quantity the same. The order:",
       "choice_a":"Loses its position.",
       "choice_b":"Does not lose its position.",
       "choice_c":"Is automatically cancelled.",
       "choice_d":"None of the choices listed.",
       "correct_answer":"A",
       "explanation":"Any change to the terms of an order causes it to lose its place on the DMM\u0027s book."
    },
    {
       "id":35771,
       "practice_test_id":2,
       "topic_id":11,
       "question":"A stock listed on the NYSE stopped trading because of an influx of orders. Trading of the stock in other markets will appear on the Network A (consolidated tape):",
       "choice_a":"As it occurs, even though it stopped trading on the NYSE.",
       "choice_b":"Will not be shown during the time it stopped trading on the NYSE.",
       "choice_c":"The trades are held back and printed after trading starts on the NYSE again.",
       "choice_d":"Trades in other markets will not resume until trading starts on the NYSE again.",
       "correct_answer":"D",
       "explanation":"If a stock is halted on the NYSE it will be halted in all markets"
    },
    {
       "id":35773,
       "practice_test_id":3,
       "topic_id":11,
       "question":"A customer enters a sell-limit order at 85 GTC. The last sale in the stock was 82. A 60¢ dividend is declared. On the ex-dividend date how much will the DMM reduce the order on his book?",
       "choice_a":"60 cents",
       "choice_b":"62.5 cents",
       "choice_c":"Nothing only if marked do not reduce",
       "choice_d":"Nothing.",
       "correct_answer":"D",
       "explanation":"Orders placed above the market are not reduced for dividends. Only orders placed below the market are reduced for dividends."
    },
    {
       "id":35774,
       "practice_test_id":4,
       "topic_id":11,
       "question":"A woman who is short 1,000 shares of XYZ at 105 is going on vacation. She enters orders to buy either 1,000 shares of XYZ at 101 GTC (to cover her short sale should the stock decline to 101), or 1,000 at 109 buy-stop GTC (to cover her short sale if the stock should go up to 109). She tells the R.R. she wants to close out her short position of 1,000 XYZ by either buying the stock at a lower price than she sold it (at 101), or at a higher price if it should advance (at 109). The stock declines to 101, but only 700 shares are bought at 101. The GTC orders would now be changed to:",
       "choice_a":"Buy 300 XYZ at 101 or 300 XYZ at 109 buy-stop GTC.",
       "choice_b":"Buy 300 XYZ at 101 or 1,000 XYZ at 109 buy-stop GTC.",
       "choice_c":"Buy 300 XYZ at 101 or 700 XYZ at 109 buy-stop GTC.",
       "choice_d":"Buy 700 XYZ at 100 or 300 XYZ at 109 buy-stop GTC.",
       "correct_answer":"A",
       "explanation":"Both orders would have to be reduced by the amount of stock that was purchased at 101, in this case 700 shares."
    },
    {
       "id":35775,
       "practice_test_id":"",
       "topic_id":11,
       "question":"The seller would pay a commission in all of the following, except:",
       "choice_a":"A tender offer.",
       "choice_b":"An exchange distribution.",
       "choice_c":"A secondary distribution.",
       "choice_d":"A specialist\u0027s block purchase.",
       "correct_answer":"A",
       "explanation":"A seller would not pay a commission during a tender offer."
    },
    {
       "id":35776,
       "practice_test_id":5,
       "topic_id":11,
       "question":"A customer is short 100 ABC at 120. The market is moving up sharply and the customer decides to cover his short position. The customer instructs his R.R. to cover the short position at the market on the close. The order:",
       "choice_a":"Will be executed on the closing price of the day.",
       "choice_b":"Will be executed at or as near to the closing price as possible.",
       "choice_c":"Will be executed at the closing bid price.",
       "choice_d":"Will be executed at the closing price offer.",
       "correct_answer":"B",
       "explanation":"A market on close order will be executed at the close or as a close to the closing price as possible"
    },
    {
       "id":35777,
       "practice_test_id":"",
       "topic_id":11,
       "question":"An open buy order entered above the current market price of a security would be a:",
       "choice_a":"All or none order.",
       "choice_b":"Stop order.",
       "choice_c":"Limit order.",
       "choice_d":"Not held order.",
       "correct_answer":"B",
       "explanation":"Only a buy stop order would be entered above the market."
    },
    {
       "id":35778,
       "practice_test_id":"",
       "topic_id":11,
       "question":"When a specialist or DMM is \u0027stopping stock:\u0027 <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>He guarantees the purchase or sale of a specific number of shares at a given price. </li><li>He may stop stock for the customers of NYSE members. </li><li>He must obtain permission from a Floor Governor. </li><li>He guarantees a specific price while the broker tries to do better.</li></ol>",
       "choice_a":"I and II.",
       "choice_b":"III and IV.",
       "choice_c":"I, II and IV.",
       "choice_d":"II, III and IV.",
       "correct_answer":"C",
       "explanation":"All of the choices listed are correct except permission of a floor governor is not required. A specialist or DMM may only stop stock for a public customer."
    },
    {
       "id":35780,
       "practice_test_id":5,
       "topic_id":11,
       "question":"Assume the customer purchased 100 ABC in a cash transaction on Monday, July 1. When would the trade settle?",
       "choice_a":"Tuesday, July 2.",
       "choice_b":"Monday, July 1.",
       "choice_c":"Tuesday, July 9.",
       "choice_d":"Friday, July 5 .",
       "correct_answer":"B",
       "explanation":"Cash trades settle the same day. Both the buyer and seller must agree to the settlement terms, prior to the execution."
    },
    {
       "id":35781,
       "practice_test_id":"",
       "topic_id":11,
       "question":"When an investor is bearish on the market he can profit by:",
       "choice_a":"Buying common stocks",
       "choice_b":"Buying preferred stocks",
       "choice_c":"Selling short common stocks",
       "choice_d":"Selling long common stocks",
       "correct_answer":"C",
       "explanation":"Short selling is a strategy used by investors who are bearish on the market. The objective of this strategy is to sell borrowed shares at a high price and buy them back some time in the future at a lower price."
    },
    {
       "id":35782,
       "practice_test_id":"",
       "topic_id":11,
       "question":"A market maker who is unable to resolve a trade issue with another market maker must:",
       "choice_a":"Report to NASDAQ Market Operations within 15 minutes",
       "choice_b":"Report to NASDAQ Market Operations within 5 minutes",
       "choice_c":"Report to NASDAQ Market Operations within 30 minutes",
       "choice_d":"Report to NASDAQ Market Operations  within 45 minutes",
       "correct_answer":"C",
       "explanation":"Reports must be filed with NASDAQ Market Operations within 30 minutes."
    },
    {
       "id":35787,
       "practice_test_id":2,
       "topic_id":11,
       "question":"You buy stock in XYZ. You are sure that it will either go up or down a lot and you want to hedge your downside risk while keeping the opportunity to buy more if XYZ goes up. What combination of orders would you most likely place?",
       "choice_a":"Buy stop, sell limit",
       "choice_b":"Buy limit, sell stop",
       "choice_c":"Buy stop, sell stop",
       "choice_d":"Buy limit, sell limit",
       "correct_answer":"C",
       "explanation":"In the case described you would want to protect your downside risk by entering a sell stop below the market. If XYZ did well you would be able to add to your position by entering a buy stop above the market."
    },
    {
       "id":35788,
       "practice_test_id":3,
       "topic_id":11,
       "question":"You sell a stock short. What type of order are you most likely to enter to hedge your risk?",
       "choice_a":"Buy stop",
       "choice_b":"Sell stop",
       "choice_c":"Buy limit",
       "choice_d":"Sell limit",
       "correct_answer":"A",
       "explanation":"If you sell stock short your risk is to the upside and to exit the trade you must buy the stock back. The best order would be to enter a buy stop above the market."
    },
    {
       "id":39451,
       "practice_test_id":4,
       "topic_id":11,
       "question":"Regarding a prime brokerage account, which of the following is true?",
       "choice_a":"A prime broker provides custody and clearing services, while other brokers provide execution services.",
       "choice_b":"A prime broker must provide custody, clearing, and execution services.",
       "choice_c":"A prime broker provides execution services only, while another broker clears transactions and provides any other account services required.",
       "choice_d":"A prime broker subcontracts out all services such as clearing and execution to other brokers",
       "correct_answer":"A",
       "explanation":"In a prime brokerage account, the prime broker provides custody and clearing services only. The customer chooses and contracts with other brokers for execution services."
    },
    {
       "id":39487,
       "practice_test_id":5,
       "topic_id":11,
       "question":"Which of the following is not a characterization of Capital markets?",
       "choice_a":"The securities traded in them can be bought and sold by both individual investors and institutional traders.",
       "choice_b":"They can be utilized by the public sector only",
       "choice_c":"They include both stock and bond markets.",
       "choice_d":"They can be utilized to raise capital for both long and short-term needs.",
       "correct_answer":"B",
       "explanation":"Utilizing capital markets, both public and private sectors can sell securities (stocks and bonds) in order to raise capital to finance both long and short-term needs. Within these markets both individual investors and institutional traders can buy and sell securities."
    },
    {
       "id":32660,
       "practice_test_id":6,
       "topic_id":6,
       "question":"JKL Manufacturing is seeking to go public and is in the process of preparing its S1 Registration statement. As it relates to the review of the information contained therein, which of the following is correct?",
       "choice_a":"The documents will be reviewed by both FINRA and the SEC for a minimum of 20 days",
       "choice_b":"The documents will be reviewed by both FINRA and the SEC for a minimum of 25 days",
       "choice_c":"The documents will be reviewed by the SEC for a minimum of 20 days",
       "choice_d":"The documents will be reviewed by FINRA for a minimum of 20 days",
       "correct_answer":"C",
       "explanation":"The S1 registration statement is filed with the SEC prior to a company going public. The registration statement is reviewed by the SEC for a minimum of 20 days. This is known as the cooling off period."
    },
    {
       "id":32661,
       "practice_test_id":6,
       "topic_id":6,
       "question":"An investor who is not associated with the issuer has purchased 10,000 shares of TYU common stock through a private placement conducted 3 months ago. The investor is asking when he can sell the shares. You should advise him:",
       "choice_a":"You can sell your shares now subject to the volume limitation of rule 144",
       "choice_b":"You can sell your shares in 3 months subject to the volume limitation of rule 144",
       "choice_c":"You can sell your shares now without being subject to the volume limitation of rule 144",
       "choice_d":"You can sell your shares in 3 months without being subject to the volume limitation of rule 144",
       "correct_answer":"D",
       "explanation":"The holding period for a private placement is 6 months. Since this investor purchased the shares 3 months ago, they must wait an additional 3 months prior to selling the shares. As the investor is not affiliated with the issuer, the investor may sell the shares without being subject to the volume limitations of rule 144."
    },
    {
       "id":32662,
       "practice_test_id":6,
       "topic_id":10,
       "question":"Tom is a CPA who purchased shares of RET through a private placement several years ago. Tom is not looking to liquidate his share in RET. Which of the following is correct?",
       "choice_a":"Tom must file form 144 within 6 months of selling his shares",
       "choice_b":"Tom must file form 144 within 90 days of selling his shares",
       "choice_c":"If the shares being sold are less than 10,000 shares and less than $100,000 in value Tom will not be required to file form 144",
       "choice_d":"Once the shares are sold by Tom, the shares will increase the amount of shares in the company\u0027s float",
       "correct_answer":"D",
       "explanation":"Once shares are sold under Rule 144, those shares become part of the publicly traded float for the company. Form 144 must be filed at the time the investor enters the order to sell."
    },
    {
       "id":32663,
       "practice_test_id":6,
       "topic_id":6,
       "question":"The manufacturing sector has been hit hard by a recent downturn in the economy. QSQ manufacturing is in need of capital to improve its balance sheet to help it make it through the challenging times. It has retained JGJ Investment bankers to offer 200 million shares at $12.50 each. JGJ is concerned that given the challenges in the economy, the shares may not sell well. JGJ would most likely:",
       "choice_a":"Offer the securities on a best efforts basis",
       "choice_b":"Offer the securities on a stand by basis",
       "choice_c":"Offer the securities on a firm commitment basis with a market out clause",
       "choice_d":"Offer the securities on a mini / maxi basis",
       "correct_answer":"A",
       "explanation":"Given the fact that the securities will not be in high demand the underwriter would most likely only offer the securities on a best efforts basis. In a best efforts underwriting the underwriter is not obligated to purchase the shares from the company and therefore does not put its own capital at risk."
    },
    {
       "id":32664,
       "practice_test_id":6,
       "topic_id":3,
       "question":"A schedule of the total amount of liabilities to be paid by a publicly traded corporate issuer over the next 12 months would be found in:",
       "choice_a":"The income statement",
       "choice_b":"The prospectus",
       "choice_c":"The registration statement",
       "choice_d":"The balance sheet",
       "correct_answer":"D",
       "explanation":"The total amount of liabilities to be paid by a publicly traded corporate issuer over the next 12 months are known as current liabilities. Current liabilities would be found in the balance sheet. As the company is already public you would not look in the prospectus nor would you look at the registration statement."
    },
    {
       "id":32665,
       "practice_test_id":6,
       "topic_id":6,
       "question":"A representative seeking indications of interest for a new issue of common stock that her firm is underwriting includes a research report on the company along with the preliminary prospectus. Which of the following is true?",
       "choice_a":"This is permitted because it will help the investor make a well informed investment decision",
       "choice_b":"Permitted as long as the principal approves the report",
       "choice_c":"Permitted as long as the stock will be listed on FINRA or NYSE",
       "choice_d":"Not permitted under any circumstances",
       "correct_answer":"D",
       "explanation":"Nothing may be included with the preliminary prospectus. The representative may not make any marks or highlights to the preliminary prospectus."
    },
    {
       "id":32666,
       "practice_test_id":6,
       "topic_id":1,
       "question":"An investor has a market value of $492,000 in his account and his firm has filed for bankruptcy. He will be covered for:",
       "choice_a":"$400,000 in securities only and he becomes a general creditor for the additional $92,000 in securities",
       "choice_b":"$492,000",
       "choice_c":"$300,000 in securities,  up to$250,000 in cash and becomes a general creditor for the additional value",
       "choice_d":"$392,000 in securities and $250,000 in cash",
       "correct_answer":"B",
       "explanation":"The customer will be covered for all of the value in his account. The investor only has securities and they are fully covered up to the $500,000 limit. The limit on coverage for cash is $250,000."
    },
    {
       "id":32667,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A person who has pass the SIE exam but who has not yet passed a required top off exam may do which of the following?",
       "choice_a":"Take a message from a client regarding the terms of an order",
       "choice_b":"Ask a prospective client about their investment objectives",
       "choice_c":"Assist in the preparation of a research report",
       "choice_d":"Discuss the tax implications of a variable annuity with an established client of the firm",
       "correct_answer":"C",
       "explanation":"A person who has not passed a required top off exam may not act in any capacity that would require registration. All of the choices require the person performing the function to be registered except assisting in the preparation of research."
    },
    {
       "id":32668,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A registered representative who passed their top off exam 4 years ago would be required or would have been required to complete the regulatory continuing education course administered by FINRA:",
       "choice_a":"This year",
       "choice_b":"Last year",
       "choice_c":"next year",
       "choice_d":"in two years",
       "correct_answer":"C",
       "explanation":"The regulatory continuing education would be required to be completed on the second and fifth anniversary and every three years after their date of association."
    },
    {
       "id":32669,
       "practice_test_id":6,
       "topic_id":10,
       "question":"The requirement for agents to be fingerprinted is contained in which of the following?",
       "choice_a":"The securities Act of 1933",
       "choice_b":"The Securities Exchange Act of 1934",
       "choice_c":"The Maloney act of 1938",
       "choice_d":"The Securities Investors Protection Act of 1970",
       "correct_answer":"B",
       "explanation":"The Securities Exchange Act of 1934 regulates the people who transact business in the securities industry. It requires registered agents and those who handle cash and securities to be fingerprinted."
    },
    {
       "id":32670,
       "practice_test_id":6,
       "topic_id":10,
       "question":"An individual applying for registration with a FINRA member firm would not be required to include which of the following on form U4?",
       "choice_a":"10-year employment history",
       "choice_b":"Aliases used by agent",
       "choice_c":"10-year residence history",
       "choice_d":"Details relating to unpaid child support",
       "correct_answer":"C",
       "explanation":"When submitting the U4 an individual is required to submit all of the information listed except a 10 year residence history. A person must provide all residence information for the last 5 years. Unpaid child support would most likely be subject to a judgement by a court and as a result must be reported on form U4."
    },
    {
       "id":32671,
       "practice_test_id":6,
       "topic_id":10,
       "question":"Tom is a 40 year old career changer, who is now entering the securities industry after having spent the last 20 years in the computer field. Tom has joined a new member firm and is filing out his U4. In doing so, Tom elects to not disclose the fact that in college he was charged with a felony after a fight broke out at his frat house in college. The issue was later dismissed and Tom paid a fine for public intoxication in the amount of $75. Which of the following is correct?",
       "choice_a":"As the event was more than 20 years old it is no longer required to be reported",
       "choice_b":"As the event was more than 10 years old it is no longer required to be reported",
       "choice_c":"As the event resulted in a mere citation and a fine of less than $100 it is not required to be reported",
       "choice_d":"Tom may be barred from being registered for failing to report the event",
       "correct_answer":"D",
       "explanation":"Even though the event was 20 years old, the person was charged with a felony. The question asks have you ever been charged with a felony. Clearly in this case the individual had been charged and as a result was required to report the event and the fact that it was dismissed in favor of a citation and a small fine."
    },
    {
       "id":32658,
       "practice_test_id":6,
       "topic_id":6,
       "question":"A fixed price transaction is completed covering 100 million shares of stock. The transaction is completed at $20 per share with the proceeds being distributed to the issuer. Poor economic data has been released on the same day this issue has begun trading and the shares are under selling pressure after opening at $24 the stock begins to decline. What is the highest price listed below, at which the syndicate could support the price of the issuer\u0027s stock?",
       "choice_a":"$24",
       "choice_b":"$23.50",
       "choice_c":"$21",
       "choice_d":"$18",
       "correct_answer":"D",
       "explanation":"Of the choices listed, the only price and therefore the highest price at which the syndicate could support the stock price is $18. A syndicate may stabilize an offering of securities at or below the public offering price."
    },
    {
       "id":32655,
       "practice_test_id":6,
       "topic_id":7,
       "question":"The OCC publishes its disclosure document The Characteristics and Risk of Standardized Options in order to: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Meet the prospectus requirements of The Securities Act of 1933 </li><li>Disclose the risks of option investing </li><li>Protect issuers of the underlying securities </li><li>Advise on the suitability of option strategies for different investment objectives.</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and II",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"B",
       "explanation":"The OCC publishes the disclosure document to meet the prospectus requirement of The securities Act of 1933 and to disclose the risks of option investing. The other choices are not part of the intent of the disclosure document."
    },
    {
       "id":32656,
       "practice_test_id":6,
       "topic_id":10,
       "question":"Which of the following choices listed maintains a list of known and suspected terrorists and uses the information to guard against money laundering?",
       "choice_a":"FINCEN",
       "choice_b":"SEC",
       "choice_c":"FINRA",
       "choice_d":"NYSE",
       "correct_answer":"A",
       "explanation":"FINCEN is a department inside the US Treasury department who maintains a list of known and suspected terrorists. FINCEN works with firms in the financial services industry to protect the Untied States from terrorist attacks and to guard against money laundering."
    },
    {
       "id":32657,
       "practice_test_id":6,
       "topic_id":6,
       "question":"SIA Technologies, has just filed paperwork to become a publicly traded company. SIA has retained a well known company to serve as the registrar for SIA. Which of the following would be functions of the newly hired entity?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>To register the stock of SIA with the SEC </li><li>To ensure proper issuance of securities to beneficial owners </li><li>To register the stock of SIA with the states where shares will be sold </li><li>To perform general audits of the transfer agent</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"II and IV",
       "choice_d":"I and III",
       "correct_answer":"C",
       "explanation":"The purpose of the registrar is to ensure that all transfers of ownership are properly completed and to audit the transfer agent. The registrar is not involved with the registration process."
    },
    {
       "id":32694,
       "practice_test_id":6,
       "topic_id":4,
       "question":"An investor in ABC, Inc. owns 500 shares of ABC common stock. Which of the following is not a feature or benefit of owning the shares?",
       "choice_a":"Right to transfer",
       "choice_b":"Right to receive declared dividends",
       "choice_c":"Limited liability",
       "choice_d":"Right to elect President and CEO",
       "correct_answer":"D",
       "explanation":"Owners of common stock do not have the right to elect officers of corporations. Common stockholders elect the board of directors and the board appoints the officers of the corporation."
    },
    {
       "id":32695,
       "practice_test_id":6,
       "topic_id":4,
       "question":"XYZ has four classes of preferred stock outstanding and trading in the market. Which of the four classes would most likely pay the lowest stated dividend?",
       "choice_a":"Straight preferred stock",
       "choice_b":"Cumulative preferred stock",
       "choice_c":"Convertible preferred stock",
       "choice_d":"Participating preferred stock",
       "correct_answer":"C",
       "explanation":"Of the four classes of preferred stock XYZ has outstanding, the convertible preferred issue would pay the lowest dividend. Investors who purchase convertible preferred shares are willing to accept a lower stated dividend in exchange for the opportunity to convert the preferred stock into common stock."
    },
    {
       "id":32659,
       "practice_test_id":6,
       "topic_id":11,
       "question":"A broker dealer who regularly buys securities from customers who enter orders to sell, and who regularly sells securities to customers who enter orders to buy, does so and makes a profit for its account. Under FINRA\u0027s rules, which of the following is correct?",
       "choice_a":"The broker dealer could be found to have violated customer protection rules",
       "choice_b":"The broker dealer could be found to have committed a violation known as trading ahead",
       "choice_c":"The broker dealer could be found to have committed a violation known as front running",
       "choice_d":"The broker dealer may trade against customer orders",
       "correct_answer":"D",
       "explanation":"The question details a broker dealer acting in the capacity of a dealer. A dealer acts a principal in the transaction and buys from customers who are selling and who sells securities to customer who wish to buy. The dealer is entitled to a profit on principal transactions."
    },
    {
       "id":32679,
       "practice_test_id":6,
       "topic_id":7,
       "question":"Which of the following is true about a put buyer?",
       "choice_a":"They want the option to expire",
       "choice_b":"Their maximum gain is unlimited",
       "choice_c":"They are not bullish on the stock",
       "choice_d":"Their maximum loss is unlimited",
       "correct_answer":"C",
       "explanation":"A buyer of a put is not bullish on the underlying stock, they are bearish, that is to say they want the stock to decline in value. Option buyers want to exercise the option. Nothing is ever unlimited with a put as the stock price cannot fall below zero."
    },
    {
       "id":32708,
       "practice_test_id":6,
       "topic_id":5,
       "question":"A mutual fund assesses a sales charge upon redemption based upon the investor\u0027s holding period of the fund. This is known as:",
       "choice_a":"A 12b-1 fee",
       "choice_b":"A contingent deferred sales charge",
       "choice_c":"A redemption charge",
       "choice_d":"A balanced load",
       "correct_answer":"B",
       "explanation":"A fund that assesses a sales charge based upon the holding period of the fund charges a back end load or a contingent deferred sales charge."
    },
    {
       "id":32709,
       "practice_test_id":6,
       "topic_id":5,
       "question":"All of the following are true regarding a closed end investment company except:",
       "choice_a":"Priced by supply and demand",
       "choice_b":"Goes ex dividend one business days prior to the record date",
       "choice_c":"It has a sales charge to invest",
       "choice_d":"Shareholders have preemptive rights",
       "correct_answer":"C",
       "explanation":"An investor who buys a closed end investment company does not pay a sales charge to invest, they pay their brokerage firm a commission to execute their order. Closed end fund shares trade on the exchanges and are purchased and sold between investors."
    },
    {
       "id":32710,
       "practice_test_id":6,
       "topic_id":5,
       "question":"An investor in the XYZ high growth fund could best be described as:",
       "choice_a":"A creditor of XYZ",
       "choice_b":"A stockholder in XYZ",
       "choice_c":"An owner of XYZ",
       "choice_d":"A shareholder with an undivided interest in the fund",
       "correct_answer":"D",
       "explanation":"Any investor in  a mutual fund is a shareholder in that fund or portfolio only."
    },
    {
       "id":32726,
       "practice_test_id":6,
       "topic_id":1,
       "question":"Which of the following accounts would be established in order to provide for the long term care and living expenses of an individual who is disabled?",
       "choice_a":"Long term care account",
       "choice_b":"Guardian account",
       "choice_c":"Trust account",
       "choice_d":"ABLE account",
       "correct_answer":"D",
       "explanation":"An ABLE account can be set up to provide for the long term care, living and quality of life expenses for individuals who are disabled."
    },
    {
       "id":32727,
       "practice_test_id":6,
       "topic_id":1,
       "question":"Which of the following types of accounts would most likely have a fee associated with the operation of the account?",
       "choice_a":"Margin account",
       "choice_b":"Discretionary account",
       "choice_c":"Trust account",
       "choice_d":"Wrap account",
       "correct_answer":"D",
       "explanation":"A wrap account would be charged a fee based upon the assets in the account. The fee paid by the account holder would cover all of the expenses associated with the account including execution costs. The account will not be charged commissions when orders are executed."
    },
    {
       "id":32728,
       "practice_test_id":6,
       "topic_id":2,
       "question":"A corporate bond purchased at 92 with an annual interest rate of 7% has what current yield?",
       "choice_a":"6.44%",
       "choice_b":"7.60%",
       "choice_c":"8.20%",
       "choice_d":"8.70%",
       "correct_answer":"B",
       "explanation":"To find the current yield you must divide the annual income by the current market price. In this case, Annual income ($70) divided by the current market price ($920) = 7.6%"
    },
    {
       "id":32729,
       "practice_test_id":6,
       "topic_id":10,
       "question":"When reviewing content to be disseminated by the broker dealer or by a registered representative concerning business activities, which of the following determine the classification for the communication?",
       "choice_a":"The content and the number and type of recipients",
       "choice_b":"How the content was delivered",
       "choice_c":"If the content is required to be filed with FINRA",
       "choice_d":"If the content requires principal approval",
       "correct_answer":"A",
       "explanation":"When reviewing content to be disseminated by the broker dealer or by a registered representative concerning business activities the content and the number and type of recipients will be the determining factor in classifying the communication. There is no difference between electronic or written forms of distribution."
    },
    {
       "id":32724,
       "practice_test_id":6,
       "topic_id":1,
       "question":"A detailed receipt of all transactions related to customer accounts must be sent:",
       "choice_a":"no later than the trade date",
       "choice_b":"no later than the time the trade is executed if the customer has agreed to receive communication electronically",
       "choice_c":"no later than the time when cash and securities are exchanged by the broker dealers",
       "choice_d":"no later than the time the customer payment date as set by the Federal Reserve Board",
       "correct_answer":"C",
       "explanation":"A customer must be sent a confirmation ( a detailed receipt) of all transactions no later than the time when cash and securities are exchanged between the broker dealers. This is the completion of the transaction and the settlement date."
    },
    {
       "id":32725,
       "practice_test_id":6,
       "topic_id":10,
       "question":"Two members of your firm\u0027s research team are speaking on the elevator on the way up to their offices. A registered representative for the firm hears them speaking about a research report they have been working on for the last few weeks on XSA Micro, Inc. The analysts are discussing the assignment of a price target substantially higher than the current price. The registered representative reaches his desk and starts purchasing shares for his account and for the account of his clients with an appropriate investment objective. Which of the following is correct?",
       "choice_a":"This is a violation known as front running",
       "choice_b":"This is a violation known as insider trading",
       "choice_c":"This is a violation known as trading ahead",
       "choice_d":"This is a violation known as freeriding",
       "correct_answer":"C",
       "explanation":"When a registered representative has advance knowledge of the release of a research report, the registered person cannot execute orders based on that knowledge. Buying or selling securities with the prior knowledge of the release would be a violation known as trading ahead."
    },
    {
       "id":32703,
       "practice_test_id":6,
       "topic_id":11,
       "question":"An investor who has a bullish outlook on on the S&P 500 should consider which two of the following choices?  <div>I. Sell calls on the S&P 500</div> <div>II. Sell puts on the S&P 500</div> <div>III. Buy puts on the S&P 500</div> <div>IV. Buy calls on the S&P 500</div> <p>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"I and IV",
       "correct_answer":"B",
       "explanation":"An investor who as a bullish outlook on the S&P 500 index could profit from an advance in the index by either purchasing calls or selling puts on the index."
    },
    {
       "id":32723,
       "practice_test_id":6,
       "topic_id":1,
       "question":"A broker dealer feels that a customer has been engaging in an activity that the broker dealer deems to be questionable should do which of the following?",
       "choice_a":"Freeze the customer\u0027s account if the activity includes an amount of more than $10,000",
       "choice_b":"Freeze the customer\u0027s account if the activity includes an amount of more than $5,000",
       "choice_c":"Report the activity in the customer\u0027s account if the activity includes an amount of more than $5,000",
       "choice_d":"Report the activity in the customer\u0027s account if the activity includes an amount of more than $10,000",
       "correct_answer":"C",
       "explanation":"A suspicious activity report should be filed for any activity which the broker dealer deems to be questionable for any amount exceeding $5,000."
    },
    {
       "id":32672,
       "practice_test_id":6,
       "topic_id":10,
       "question":"John is a 60 year old rep at a well established broker dealer. Eight years ago his elderly mother was hospitalized for 2 weeks to deal with a medical issue. John admitted his mother to the hospital and signed the papers. The hospital is seeking to receive payment for $1,200 worth unpaid medical bills not covered by his mother\u0027s insurance. This year John began the process of refinancing his home and noticed that the hospital had an order for payment entered against him as well as his mother. Which of the following is correct?",
       "choice_a":"The obligation to pay rests with John\u0027s mother and need not be reported",
       "choice_b":"The obligation to pay rests with John and his mother and need not be reported",
       "choice_c":"The obligation to pay is less than $2,500 and need not be reported",
       "choice_d":"The obligation to pay rests with John and his mother and must be reported",
       "correct_answer":"D",
       "explanation":"The hospital in this case has had a court order entered against both John and his mother. Therefore, the obligation to pay in the eyes of the court rests on both parties. Since John has an unpaid judgment, it must be reported by John on his U4."
    },
    {
       "id":32693,
       "practice_test_id":6,
       "topic_id":7,
       "question":"The main difference between an American and European option is:",
       "choice_a":"American options may be exercised by the holder at any time, while European options may only be exercised by the holder at expiration",
       "choice_b":"European options may be exercised by the holder at any time, while American options may only be exercised by the hold at expiration",
       "choice_c":"American options settle in U.S dollars while  European options settle in Euros",
       "choice_d":"American options may be exercised by the holder at any time, while a European option may only be exercised by the holder quarterly",
       "correct_answer":"A",
       "explanation":"American style options may be exercised any time by the holder and European style options may only  be exercised by the holder at expiration."
    },
    {
       "id":32711,
       "practice_test_id":6,
       "topic_id":8,
       "question":"A client has phoned in concerned about what will happen to his investment in a waste management company if the new EPA laws are enacted requiring disposal companies to reduce pollution. What type of risk is he concerned with:",
       "choice_a":"Investment risk",
       "choice_b":"Legislative risk",
       "choice_c":"Call risk",
       "choice_d":"Environmental risk",
       "correct_answer":"B",
       "explanation":"This client is concerned about legislative risk. The risk that the government will do something that adversely affects your investment."
    },
    {
       "id":32712,
       "practice_test_id":6,
       "topic_id":8,
       "question":"A client who is interested in investing in a whole loan private label CMO is asking you about the collateral and guarantees associated with the security. Upon review of the security you should tell him:",
       "choice_a":"The securities are backed by the full faith and credit of Ginnie Mae",
       "choice_b":"The securities are tied to a pool of mortgages backed by Freddie Mac",
       "choice_c":"The securities are tied to a pool of mortgages backed by Fannie Mae",
       "choice_d":"The securities are tied to a pool of mortgages backed by a letter of credit and or insurance taken out by the issuer",
       "correct_answer":"D",
       "explanation":"A private labeled CMO is created  when a broker dealer purchases a large<br>portfolio of mortgages and sells off the interest in the pool to investors in<br>CMOs. Whole loan CMOs are backed by the pool of mortgages which in turn may<br>have insurance or a letter of credit backing the loans in the pool, not the CMO<br>itself."
    },
    {
       "id":32713,
       "practice_test_id":6,
       "topic_id":8,
       "question":"A 42 year old investor wants to put $20,000 into a plan to help meet the educational expenses of their 12 year old son. They want to make a lump sum deposit. Which would you recommend?",
       "choice_a":"A 529 plan",
       "choice_b":"A Coverdell IRA",
       "choice_c":"A Roth IRA",
       "choice_d":"A Growth mutual fund",
       "correct_answer":"A",
       "explanation":"A 529 plan would allow the investor to make a lump sum deposit. The key is that the investor is looking for a \u0022plan\u0022 to put money into and has a large sum of money to invest. The 529 plan is the correct option for this investor."
    },
    {
       "id":32705,
       "practice_test_id":6,
       "topic_id":4,
       "question":"REITs provide investors with all of the following advantages except",
       "choice_a":"Pass through income",
       "choice_b":"Liquidity",
       "choice_c":"Limited liability",
       "choice_d":"Tax deduction for losses",
       "correct_answer":"D",
       "explanation":"Only income is passed through to investors in a Real Estate Investment Trust. Losses incurred by the REIT cannot be deducted by an investor."
    },
    {
       "id":32692,
       "practice_test_id":6,
       "topic_id":2,
       "question":"Which of the choices below accurately reflects the relationship between the price of a bond and the income to be received by investors?",
       "choice_a":"Nominal yield",
       "choice_b":"Current yield",
       "choice_c":"Yield to maturity",
       "choice_d":"Yield to price ratio",
       "correct_answer":"B",
       "explanation":"The current yield for a bond is the annual interest income dividend by its current market price. The current market price is what an investor must pay to purchase the bond in order to receive the annual interest payments."
    },
    {
       "id":32691,
       "practice_test_id":6,
       "topic_id":2,
       "question":"Which of the following debt instruments would have an interest rate that is the most sensitive to a change in the level of interest rates in the market?",
       "choice_a":"Commercial paper",
       "choice_b":"Corporate bonds",
       "choice_c":"Municipal bonds",
       "choice_d":"Treasury bonds",
       "correct_answer":"A",
       "explanation":"As the level of interest rates in the overall market change, the interest rates on short term debt instruments will change the most and would therefore be the most sensitive to the change. The only short term debt instrument listed is commercial paper, which has a maximum maturity of 2790 days."
    },
    {
       "id":32674,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A registered representative\u0027s wife owns an antique store selling high end collectible antiques. Over the last few years the store has grown significantly and is now expanding to offer auction items and services. The registered representative would like to help his wife at the store on the weekends, which of the following is correct? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The member firm must be notified in writing </li><li>The representative must update his U4 </li><li>The member firm must perform a risk assessment  </li><li>As the items being sold are collectible and being bought and sold at auction the activity would be deemed investment related</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"I, II and IV",
       "choice_d":"I, II, III and IV",
       "correct_answer":"A",
       "explanation":"The representative would be required to notify the member firm in writing and to update his U4 to reflect the outside business activity. This would not be deemed to be investment related and the member would not be required to perform a risk assessment."
    },
    {
       "id":32675,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A member firm has been accused of a relatively small violation by the FINRA staff. During the efforts to resolve the matter, FINRA offers to resolve the issue though minor rule procedure. Which of the following is correct?",
       "choice_a":"The firm will only be subject to a censure",
       "choice_b":"The firm will only be subject to a $5,000 fine",
       "choice_c":"The firm will be subject to a censure and to a $2,500 fine",
       "choice_d":"The firm will be subject to a censure and to a $5,000 fine",
       "correct_answer":"C",
       "explanation":"Under minor rule violation procedure, the maximum penalty is a censure and a $2,500 fine. This process is used to resolve small infractions of FINRA rules such as items which are clerical in nature."
    },
    {
       "id":32676,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A registered representative who has been informed of their requirement to complete the regulatory continuing education program, will have how long to satisfy the requirement?",
       "choice_a":"90 days",
       "choice_b":"90 days plus a 30 day grace period",
       "choice_c":"120 days",
       "choice_d":"120 days plus a 30 grace period",
       "correct_answer":"C",
       "explanation":"A registered person will have 120 days from the time they receive notice to complete the regulatory continuing education program. There is no grace period. If the agent does not complete the program in the required time, their registration will be placed in suspense status until the course is completed."
    },
    {
       "id":32677,
       "practice_test_id":6,
       "topic_id":10,
       "question":"All of the following people are subject to statutory disqualification except:",
       "choice_a":"An associated person suspended by a Canadian regulator",
       "choice_b":"An associated person who participated in the expulsion of a member firm",
       "choice_c":"An associated person who makes misleading statements on their application for association",
       "choice_d":"An individual who declared bankruptcy as a result of losses in personal securities transactions",
       "correct_answer":"D",
       "explanation":"Personal bankruptcy does not automatically disqualify an individual from registration."
    },
    {
       "id":32678,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A registered representative has taken a leave of absence to pursue other interests. They have how long to return to active duty as a representative without being required to take the exam again",
       "choice_a":"36 months",
       "choice_b":"18 months",
       "choice_c":"24 months",
       "choice_d":"12 months",
       "correct_answer":"C",
       "explanation":"A registered representative may leave the business for up to 24 months without having to retake the exam."
    },
    {
       "id":32701,
       "practice_test_id":6,
       "topic_id":2,
       "question":"As it relates to the Government National Mortgage Association ( Ginnie Mae) which of the following choices is not correct?",
       "choice_a":"Investors will receive monthly interest and principal payments",
       "choice_b":"The minimum denomination is $1,000",
       "choice_c":"Interest income is free from federal taxes",
       "choice_d":"In the event of a default the U.S. government will make any required payments to investors",
       "correct_answer":"C",
       "explanation":"All of the choices are correct relating to Ginnie Mae securities, except the interest income is not free from federal income taxes. The interest income earned by investors is taxed at all levels."
    },
    {
       "id":32702,
       "practice_test_id":6,
       "topic_id":2,
       "question":"Several years ago ABC a AAA rated corporate issuer of debt securities, sold $500 million worth of 8 percent bonds. Interest rates in the market have fallen to 5 percent. Which of the following statements is correct?",
       "choice_a":"The level of income on the 8 percent bonds has declined as interest rates have fallen and the market price of the bonds increased",
       "choice_b":"The level of income on the 8 percent bonds has increased as interest rates have fallen and the market price of the bonds increased",
       "choice_c":"The level of income on the 8 percent bonds has not declined as interest rates have fallen and the market price of the bonds increased",
       "choice_d":"The level of income on the 8 percent bonds has declined as interest rates have fallen and the market price of the bonds declined",
       "correct_answer":"C",
       "explanation":"As interest rates in the market change the price of outstanding issues change. However, The amount of income generated by the bonds in dollar terms remains constant. The 8 percent bond has and will always pay $80 per year so long as the issuer does not default. The relationship of the income to the price of the bond changes and is reflected in the current yield."
    },
    {
       "id":32686,
       "practice_test_id":6,
       "topic_id":2,
       "question":"Which of the following municipal issues would not be subject to a statutory debt limit?",
       "choice_a":"Bonds issued by the state to cover general working expenses",
       "choice_b":"Bonds issued by the county to improve the municipal court house",
       "choice_c":"Bonds issued by a town to improve school buildings",
       "choice_d":"Bonds issued  by a turnpike authority to improve roads",
       "correct_answer":"D",
       "explanation":"Because revenue bonds are considered to pay for themselves through the collection of user fees, revenue bonds are not subject to statutory debt limits. Bonds issued by a turnpike authority to improve roads would be revenue bonds and the debt service would be supported through the collection of tolls."
    },
    {
       "id":32687,
       "practice_test_id":6,
       "topic_id":2,
       "question":"An investor who is comparing a corporate bond to a municipal bonds of the same quality and maturity would observe which of the following?",
       "choice_a":"The corporate bond is more volatile",
       "choice_b":"The corporate bond has a lower coupon rate",
       "choice_c":"The municipal bond is more volatile",
       "choice_d":"The municipal bond has a lower coupon rate",
       "correct_answer":"D",
       "explanation":"When comparing a corporate bond and a municipal bond of the same quality and maturity, the municipal bond would have a lower coupon rate. Interest earned on municipal bonds is free from federal income taxes and as such the coupon rate is lower than equal quality corporate bonds which are subject to taxation."
    },
    {
       "id":32688,
       "practice_test_id":6,
       "topic_id":8,
       "question":"An investor who owns a portfolio of corporate bonds is concerned about interest rate risk. Which of the following would best describe interest rate risk?",
       "choice_a":"As interest rates increase the risk of default increases",
       "choice_b":"As interest rates fall the amount of interest income received will fall",
       "choice_c":"As interest rates rise the value of previously issued bonds will fall",
       "choice_d":"As interest rates fall the value of previously issued bonds fall",
       "correct_answer":"C",
       "explanation":"Interest rate risk, is the risk that as interest rates rise the value of previously issued bonds will fall, causing the investor to suffer losses on the value of the bonds in their portfolio."
    },
    {
       "id":32689,
       "practice_test_id":6,
       "topic_id":8,
       "question":"Which of the following investment choices would be the least suitable for an investor who is seeking regular income?",
       "choice_a":"Warrant",
       "choice_b":"Common stock",
       "choice_c":"Treasury bond",
       "choice_d":"Preferred stock",
       "correct_answer":"A",
       "explanation":"The question asks which of the choices would be least suitable for an investor who is seeking income. A warrant never pays any type dividend and therefore does not produce and type of income."
    },
    {
       "id":32690,
       "practice_test_id":6,
       "topic_id":2,
       "question":"An investor has purchased 5 XYZ subordinated debentures in the market at 105. The debentures pay an interest rate of 5 percent. How much in annual income would the investor expect to receive each year from the investment?",
       "choice_a":"$50",
       "choice_b":"$250",
       "choice_c":"$52.50",
       "choice_d":"$262.50",
       "correct_answer":"B",
       "explanation":"The investor would expect to receive 5 percent of par value, which for a bond is always $1000. In this case the investor would receive $50 per bond per year. Since the investor purchased 5 bonds, the investor would receive a total of $250 in interest."
    },
    {
       "id":32696,
       "practice_test_id":6,
       "topic_id":4,
       "question":"Mr. Walsh owns 1,000 shares of GRT participating preferred stock. The preferred stock has a stated dividend rate of 6% and is trading in the market at 109. GRT common stock is trading in the market at $28 and has paid a quarterly dividend of 15 cents per share. What is the total amount of dividends Mr. Walsh received this year?",
       "choice_a":"$6,600",
       "choice_b":"$600",
       "choice_c":"$660",
       "choice_d":"$6,000",
       "correct_answer":"A",
       "explanation":"Mr. Walsh owns 1,000 shares of a 6% participating preferred stock. Each share of stock pays $6 per share. Therefore the investor will have received $6,000 in stated dividends. Since the preferred issue is also participating, Mr. Walsh is entitled to receive the common dividend as well. The common stock pays 15 cents per quarter for a total of 60 cents per year. As a result Mr. Walsh will receive and additional $600, for a total of $6,600."
    },
    {
       "id":32697,
       "practice_test_id":6,
       "topic_id":4,
       "question":"Jim owns 1,000 shares of XYZ preferred stock. The preferred stock is trading in the market at $140 and is convertible into XYZ common stock at $25 per share. What is the parity price of the common stock?",
       "choice_a":"$30",
       "choice_b":"$25",
       "choice_c":"$35",
       "choice_d":"$40",
       "correct_answer":"C",
       "explanation":"The parity price is the price that would make the value of the common stock to be received equal to the value of the preferred stock the investor now owns. If the investor has a preferred stock worth $140 the investor would not exchange it for common stock worth less than $140. Each share of preferred stock can be converted into 4 shares of common stock, found as follows: par value / conversion price. In this case $100 / $25= 4. Then you take the current market value of the stock and divide it by the number of shares to be received upon conversion. In this case $140 / 4 =$35"
    },
    {
       "id":32698,
       "practice_test_id":6,
       "topic_id":4,
       "question":"FGH Investments, a large institutional investor, owns 3 percent of the outstanding stock in TYU Technology, Inc. TYU is offering new shares for sale through a subsequent primary offering to expand its plant. What is the maximum amount of time FGH has to consider if it is going to maintain its 3 percent stake in the company, prior to shares being sold to new investors?",
       "choice_a":"15 days",
       "choice_b":"30 days",
       "choice_c":"45 days",
       "choice_d":"60 days",
       "correct_answer":"C",
       "explanation":"The question details an investors preemptive right to maintain their percentage ownership in a corporation. This is conducted through rights offering. The maximum duration of a rights offering is 45 days."
    },
    {
       "id":32699,
       "practice_test_id":6,
       "topic_id":8,
       "question":"Assuming that all of the following bonds are of equal quality, which of the following would be the most likely to be called if interest rates were to decline?",
       "choice_a":"A 6 percent debenture maturing in 20 years callable in 15 at 105",
       "choice_b":"An 8 percent debenture maturing in 20 years callable in 15 at 103",
       "choice_c":"A 6 percent debenture maturing in 20 years callable in 5 at 105",
       "choice_d":"An 8 percent debenture maturing in 20 years callable in 5 at 103",
       "correct_answer":"D",
       "explanation":"As interest rates fall the bond with the highest interest rate, the longest term to maturity and the soonest call date, with the lowest price, would be the most likely issue to be called. In this case, the 8 percent bond with 5 years until its call date with a price of 103 would be the best choice."
    },
    {
       "id":32700,
       "practice_test_id":6,
       "topic_id":4,
       "question":"An investor has purchased 500 shares of an ADR whose underlying common stock is listed for trading in Japan. Which of the following is true regarding any dividend paid? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The dividend will be paid in the foreign currency and converted by the customer\u0027s brokerage firm </li><li>The dividend will be paid in U.S. dollars </li><li>The dividend will be paid in the foreign currency and converted by the bank </li><li>The dividend will be received in U.S. dollars</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"III and IV",
       "choice_c":"II and III",
       "choice_d":"I and III",
       "correct_answer":"B",
       "explanation":"The dividend on an ADR is paid by the company in the foreign currency and it is converted into U.S dollars by the custodian bank. The bank the sends out the dividend to be received by investors in U.S. dollars"
    },
    {
       "id":32680,
       "practice_test_id":6,
       "topic_id":8,
       "question":"An investor wants to realize the greatest possible gain on a long stock position that has increased in value and protect his stock from a correction. The stock is currently trading at $62.20. Which of the following would you recommend?",
       "choice_a":"Sell calls with a strike price of 65",
       "choice_b":"Buy puts with a strike price of 60",
       "choice_c":"Buy puts with a strike price of 65",
       "choice_d":"Sell calls with a strike price of 70",
       "correct_answer":"B",
       "explanation":"Buying the puts with a strike price of 60 would be the most appropriate choice for this investor. The in the money puts with a strike price of 65 do not make sense."
    },
    {
       "id":32681,
       "practice_test_id":6,
       "topic_id":7,
       "question":"How far are the IBM Aug 70 calls in the money if IBM trades at $77?",
       "choice_a":"$77",
       "choice_b":"$7",
       "choice_c":"$0",
       "choice_d":"$10",
       "correct_answer":"B",
       "explanation":"A call option is in-the-money by the amount that the underlying security trades ABOVE the call\u0027s strike price."
    },
    {
       "id":32682,
       "practice_test_id":6,
       "topic_id":7,
       "question":"Your customer is long 100 shares of MSFT. For best protection, what should he do?",
       "choice_a":"buy a call",
       "choice_b":"sell a call",
       "choice_c":"sell a put",
       "choice_d":"buy a put",
       "correct_answer":"D",
       "explanation":"When an investor is long stock, the risk is that the price could drop; therefore, he must buy a put or sell a call, buying a put will provide the most protection."
    },
    {
       "id":32683,
       "practice_test_id":6,
       "topic_id":9,
       "question":"Which of the following investments listed below would subject the investor to a surrender period?",
       "choice_a":"A unit investment trust",
       "choice_b":"A variable annuity",
       "choice_c":"An open end investment company",
       "choice_d":"An exchanged linked note",
       "correct_answer":"B",
       "explanation":"A variable annuity would subject an investor to a surrender period. If the investor withdrew their funds during this time, the investor would pay a penalty for early liquidation. None of the other choices would have surrender periods."
    },
    {
       "id":32684,
       "practice_test_id":6,
       "topic_id":5,
       "question":"An investor who wishes to include a prior purchase to a new letter of intent, back dates the letter 60 days. In order to meet the obligations under the letter the investor must complete the investments:",
       "choice_a":"Within 10 months",
       "choice_b":"Within 13 months",
       "choice_c":"Within 11 months",
       "choice_d":"Within 12 months",
       "correct_answer":"C",
       "explanation":"A letter of intent gives the investor 13 months to meet the contribution level for the reduced sales charge. The 13 month window starts from the back date. In this case the investor back dated the letter of intent 2 months, so the investor has another 11 months to complete the contributions."
    },
    {
       "id":32685,
       "practice_test_id":6,
       "topic_id":7,
       "question":"An investor who is looking to speculate on the earnings of XYZ, Inc. wants to purchase an out of the money option in the hope the earnings exceed expectations. XYZ is currently trading in the market at $31 per share. Which of the following options would be the best choice for the investor?",
       "choice_a":"Go long a May 30 call on XYZ",
       "choice_b":"Go long a May 30 put on XYZ",
       "choice_c":"Go long a May 35 call on XYZ",
       "choice_d":"Go long a May 35 put on XYZ",
       "correct_answer":"C",
       "explanation":"The investor wants to speculate that the company beats earnings and that the stock price will rise as a result. The question also states that the investor wants to purchase an option that is out of the money. The best choice would be for the investor to go long a May 35 call. With the stock trading at $31 the $35 call is out of the money."
    },
    {
       "id":32717,
       "practice_test_id":6,
       "topic_id":2,
       "question":"An investor purchased an 8% corporate bond at a price of 110. The bond matures in 15 years and is callable at par plus accrued interest in 10 years. Which of the following would be the highest yield on the bond for this investor?",
       "choice_a":"Yield to maturity",
       "choice_b":"Yield to call",
       "choice_c":"Current yield",
       "choice_d":"Nominal yield",
       "correct_answer":"D",
       "explanation":"The investor purchased a bond at a premium, a price that is greater than the par value of the bond. When a bond is purchased at a premium the highest yield is the nominal yield, the rate named on the bond."
    },
    {
       "id":32716,
       "practice_test_id":6,
       "topic_id":7,
       "question":"An investor who has been working with their agent for a significant period of time is discussing WER stock with the agent. Although the customer trusts the agent\u0027s judgement the customer has not given the agent discretionary authority over the account. The client says buy 500 shares of WER whenever you think the price is right. Which of the following is correct?",
       "choice_a":"The order may not be executed by the agent since the agent does not have discretion",
       "choice_b":"The order may not be executed by the agent without prior principal approval since the agent does not have discretion",
       "choice_c":"The order may be be executed by the agent even though the agent does not have discretion",
       "choice_d":"The order would need to be verified in writing prior to execution since the agent does not have discretion",
       "correct_answer":"C",
       "explanation":"An agent who does not have discretionary authority may execute the order at a time and price the agent determines without requiring discretion. The customer in this case has provided the details regarding the action, asset and the amount. The agent may use time and price discretion."
    },
    {
       "id":32714,
       "practice_test_id":6,
       "topic_id":11,
       "question":"Several years ago an investor purchased 400 shares of OnNet.com at $12 per share. The value of the stock has increased significantly to $45 and the investor is worried that the stock may fall. She feels that the stock has the potential to continue higher but wants to protect her profit in case the stock falls. Which of the following would be the best order for her to enter when the stock is trading at $45?",
       "choice_a":"Sell 400 shares at 48 GTC",
       "choice_b":"Sell 400 shares at 45 stop GTC",
       "choice_c":"Sell 400 shares at 44",
       "choice_d":"Sell 400 shares at 43 stop GTC",
       "correct_answer":"D",
       "explanation":"With the stock trading at $45 the best order for this investor to enter would be a stop order that is below the market. The order should be placed at a price that is somewhat lower than the current price to ensure that normal price fluctuations do not cause the stock to be sold right away. The order should be entered as good until canceled so that the order is in place to protect the position."
    },
    {
       "id":32715,
       "practice_test_id":6,
       "topic_id":11,
       "question":"Which of the following accurately represents the characteristics of an immediately executable order ?",
       "choice_a":"An immediately executable order to buy has a limit price that is equal to or higher than the ask price and for up to the displayed size.",
       "choice_b":"An immediately executable order to sell has a limit price that is equal to or lower than the ask price and for up to the displayed size.",
       "choice_c":"An immediately executable order to buy has a limit price that is equal to or higher than the bid price and for up to the displayed size.",
       "choice_d":"An immediately executable order to sell has a limit price that is equal to or higher than the bid price and for up to the displayed size.",
       "correct_answer":"A",
       "explanation":"An immediately executable order must have a limit price that is equal to the best price in the market and the order may only be for up to the number of shares displayed. An immediately executable order to buy has a limit price that is equal to or higher than the ask price and for up to the displayed size."
    },
    {
       "id":32706,
       "practice_test_id":6,
       "topic_id":8,
       "question":"An investor would expect to realize the largest capital gain by buying bonds:",
       "choice_a":"That are short term when rates are low",
       "choice_b":"That are long term when rates are high",
       "choice_c":"That are long term when rates are low",
       "choice_d":"That are short term when rates are high",
       "correct_answer":"B",
       "explanation":"An investor would expect to realize the largest gain by purchasing bonds when rates are high. The bond with the longest time left to maturity will become worth the most."
    },
    {
       "id":32707,
       "practice_test_id":6,
       "topic_id":8,
       "question":"As interest rates change, the rates on which of the following will change the most?",
       "choice_a":"Preferred stock",
       "choice_b":"Long term corporate debt",
       "choice_c":"Intermediate term corporate debt",
       "choice_d":"T Bills",
       "correct_answer":"D",
       "explanation":"Interest rates on short-term instruments change more quickly than rates on longer-term instruments. The T\u0027 Bill is the shortest term debt instrument in the question and in general the rates on T\u0027 Bills are more sensitive to a change in market rates."
    },
    {
       "id":32673,
       "practice_test_id":6,
       "topic_id":1,
       "question":"A registered representative who has managed the account for an elderly client for more than 15 years receives a call from the client. During the call the client seems nervous and states that he needs $15,000 sent to a collection company who has contacted him about an unpaid debt. When the registered representative inquires as to the nature of the debt, the client seems to become confused. Which of the following is correct?",
       "choice_a":"The firm should send the money and investigate the matter within 15 days",
       "choice_b":"The firm should send the money and investigate the matter within 10 days",
       "choice_c":"The firm should withhold sending the money for 15 days while it investigates the matter",
       "choice_d":"The firm should withhold sending the money for 10 days while it investigates the matter",
       "correct_answer":"C",
       "explanation":"The question details an event that could clearly be a case of an elderly person being exploited by bad actors. In these situations FINRA allows broker dealers to withhold sending the money for 15 days to ensure that the client is not being taken advantage of."
    },
    {
       "id":32720,
       "practice_test_id":6,
       "topic_id":1,
       "question":"Which of the following accounts would be owned and operated for the benefit of a minor? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A 529 prepaid tuition plan </li><li>A UGMA  </li><li>A 529 college savings plan </li><li>An educational IRA</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I, II and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"The key to this question is determining which accounts are deemed to be property of the minor. A 529 plan is deemed to be property of the person who put the assets in the account. The UGMA and the Educational IRA are property of the minor."
    },
    {
       "id":32719,
       "practice_test_id":6,
       "topic_id":1,
       "question":"An investor purchased 500 shares of ABC common stock at $12 per share 2 years ago. He is looking to sell his shares at the current market price of $14. If ABC has paid a 10 cent dividend for each of the quarters the investor has owned the stock, what is his approximate total return?",
       "choice_a":"23.3 percent",
       "choice_b":"16.6 percent",
       "choice_c":"14.3 percent",
       "choice_d":"20 percent",
       "correct_answer":"A",
       "explanation":"The investor purchased the stock at $12 and sold it at $14, making a $2 profit. The investor also received a 10 cent dividend during each of the 8 quarters the investor owned the stock. Therefore the investor received 80 cents in dividends in addition to his $2 capital gain. $2.80 / $12 = 23.33, rounded to 23.3 percent"
    },
    {
       "id":32718,
       "practice_test_id":6,
       "topic_id":11,
       "question":"Which of the following issues would be most likely to trade and quoted in basis points?",
       "choice_a":"A Treasury bond",
       "choice_b":"A municipal revenue bond",
       "choice_c":"A Treasury bill",
       "choice_d":"A convertible bond with a call provision",
       "correct_answer":"C",
       "explanation":"Of the choices listed only the Treasury bill would be quoted and traded in basis points. A basis point is equal to .01 percent."
    },
    {
       "id":32721,
       "practice_test_id":6,
       "topic_id":9,
       "question":"An individual who needs to access the assets in their IRA to help with the down payment withdraws $7,000. The investor is 48 years old and has been contributing to the IRA for more than 20 years. Which of the following is correct?",
       "choice_a":"The individual may use the money for up to 60 days without penalty",
       "choice_b":"The individual may use the money for up to 45 days without penalty",
       "choice_c":"The individual may use the money for up to 30 days without penalty",
       "choice_d":"The individual will be required to pay the taxes on the money and any related penalty at the time the money is withdrawn",
       "correct_answer":"A",
       "explanation":"An individual who wished to access money in an IRA may do so without penalty for 60 days. This portion of the assets must be deposited or rolled over into another qualified account within the 60 day time frame. If the assets are not rolled over into another account the individual will pay income taxes on the money and if the person is under the age of 59.5 the money will be subject to a 10% penalty tax."
    },
    {
       "id":32722,
       "practice_test_id":6,
       "topic_id":1,
       "question":"In a cash account registered as JTWROS a customer purchased $23,000 worth of securities. Two days later the customer sent in a payment for $15,000 worth of the securities and sends no more payments. Which of the following is correct?",
       "choice_a":"The firm will sell $23,000 worth of stock and freeze the account for 90 days",
       "choice_b":"The firm will sell $23,000 worth of stock and freeze the account for 60 days",
       "choice_c":"The firm will sell $8,000 worth of stock and freeze the account for 90 days",
       "choice_d":"The firm will sell $8,000 worth of stock and freeze the account for 60 days",
       "correct_answer":"C",
       "explanation":"The customer did not pay completely for the securities purchased. The firm will therefore sell out the portion of the securities the customer failed to pay for in case $8,000 worth. The firm will then freeze the account for 90 days."
    },
    {
       "id":32704,
       "practice_test_id":6,
       "topic_id":4,
       "question":"The subscription price of a warrant is always:",
       "choice_a":"Below the stock price when issued",
       "choice_b":"Equal to the stock price when issued",
       "choice_c":"Above the stock price when issued",
       "choice_d":"Determined on the exercise date",
       "correct_answer":"C",
       "explanation":"The subscription price of a warrant is always above the market value of the stock when it\u0027s originally issued. The value of the warrant is that it is long term up to 10 years."
    }
  ]